/**
 * クラス名：マイン見積
 * 説明：親部品見積・子部品見積纏めJSファイルや共通操作ファイルである。
 * 作成者：ナンス
 * 作成日：2023/03/01
 * バージョン：1.0
 */
import {
  Form,
  Button,
  Row,
  Input,
  Col,
  Modal,
  Image,
  Tooltip,
  Space,
  Tabs,
  Menu,
  Checkbox,
  Steps,
  Select,
  Empty,
  Spin,
  Table,
  Typography,
  Upload,
  Popconfirm,
} from 'antd';
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react';
import { CloseOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Table as RTable } from 'react-bootstrap';
import lodash from 'lodash';
import JSZip from 'jszip'; // 2025-05-21 親部品をデータとして保存することはできません
import * as signalR from '@microsoft/signalr';

import '../../assets/styles/common.css';
import close from '../../assets/images/close.png';
import save from '../../assets/images/save.png';
import pc_save from '../../assets/images/pc_save.png';
import pmx_import from '../../assets/images/pmx_import.png';
import dxf_import from '../../assets/images/dxf.png';
import logo from '../../assets/images/logo.ico';
import export_report from '../../assets/images/export_report.png';
import edit_info from '../../assets/images/edit_info.png';
import download_to_pc from '../../assets/images/downloadToPC.png'; // 2025-05-21 親部品をデータとして保存することはできません
import upload_from_pc from '../../assets/images/uploadFromPC.png'; // 2025-05-21 親部品をデータとして保存することはできません
import IQ3Estimate from '../iq3/IQ3Estimate';
import ParentEstimate from '../parent/ParentEstimate';
import EstimateBasicInfo from '../parent/EstimateBasicInfo';
import ParentKouteiSentaku from '../parent/ParentKouteiSentaku';
import IQ3KouteiSentaku from '../iq3/IQ3KouteiSentaku';
import IQ5KouteiSentaku from '../iq5/IQ5KouteiSentaku.js';
import {
  formatDateString,
  todayTime,
  updateEstimateInfoByReCal,
  convertServerExcelToHtml,
  formatPMXDate,
  toDecimal,
  getInitParamUpdateFlgInfos,
  getNameByValue,
  getMaterialNameById,
  getMaterialTypeById,
  getMaterialSurfaceById,
  getMaterialThickById,
  JPYs,
  patternPage,
  iq3EstimateInitInfo,
  padWithLeadingZeros,
  toHalfWidth,
  regexExp,
  isDigit,
  handleKeyPress,
  today,
  isDigitZenkaku,
  compareParentInfo,
  toDecimal_place3,
  blobToBase64,
  getAccessToken,
  initAdditionalItemCost,
  initAdditionalItemLabel,
  initAdditionalItemMemo,
  initAdditionalItemDate,
  getDetails,
  getInitMaterialSizeInfo,
  getInitMaterialPatternsInfo,
  getProcessRecord,
  estimateInitInfo,
  generateTimestamp,
  getFileExtension,
  getDefaultJellDOptions,
  getRequestHeader,
  getSteelMaterialClassList,
  getCommonProcessMstData,
} from '../common/Common';
import {
  commonTaiochuModal,
  confirmScreenChangeContent,
  confirmScreenChangeTitle,
  commonModal,
  commonFooter,
  confirmDisplayDataSaveContent,
  confirmOverwriteSaveContent,
  confirmSaveContent,
  confirmDiscardContent,
  confirmScreenChangeWarning,
  confirmContent,
  dataConfirmOK,
  sameDrawingNoContent,
  commonActionFooter,
  confirmUpdateContent,
  complete,
  noCheckMsgModalContent,
  noCheckMsgModalTitle,
  error,
} from '../common/CommonModal';
import confirm_icon from '../../assets/images/confirm_icon.png';
import {
  createEstimateProductInfo,
  getEstimateIq3Info,
  getExcelDatabyUseType,
  updateEstimateProductInfo,
  getCardInfo,
  getCardDetailImg,
  GetParametersByCompId,
  getIsExistSameEstimate,
  updateUserSetting,
  getExistCompanySetting,
  getExistUserSetting,
  getEstimateIq5Info,
  getSetting,
  getImageURL,
} from '../common/CommonAPI';
import export_csv_icon from '../../assets/images/export_csv_icon.png';
import PMX_CloudFileDialog_Tab_Parent from './PMX_CloudFileDialog_Tab_Parent';
import parent_call_detail from '../../assets/images/parent_call_detail.png';
import ParentList from '../parent/ParentList';
import {
  WorkType,
  ServiceClass,
  PrintTypes,
  CreatePMXData,
  WorkTypeGroup,
  ParamCalType,
  EstimateCreationType,
  DataType,
  SurfaceProtectionType,
  ClientType,
  dxfTypes,
} from './enums';
import {
  BendingTypes,
  BlankTypes,
  FRBend,
  SecondaryWorkTypes,
  SubWeldTypes,
  Types,
  amtEmptyStr,
  byQuantities,
  saveSameTypes,
  dataTypeList,
  AllowedExtensionsDxf,
  ParentClassNumber,
  IQ3ClassNumber,
  WeldFinish_IQ5ManufactSizeKind,
  Bend_IQ5ManufactSizeKind,
  IQ5ClassNumber,
  Hole_IQ5ManufactSizeKind,
} from './Constant';
import new_icon from '../../assets/images/new_icon.png';
import curt from '../../assets/images/curt.png';
import child_add from '../../assets/images/child_add.png';
import child_delete from '../../assets/images/child_delete.png';
import ProcessPatternForm from '../parameter/parent/processPattern/ProcessPatternForm';
import IQ5Estimate from '../iq5/IQ5Estimate';
import manual from '../../assets/images/manual.png';
import auto from '../../assets/images/auto.png';
import { PNG, STEEL_SHAPE_URL } from '../common/Constant.js';
import SteelMaterialList from '../parameter/iq5/steelMaterial/SteelMaterialList.js';
import Draggable from 'react-draggable';
import axios from 'axios';
import { iq5EstimateInitInfo } from './CommonIQ5.js';
import warning from 'antd/es/_util/warning.js';

dayjs.extend(customParseFormat);
const iconWidth = 32;

const MainEstimate = React.forwardRef((props, ref) => {
  const [activePartMenu, setActivePartMenu] = useState('1');
  // PMX工程選択ダイアログ表示
  const [isPMXProcessPatternOpen, setIsPMXProcessPatternOpen] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [selectedEstimateData, setSelectedEstimateData] = useState([]);
  const [selectedEstimateDataTemp, setSelectedEstimateDataTemp] = useState([]);
  const [selectediq3Data, setSelectediq3Data] = useState([]);
  const [selectediq5Data, setSelectediq5Data] = useState([]);
  const [confirmScreenChangeModalOpen, setConfirmScreenChangeModalOpen] = useState(false);
  const [confirmDisplayDataSaveModalOpen, setConfirmDisplayDataSaveModalOpen] = useState(false);
  // 開発中ポップアップ
  const [openCommonTaiochuPopup, setOpenCommonTaiochuPopup] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [clickPMX, setClickPMX] = useState(false);
  const [clickMenu, setClickMenu] = useState(''); //親部品、板金のタブイベントか判断するため、空白を初期設定
  // 帳票出力
  const [isReportOutputOpen, setIsReportOutputOpen] = useState(false);
  const [isListOutputOpen, setIsListOutputOpen] = useState(false);
  const [childTitle, setChildTitle] = useState('');
  // pc保存
  const [isEstimateDataSaveConfirm, setIsEstimateDataSaveConfirm] = useState(false);
  const [isLoadPMXProcess, setIsLoadPMXProcess] = useState(false);
  const [isCreatePMX, setIsCreatePMX] = useState();
  const [currentStep, setCurrentStep] = useState(0);
  const [pmxProcessType, setPmxProcessType] = useState('');
  const [patternList, setPatternList] = useState([]);
  const [parentPatternNo, setParentPatternNo] = useState(1);
  const [childPatternNo, setChildPatternNo] = useState(1);
  const [childIQ5PatternNo, setChildIQ5PatternNo] = useState(1);
  const [currentPMXMenu, setCurrentPMXMenu] = useState(null);
  const [iq3PatternList, setIQ3PatternList] = useState([]);
  const [iq5PatternList, setIQ5PatternList] = useState([]);
  const [pmxTabKey, setPMXTabKey] = useState('1');
  const [isPMXCloudFileDialogOpen, setIsPMXCloudFileDialogOpen] = useState(false);
  const [parentListDisplay, setParentListDisplay] = useState(false);
  const [selectedParentAddEstimate, setSelectedParentAddEstimate] = useState([]);
  const [checkPMXOrNot, setCheckPMXOrNot] = useState(false);
  const [isSteelMaterialListModalVisible, setIsSteelMaterialListModalVisible] = useState(false);
  const [selectedSteelSelect, setSelectedSteelSelect] = useState({});
  const [selectedSteelClassList, setSelectedSteelClassList] = useState({});
  const [selectedSteelTypeList, setSelectedSteelTypeList] = useState({});
  const [steelMaterialId, setSteelMaterialId] = useState(null);
  const [steelMaterialName, setSteelMaterialName] = useState('');
  const [sizeForBulkEdit, setSizeForBulkEdit] = useState(0);
  const [partCountForBulkEdit, setPartCountForBulkEdit] = useState(0);
  const [estimateBasicInfoChangedFlg, setEstimateBaseInfoChangedFlg] = useState(false);

  // 2025-06-02 ヘッダーの設定画面だと「CURT.パラ更新」でチェックボックスをいじれるが、
  // CURTボタンでもチェックボックスをいじれるようにしてほしい
  const [updateUserCURTSetting, setUpdateUserCURTSetting] = useState();

  // 別名保存・上書き保存
  const saveMenuChildItems = [
    { key: 'otherNmSave', label: '別名保存' },
    { key: 'overwrite', label: '上書き保存' },
  ];
  // iq3Data確認
  const [iq3DataConfirm, setIq3DataConfirm] = useState(false);
  // 新規保存
  const [createConfirm, setCreateConfirm] = useState(false);
  // 破棄
  const [discardConfirm, setDiscardConfirm] = useState(false);
  const [selectedSaveMenuKey, setSelectedSaveMenuKey] = useState('');
  // 別名保存の入力項目
  const [estimateNo, setEstimateNo] = useState('');
  const [inputDrawingNo, setInputDrawingNo] = useState('');
  const [parentEstimateName, setParentEstimateName] = useState('');
  const [isSaveByOtherName, setIsSaveByOtherName] = useState(false);
  // 上書き保存
  const [isSaveByOverwrite, setIsSaveByOverwrite] = useState(false);
  const [saveDiscardConfirmPopup, setSaveDiscardConfirmPopup] = useState(false);
  const [navigateTabName, setNavigateTabName] = useState('');
  const [yobidashiClk, setYobidashiClk] = useState(false);
  const [calClk, setCalClk] = useState(false);
  const [saveClk, setSaveClk] = useState(false);
  const [pcInClk, setPcInClk] = useState(false);
  const [pcOutClk, setPcOutClk] = useState(false);
  const [reportClk, setReportClk] = useState(false);
  const [csvClk, setCsvClk] = useState(false);
  const [pmxSelectedEstimateData, setPMXSelectedEstimateData] = useState([]);
  //帳票出力
  const [excelIndividualFormats, setExcelIndividualFormats] = useState([]);
  const [selectedExeclIndividualFormat, setSelectedExeclIndividualFormat] = useState();
  // PMX取り込み
  const [selectedPMXEstimateData, setSelectedPMXEstimateData] = useState([]);
  const [selectedCardData, setSelectedCardData] = useState([]);
  // カード情報
  const [cardInfo, setCardInfo] = useState([]);
  // カード情報
  const [cardInfoCount, setCardInfoCount] = useState(0);
  // 新パラメータ情報
  const [newParameters, setNewParameters] = useState();
  // Waitingダイアログの表示
  const [parentLoading, setParentLoading] = useState(true);
  // パネル更新フラグ
  const [basicInfoUpdate, setBasicInfoUpdate] = useState(false);
  // チェック板金
  const [noIq3, setNoIq3] = useState(false);
  // 同一図番で保存
  const [isSaveSameDrawingNo, setIsSaveSameDrawingNo] = useState(false);
  const [saveSameDrawingNoFncName, setSaveSameDrawingNoFncName] = useState('');
  // パラメータ更新モデル
  const [isCurtParam, setIsCurtParam] = useState(false);
  // パラメータ更新フラグ情報
  const [paramUpdateFlgInfos, setParamUpdateFlgInfos] = useState();
  // 更新確認メッセージ
  const [updateConfirm, setUpdateConfirm] = useState(false);
  // CURT.パラ更新項目チェックなしのメッセージ表示
  const [noCheckMsg, setNoCheckMsg] = useState(false);
  // まとめて編集
  const [isUpdate, setIsUpdate] = useState(false);
  const [isUpdateSteel, setIsUpdateSteel] = useState(false);
  const [chkrowscount, setChkRowsCount] = useState(0);
  const [bulkEditSelectedRow, setBulkEditSelectedRow] = useState([]);
  const [bulkEditSelectedRowId, setBulkEditSelectedRowId] = useState([]);
  const [bulkIQ3DataLst, setBulkIQ3DataLst] = useState([]);
  const [bulkIQ5DataLst, setBulkIQ5DataLst] = useState([]);
  const [activeBulkEditTabKey, setActiveBulkEditTabKey] = useState([]);
  const [isAllEdit, setIsAllEdit] = useState(true);
  const [partCount, setPartCount] = useState('');
  const [materialTypeId, setMaterialTypeId] = useState('');
  const [thickness, setThickness] = useState('');
  const [materialSurfaceId, setMaterialSurfaceId] = useState([]);
  const [listData, setListData] = useState([]);
  const [processSelectedData, setProcessSelectedData] = useState({});
  const [processSelectedDataUpdate, setProcessSelectedDataUpdate] = useState(false);
  const [parentInfoChangeFlg, setParentInfoChangeFlg] = useState(false);
  const [parentQuantityChangeFlg, setParentQuantityChangeFlg] = useState(false);
  const [isProcessSelectInfo, setIsProcessSelectInfo] = useState(false);
  const [isPrepareInfo, setIsPrepareInfo] = useState(false);
  const [isPMXEvent, setIsPMXEvent] = useState(false);
  const [isAllUpdateOK, setIsAllUpdateOK] = useState(false);

  // DXF
  const [currentDXFStep, setCurrentDXFStep] = useState(0);
  const [isDXFNext, setIsDXFNext] = useState(false);
  const [isDXFNextIQ3, setIsDXFNextIQ3] = useState(false);
  const [isDXFProcessPatternOpen, setIsDXFProcessPatternOpen] = useState(false);
  const [isDXFFileUpload, setIsDXFFileUpload] = useState(false);
  const dxfFileRef = React.useRef(null);
  const [displayDxfType, setDisplayDxfType] = useState(false);
  const [dxfUpDataLst, setDxfUpDataLst] = useState([]);
  const [settingInfo, setSettingInfo] = useState({});
  const [isDXFPrepareInfo, setIsDXFPrepareInfo] = useState(false);
  const [dxfCompanySetting, setDXFCompanySetting] = useState([]);
  const [dxfParentPatternNo, setDXFParentPatternNo] = useState(null);
  const [dxfChildPatternNo, setDXFChildPatternNo] = useState(null);
  const [dxfCalculateLoading, setDXFCalculateLoading] = useState(false);

  // 2025-09-19 IQX_WEBEST-470 表面処理費が表示されないバグ
  const [pmxRead, setPmxRead] = useState(false);

  // 表面処理
  const [isHyoumenSelect, setIsHyoumenSelect] = useState(false);

  useEffect(() => {
    // 設定情報取得
    getSettingInfo();
  }, []);

  const getSettingInfo = async () => {
    const settingResponse = await getExistCompanySetting();
    if (settingResponse && Object.keys(settingResponse)?.length > 0) {
      setSettingInfo(settingResponse);
    }
  };

  const handleBeforeUpload = (file) => {
    setDxfUpDataLst((prev) => [...prev, file]);
    return false; // prevent auto upload
  };

  // Dxfタイブ画面のOK
  const onDxfOK = () => {
    setDisplayDxfType(false);
    handleFileUpload(dxfUpDataLst, true);
  };

  // Dxfタイブ画面の閉じる
  const onDxfCancel = () => {
    setDisplayDxfType(false);
  };

  const dxfTypecolumns = [
    {
      key: 'id',
      title: 'No',
      width: 30,
      render: (_, __, index) => <div style={{ textAlign: 'center' }}>{index + 1}</div>,
    },
    {
      key: 'dxfNm',
      title: 'ファイル名',
      width: 100,
      render: (_, record) => (
        <div style={{ marginLeft: 20 }}>
          <Typography.Text className="history-tb-label" id={'typographyTxt'} ellipsis={{ tooltip: [record.name] }}>
            {record.name}
          </Typography.Text>
        </div>
      ),
    },
    {
      key: 'dxfType',
      title: 'DXFタイブ',
      width: 100,
      render: (_, record, index) => (
        <div style={{ marginLeft: 20 }}>
          <Select
            popupMatchSelectWidth={false}
            defaultValue={0}
            id={'dxfType' + record?.id}
            name={'dxfType' + record?.id}
            value={
              dxfTypes?.some((opt) => opt.id === record?.dxfType)
                ? record?.dxfType
                : dxfTypes?.length > 0
                ? dxfCompanySetting?.[0]?.dxfTypeCode
                : ''
            }
            onChange={(e) => {
              const upDxfDataLst = [...dxfUpDataLst];
              if (upDxfDataLst && upDxfDataLst?.length > 0) {
                upDxfDataLst[index].dxfType = e;
                setDxfUpDataLst(upDxfDataLst);
              }
            }}
          >
            {dxfTypes?.map((item, index) => (
              <Select.Option key={index + 'dxfType'} id={'dxfType' + index} value={item.id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      ),
    },
    {
      key: 'action',
      title: '削除',
      width: 60,
      render: (_, record, index) => (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Popconfirm
            title="削除してもよろしいですか？"
            onConfirm={() => {
              const updated = dxfUpDataLst.filter((_, i) => i !== index);
              setDxfUpDataLst(updated);
            }}
            okText="はい"
            cancelText="いいえ"
          >
            <Button danger type="text" icon={<DeleteOutlined />} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  // const dxfTitle = (
  //   <div
  //     style={{
  //       background: '#001529',
  //       color: 'white',
  //       fontSize: '14px',
  //       borderTopLeftRadius: '8px',
  //       borderTopRightRadius: '8px',
  //       display: 'flex',
  //       justifyContent: 'left', // Center the title horizontally
  //       alignItems: 'center', // Center the title vertically
  //       height: 35,
  //       marginLeft: -24,
  //       marginTop: -20,
  //       marginRight: -24,
  //     }}
  //   >
  //     <p style={{ marginLeft: 10 }}>DXFファイル一覧</p>
  //   </div>
  // );

  const navigate = useNavigate();
  const location = useLocation();

  // file dialog
  const inputFile = useRef();
  const iQ3EstimateRef = useRef();
  const parentEstimateRef = useRef();
  const estimateBasicInfoRef = useRef();
  const inputFile_pcInput = useRef(null);
  const inputFile_pcOutput = useRef(null);
  const pmxCloudParentRef = useRef();
  const iQ3KouteiSentakuRef = useRef();
  const parentKouteiSentakuRef = useRef();
  const iQ5EstimateRef = useRef();
  const iQ5KouteiSentakuRef = useRef();

  const filterOption = (input, option) => option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
  const estimateParameters = props.selectedEstimateData?.estimateProducts?.calcParameters?.parameters;

  // 材料名称リスト
  const materialLst = estimateParameters?.materialIq3?.filter((i) => i?.info?.isUsed);

  // 材質名称リスト
  const materialTypeLst = estimateParameters?.materialTypeIq3?.filter((i) => i?.info?.isUsed);

  // 材料表面保護
  const materialSurfaceLst = estimateParameters?.materialSurfaceIq3?.filter((i) => i?.info?.isUsed);

  const patternformRef = useRef();

  // 2025-05-21 親部品をデータとして保存することはできません
  const upload3DFileRef = React.useRef(null);

  const [uploadLoading, setUploadLoading] = useState(false);

  const iq3Columns = [
    {
      id: '1',
      title: 'No.',
      dataIndex: 'no',
      className: 'cm-a-right',
      width: 50 + 'px',
      // render: (value, array, index) => index + 1,
    },
    {
      id: '2',
      title: '採用',
      dataIndex: 'creationType',
      width: 60 + 'px',
      align: 'center',
      render: (value) => (value === EstimateCreationType.Auto ? '自動' : '手動'),
    },
    {
      id: '3',
      title: '画像',
      dataIndex: 'imageUrl',
      width: 140 + 'px',
      align: 'center',
      render: (value) => (
        <img src={value} alt="" className={value === undefined || value === '' ? 'pmx-no-img' : 'pmx-img'} />
      ), // IQX_WEBEST-247
    },
    {
      id: '4',
      title: ['工程パターン', <br />, '子部品図番', <br />, '子部品名称'],
      dataIndex: 'processSelect',
      width: 220 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'left' }}>
          <label style={{ fontSize: '13px' }}>{record?.processSelect?.name}</label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 2 }}>{record.drawingNo}</label>
          {/* <Input style={{ width: '260px', height: '22px', fontSize: '13px', marginTop: 2 }} value={record.imgNo} /> */}
          <br />
          <label style={{ fontSize: '13px', marginTop: 2 }}>{record.name}</label>
          {/* <Input style={{ width: '260px', height: '22px', fontSize: '13px', marginTop: 3 }} value={record.partNm} /> */}
          <br />
        </div>
      ),
    },
    {
      id: '5',
      title: '員数(製造数)',
      dataIndex: 'partCount',
      width: 80 + 'px',
      align: 'center',
      render: (partCount) =>
        partCount + '(' + partCount * props?.selectedEstimateData?.estimateProducts?.quantity + ')',
    },
    {
      id: '6',
      title: ['材質', <br />, '材料', <br />, '板厚', <br />, '表面保護'],
      dataIndex: 'materialItems',
      width: 150 + 'px',
      align: 'center',
      render: (_, record) =>
        estimateParameters ? (
          <div style={{ textAlign: 'left' }}>
            <label style={{ fontSize: '13px', marginTop: 2 }}>
              {getMaterialTypeById(record.materialTypeIq3Id, estimateParameters?.materialTypeIq3)}
            </label>
            <br />
            <label style={{ fontSize: '13px' }}>
              {getMaterialNameById(record.materialIq3Id, estimateParameters?.materialIq3)}
            </label>
            <br />
            <label style={{ fontSize: '13px', marginTop: 2 }}>
              {getMaterialThickById(record.thickness, estimateParameters?.materialIq3)}
            </label>
            <br />
            <label style={{ fontSize: '13px', marginTop: 2 }}>
              {getMaterialSurfaceById(record.materialSurfaceIq3Id, estimateParameters?.materialSurfaceIq3)}
            </label>
          </div>
        ) : (
          <></>
        ),
    },
    {
      id: '7',
      title: ['重量', <br />, '表面積', <br />, '表面処理費'],
      dataIndex: 'amountItems',
      width: 100 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.weight ? toDecimal(record.weight, 2) : toDecimal(0, 2)}
            kg
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.totalSurfaceArea != undefined ? toDecimal(record.totalSurfaceArea, 2) : toDecimal(0, 2)}
            cm<sup>2</sup>
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.surfaceTotalPrice ? JPYs.format(Math.round(record.surfaceTotalPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
    {
      id: '8',
      title: ['材料原価', <br />, '製造原価', <br />, '購入品費'],
      dataIndex: 'costItems',
      width: 110 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.materialCostUnitPrice ? JPYs.format(Math.round(record.materialCostUnitPrice)) : amtEmptyStr}
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.workCostUnitPrice ? JPYs.format(Math.round(record.workCostUnitPrice)) : amtEmptyStr}
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.purchaseUnitPrice ? JPYs.format(Math.round(record.purchaseUnitPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
    {
      id: '9',
      title: '原価',
      dataIndex: 'costUnitPrice',
      width: 110 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.costUnitPrice ? JPYs.format(Math.round(record.costUnitPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
    {
      id: '10',
      title: '原価合計',
      dataIndex: 'costTotalPrice',
      width: 110 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.costTotalPrice ? JPYs.format(Math.round(record.costTotalPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
  ];

  const showSteelMaterial = () => {
    setIsSteelMaterialListModalVisible(true);
  };

  const detail_ProcessSelect_ModalTitle = (
    <div
      style={{
        width: 1200,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{'工程選択'}</p>
    </div>
  );

  const steelDetailDialogCancel = () => {
    setIsSteelMaterialListModalVisible(false);
  };

  const updateSteelSelect = (record, classList, TypeList) => {
    setSelectedSteelSelect(record);
    setSelectedSteelClassList(classList);
    setSelectedSteelTypeList(TypeList);
  };

  //
  const steelDetailDialogOk = () => {
    setSteelMaterialName(selectedSteelSelect ? selectedSteelSelect.name : '');
    setIsSteelMaterialListModalVisible(false);
  };

  useEffect(() => {
    // props?.updateSelectedEstimateDataIQ5info(selectedEstimateData);
    // This effect will run whenever `selectedEstimateData` changes
    // console.log("selectedEstimateData updated:", selectedEstimateData);
    // iQ5EstimateRef?.current?.updateiq5ActionForCal(true);
    // You can add any actions you want to happen immediately after update here
  }, [selectedEstimateData]);

  const iq5Columns = [
    {
      id: '1',
      title: 'No.',
      dataIndex: 'no',
      className: 'cm-a-right',
      width: 50 + 'px',
    },
    {
      id: '2',
      title: '状態',
      dataIndex: 'creationType',
      width: 80 + 'px',
      align: 'center',
      render: (value, record, index) => {
        const isAuto = record.additions[0]?.dataType === 0;
        return isAuto ? (
          <Image src={auto} alt="Auto" width={31} preview={false} />
        ) : (
          <Image src={manual} alt="Manual" width={31} preview={false} />
        );
      },
    },
    {
      id: '3',
      title: '画像',
      dataIndex: 'imageId',
      width: 120 + 'px',
      align: 'center',
      render: (value) => (
        <img
          className={value === undefined || value === '' ? 'pmx-no-img' : 'steel-shape-img'}
          src={STEEL_SHAPE_URL + value + PNG}
          alt=""
        />
      ),
    },
    {
      id: '4',
      title: ['工程パターン', ' / ', '子部品図番', ' / ', '子部品名称'],
      dataIndex: 'drawingNoName',
      width: 280 + 'px',
      align: 'center',
      render: (_, record, index) => (
        <div style={{ textAlign: 'left' }}>
          <label style={{ fontSize: '13px' }}>{record?.processSelect?.name}</label>
          <br />
          <Input
            disabled
            style={{
              fontSize: '13px',
              height: 25,
              padding: 3,
              borderColor: '#a5a5a563',
              borderRadius: 4,
              marginTop: 8,
            }}
            className="input-editable"
            name="drawingNo"
            value={record.drawingNo}
          />
          <br />
          <Input
            disabled
            style={{
              fontSize: '13px',
              height: 25,
              padding: 3,
              borderColor: '#a5a5a563',
              borderRadius: 4,
              marginTop: 8,
            }}
            className="input-editable"
            name="name"
            value={record.name}
          />
          <br />
        </div>
      ),
    },
    {
      id: '5',
      title: ['鋼材', ' / ', '材料', ' / ', '材質'],
      dataIndex: 'materialItems',
      width: 200 + 'px',
      align: 'center',
      render: (_, record) =>
        estimateParameters ? (
          <div style={{ textAlign: 'left' }}>
            <label style={{ fontSize: '13px' }}>{record.steelShapeName}</label>
            <br />
            <label style={{ fontSize: '13px', marginTop: 8 }}>{record.materialName}</label>
            <Row>
              <Col span={18}>
                <label style={{ fontSize: '13px', marginTop: 8 }}>{record.materialTypeName}</label>
              </Col>
            </Row>
          </div>
        ) : (
          <></>
        ),
    },
    {
      id: '6',
      title: ['寸法', ' / ', '員数'],
      dataIndex: 'partCount',
      width: 150 + 'px',
      align: 'center',
      render: (_, record, index) => (
        <div style={{ textAlign: 'center' }}>
          <Input
            disabled
            style={{
              textAlign: 'left',
              width: 100,
              fontSize: '13px',
              height: 25,
              padding: 3,
              borderColor: '#a5a5a563',
              borderRadius: 4,
            }}
            className="input-editable"
            name="size"
            value={record.size}
          />
          <br />
          <Input
            disabled
            style={{
              textAlign: 'left',
              width: 100,
              fontSize: '13px',
              height: 25,
              padding: 3,
              borderColor: '#a5a5a563',
              borderRadius: 4,
              marginTop: 8,
            }}
            className="input-editable"
            name="partCount"
            value={record.partCount}
          />
        </div>
      ),
    },
    {
      id: '7',
      title: ['重量', ' / ', '面積'],
      dataIndex: 'amountItems',
      width: 150 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.weight ? toDecimal_place3(record.weight, 3) : toDecimal_place3(0, 3)}
            kg
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 10 }}>
            {record.totalSurfaceArea != undefined ? Math.round(record.totalSurfaceArea) : 0.0}
            cm<sup>2</sup>
          </label>
        </div>
      ),
    },
    {
      id: '8',
      title: ['材料', ' / ', '製造', ' / ', '購入品'],
      dataIndex: 'amountItems',
      width: 200 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.materialCostUnitPrice ? JPYs.format(Math.round(record.materialCostUnitPrice)) : amtEmptyStr}
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.workCostUnitPrice ? JPYs.format(Math.round(record.workCostUnitPrice)) : amtEmptyStr}
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.purchaseUnitPrice ? JPYs.format(Math.round(record.purchaseUnitPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
    {
      id: '9',
      title: '原価',
      dataIndex: 'costUnitPrice',
      width: 200 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.costUnitPrice ? JPYs.format(Math.round(record.costUnitPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
    {
      id: '10',
      title: '原価合計',
      dataIndex: 'costTotalPrice',
      width: 200 + 'px',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.costTotalPrice ? JPYs.format(Math.round(record.costTotalPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
  ];

  useEffect(() => {
    // 親部品のページリロードの場合、初期値の再設定（IQX_WEBEST-79）
    if (props.selectedEstimateData?.estimateProducts === undefined && location?.pathname === '/home/:estimate.parent') {
      props?.navigatePage('', ':estimate.parent', 'parent');
      setActivePartMenu('1');
      props?.updateActiveTabKey('1');
    } else if (
      props.selectedEstimateData?.estimateProducts === undefined &&
      location?.pathname === '/home/:estimate.iq3'
    ) {
      props?.navigatePage('', ':estimate.iq3', 'iq3');
      setActivePartMenu('2');
      props?.updateActiveTabKey('2');
    } else if (
      props.selectedEstimateData?.estimateProducts === undefined &&
      location?.pathname === '/home/:estimate.iq5'
    ) {
      props?.navigatePage('', ':estimate.iq5', 'iq5');
      setActivePartMenu('2');
      props?.updateActiveTabKey('2');
    } else {
      if (
        location?.pathname === '/home/:estimate.iq3' ||
        location?.pathname === '/home/:estimate.parent' ||
        location?.pathname === '/home/:estimate.iq5'
      ) {
        // 2025-07-02 IQX_WEBEST-436 工程パターンが変更されない
        if (activePartMenu === '1') {
          navigate(':estimate.parent');
        } else if (activePartMenu === '2') {
          navigate(':estimate.iq3');
        } else if (activePartMenu === '3') {
          navigate(':estimate.iq5');
        }
        props?.loading(false); // Waitingダイアログを非表示にする
      }
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      location.pathname === '/home/:estimate.parent' ||
      location.pathname === '/home/:estimate.iq3' ||
      location.pathname === '/home/:estimate.iq5'
    ) {
      //破棄用見積情報保持
      if (selectedEstimateDataTemp?.estimateProducts === undefined || props.createNew) {
        if (props.selectedEstimateData !== undefined) {
          setSelectedEstimateDataTemp(JSON.parse(JSON.stringify(props.selectedEstimateData)));
          props.updateTempEstimateData(props.selectedEstimateData);
        }
      }
      // if (
      //   (location?.pathname === '/home/:estimate.iq3' || location?.pathname === '/home/:estimate.parent') &&
      //   !isPMXEvent
      // ) {
      //   props?.loading(false); // Waitingダイアログを非表示にする
      // }
    }
  }, [props.selectedEstimateData, props.createNew]);

  useEffect(() => {
    if (
      location.pathname === '/home/:estimate.parent' ||
      location.pathname === '/home/:estimate.iq3' ||
      location.pathname === '/home/:estimate.iq5'
    ) {
      let partMenu = props.activeTab ? props.activeTab : '1';
      setActivePartMenu(partMenu); // （IQX_WEBEST-79）
      props?.updateActiveTabKey(partMenu);
      // 2025-07-02 IQX_WEBEST-436 工程パターンが変更されない
      if (partMenu === '2') {
        navigate(':estimate.iq3');
      } else if (partMenu === '3') {
        navigate(':estimate.iq5');
      } else {
        navigate(':estimate.parent');
      }
      if (location.pathname === '/home/:estimate.iq3') {
        setActivePartMenu('2');
        props?.updateActiveTabKey('2');
      } else if (location.pathname === '/home/:estimate.iq5') {
        setActivePartMenu('3');
        props?.updateActiveTabKey('3');
      }
      setSelectedEstimateData(props.selectedEstimateData);
      // setCheckPMXOrNot(!props?.createNew);
    }
  }, [props.selectedEstimateData, props.createNew]);

  useEffect(() => {
    if (
      location.pathname === '/home/:estimate.parent' ||
      location.pathname === '/home/:estimate.iq3' ||
      location.pathname === '/home/:estimate.iq5'
    ) {
      let partMenu = props.activeTab ? props.activeTab : '1';
      setActivePartMenu(partMenu); // （IQX_WEBEST-79）
      props?.updateActiveTabKey(partMenu);
    }
  }, [props.activeTab]);

  //編集モード切替により呼び出す
  useEffect(() => {
    if (
      location.pathname === '/home/:estimate.parent' ||
      location.pathname === '/home/:estimate.iq3' ||
      location.pathname === '/home/:estimate.iq5'
    ) {
      setEditMode(props.editMode);
    }
  }, [props.editMode]);

  useEffect(() => {
    if (
      location.pathname === '/home/:estimate.parent' ||
      location.pathname === '/home/:estimate.iq3' ||
      location.pathname === '/home/:estimate.iq5'
    ) {
      if (isPMXEvent) {
        props?.loading(true); // Waitingダイアログを非表示にする
        iQ3EstimateRef?.current?.updateIq3PMXDatas(props?.selectedEstimateData?.esIq3Info);
      }
    }
  }, [isPMXEvent]);

  useEffect(() => {
    if (
      location.pathname === '/home/:estimate.parent' ||
      location.pathname === '/home/:estimate.iq3' ||
      location.pathname === '/home/:estimate.iq5'
    ) {
      if (isPMXProcessPatternOpen && currentPMXMenu == 'cloud') {
        // getPMXEstimateInfo();
        // 2025-05-23 ローカルPMXファイル読み込み
        getPMXEstimateInfoCloud();
      }
    }
  }, [isPMXProcessPatternOpen]);

  useEffect(() => {
    if (
      location.pathname === '/home/:estimate.parent' ||
      location.pathname === '/home/:estimate.iq3' ||
      location.pathname === '/home/:estimate.iq5'
    ) {
      if (isAllUpdateOK) {
        const data = [...bulkIQ3DataLst];
        for (let i = 0; i < bulkEditSelectedRow?.length; i++) {
          const index = data?.findIndex((item) => item?.no === bulkEditSelectedRow[i]?.no);
          if (index >= 0 && data[index]) {
            //基本情報更新
            if (partCount !== '') {
              data[index].partCount = partCount;
            }
            if (materialTypeId !== '') {
              let materialId = materialTypeId;
              let materialSurfaceId = materialTypeId;
              let materialList = materialLst?.filter(
                (item) => item.info.isUsed && item.materialTypeIq3Id === materialTypeId
              );
              if (materialList?.length > 0) {
                materialId = materialList[0]?.id;
              }
              // 材料表面情報
              let materialSurfaceList = materialSurfaceLst?.filter(
                (item) => item.info.isUsed && item.materialTypeIq3Id === materialTypeId
              );
              if (materialSurfaceList?.length > 0) {
                materialSurfaceId = materialSurfaceList[0]?.id;
              }
              let materilTypeNm = getMaterialTypeById(materialTypeId, materialTypeLst);
              data[index].materialTypeName = materilTypeNm;
              data[index].materialTypeIq3Id = materialTypeId;
              data[index].thickness = materialId;
              data[index].materialName = getMaterialNameById(materialId, materialLst);
              data[index].materialIq3Id = materialId;
              data[index].materialSurfaceId = materialSurfaceId;
              data[index].materialSurfaceName = getMaterialSurfaceById(materialSurfaceId, materialSurfaceLst);
              data[index].materialSurfaceIq3Id = materialSurfaceId;
            }
            if (thickness !== '') {
              data[index].thickness = thickness;
              data[index].materialName = getMaterialNameById(thickness, materialLst);
              data[index].materialIq3Id = thickness;
            }
            if (materialSurfaceId !== '') {
              data[index].materialSurfaceId = materialSurfaceId;
              data[index].materialSurfaceName = getMaterialSurfaceById(materialSurfaceId, materialSurfaceLst);
              data[index].materialSurfaceIq3Id = materialSurfaceId;
            }

            // 2025-05-27 一括編集にて材料費￥０に編集したい。できないか？の対応
            // if (props?.isZeroMaterialCost) {
            //   data[index].isZeroMaterialCost = true;
            // }
            // 工程選択情報更新

            if (processSelectedDataUpdate && Object.keys(processSelectedData).length > 0) {
              let bulkData = data?.[index]?.processSelect;
              if (bulkData !== undefined) {
                bulkData.id = processSelectedData?.id;
                bulkData.name = processSelectedData?.name;
                // IQX_WEBEST-367 板金子部品の一括編集画面の工程選択タブにある「変更していない項目も一括で変更する」チェックにチェックできない。
                if (isAllEdit) {
                  bulkData.details = processSelectedData?.details;
                } else {
                  for (let j = 0; j < processSelectedData?.details?.length; j++) {
                    if (processSelectedData?.details[j]?.isUsedForCalc) {
                      let editIndex = bulkData?.details?.findIndex(
                        (item) => item.processId === processSelectedData?.details[j]?.processId
                      );
                      if (editIndex >= 0) {
                        bulkData.details[editIndex] = processSelectedData?.details[j];
                      }
                    }
                  }
                }
                data[index].processSelect = bulkData;
              }
            }
          }
        }
        //CURT.iq3リストに更新
        setBulkIQ3DataLst(data);
        iQ3EstimateRef?.current?.updateIQ3DataByBulkEdit(data);
        setIsAllUpdateOK(false);
      }
    }
  }, [isAllUpdateOK]);

  // 2025-05-23 ローカルPMXファイル読み込み
  // 板金見積データ作成
  const getNewIQ3EstimateInfo = (lists, parameters, settings) => {
    let userSettingData = settings.userSettings;
    const patternLst = parameters?.processPattern; // 工程パターンマスタデータ
    let kouteiPatternList = patternLst?.filter((item) => item.id === userSettingData?.[0]?.users?.iq3ProcessPatternId);
    if (kouteiPatternList?.length === 0) {
      kouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.SheetMetal);
    }

    const materialType = parameters?.materialTypeIq3; // 材質マスタデータ
    let materialTypeList = materialType?.filter((item) => item.info.isUsed);

    const material = parameters?.materialIq3; // 材料マスタデータ
    let materialList = material?.filter(
      (item) =>
        item.info.isUsed && item.materialTypeIq3Id === (materialTypeList?.length > 0 ? materialTypeList[0]?.id : 0)
    );

    const materialSurface = parameters?.materialSurfaceIq3; // 材料表面マスタデータ
    let materialSurfaceList = materialSurface?.filter(
      (item) =>
        item.info.isUsed && item.materialTypeIq3Id === (materialTypeList?.length > 0 ? materialTypeList[0]?.id : 0)
    );

    // 工程マスタ情報取得
    let processMaster = [];
    const processMstData = parameters?.process; // 工程マスタデータ
    processMaster = processMstData?.filter((process) => process?.class === ServiceClass.SheetMetal);
    let blankIsUsedData = [];
    processMaster?.filter((i) => {
      if (
        i.workType === WorkType.SmBlankCombi ||
        i.workType === WorkType.SmBlankLaser ||
        i.workType === WorkType.SmBlankPunch
      ) {
        blankIsUsedData.push(i.id);
        // return i.id;
      }
    });
    const filteredList2 = kouteiPatternList?.[0]?.details?.filter((item2) =>
      blankIsUsedData.some((item1) => item1 === item2.processId)
    );

    const isAnyTrue = filteredList2?.some((item) => item.isUsedForCalc);

    // 工程入力
    let processSelectDetails = kouteiPatternList?.[0]?.details;

    let kouteiInputArr = [];
    if (processSelectDetails) {
      kouteiInputArr = processSelectDetails?.map((item, index) => {
        const processMstInfo = processMaster?.filter((i) => i.id === item.processId)?.[0] || [];

        const workType = processMstInfo.workType || '';

        let data = {
          id: index + 1,
          processId: item.processId,
          details: getDetails(workType, parameters, processSelectDetails),
        };

        return data;
      });
    }

    //　工程積算
    let kouteiCalArr = [];
    if (processSelectDetails) {
      kouteiCalArr = processSelectDetails?.map((item, index) => {
        const processMstInfo = processMaster?.filter((i) => i.id === item.processId)?.[0] || [];

        const workType = processMstInfo.workType || '';
        let dataItems = [];
        if (item.multiprocesses?.length > 0) {
          for (let m = 0; m < item.multiprocesses?.length; m++) {
            let dataItem = {
              id: m + 1,
              processName: processMstInfo?.name,
              processDetailTypeNo: item.multiprocesses[m]?.processDetailTypeId,
              dandoriAmt: 0,
              dandoriTime: 0,
              sagyoAmt: 0,
              sagyoTime: 0,
              processDetailWorkTypeGroup: item.multiprocesses[m]?.processDetailGroup,
              kasho: 1,
              isCommission: false,
              supplier: '',
              supplierCode: '',
              formula: '',
            };
            dataItems.push(dataItem);
          }
        }

        let addition = {
          no: index + 1,
          processId: item.processId,
          dataType: DataType.Data,
          dataItems: dataItems,
          editItems: [],
          totalDandori: {
            dataItemsAmt: 0,
            dataItemsTime: 0,
            editItemsAmt: 0,
            editItemsTime: 0,
          },
          totalSagyo: {
            dataItemsAmt: 0,
            dataItemsTime: 0,
            editItemsAmt: 0,
            editItemsTime: 0,
          },
          totalDataPrice: 0,
          totalDataTime: 0,
          totalEditPrice: 0,
          totalEditTime: 0,
        };

        return addition;
      });
    }

    // 材料詳細パターン情報を準備する
    let materialDetailPatterns = [];

    // 材料詳細サイズリスト情報を準備する
    let materialDetailSizes = [];
    let materialSizeIq3Infos = parameters?.materialSizeIq3;
    if (materialSizeIq3Infos) {
      materialDetailSizes = materialSizeIq3Infos
        ?.filter((item) => item.info.isUsed && item.name !== 'Free')
        ?.map((item, index) => {
          let data = getInitMaterialSizeInfo(index, item);
          materialDetailPatterns = getInitMaterialPatternsInfo(materialDetailPatterns, item);
          return data;
        });
    }

    // ブランクの場合
    let blankProcess = getProcessRecord(
      ServiceClass.SheetMetal,
      [WorkType.SmBlankLaser, WorkType.SmBlankPunch, WorkType.SmBlankCombi], // レーザー、パンチ、複合機
      processMstData
    );
    // 板金工程選択にブランクを使用している場合、
    let usedBlankProcess = processSelectDetails?.find(
      (selectItem) =>
        selectItem.isUsedForCalc && blankProcess?.findIndex((item) => item.id === selectItem.processId) > -1
    );
    // 使用している装置の情報を取得する
    let usedDeviceInfo = parameters?.device?.find((device) => device.id === usedBlankProcess?.deviceId);
    let grabbingX = 0;
    let grabbingY = 0;
    let pierWidthX = 0;
    let pierWidthY = 0;
    let worlRangeX = 0;
    let worlRangeY = 0;
    // 装置がある場合、
    if (usedDeviceInfo) {
      // 装置から材料配置情報
      let materialArrange = usedDeviceInfo?.details?.materialArrange;
      grabbingX = materialArrange?.graspAllowanceX;
      grabbingY = materialArrange?.graspAllowanceY;
      pierWidthX = materialArrange?.xWidth;
      pierWidthY = materialArrange?.yWidth;
      worlRangeX = materialArrange?.workRangeX;
      worlRangeY = materialArrange?.workRangeY;
    }

    let data = JSON.parse(JSON.stringify(lists));
    const updatedList = data?.map((i, index) => {
      if (i?.id === 0) {
        i.no = 1;
        i.creationType = EstimateCreationType.Auto;
        i.drawingNo = 'Part_' + formatDateString(todayTime());
        i.name = 'Part_' + padWithLeadingZeros(index + 1, 5);
        i.surfaceProtection = SurfaceProtectionType.OneSideVinyl;
        
        i.processSelect = {
          id: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.id : 0,
          name: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.name : '',
          details: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.details : [],
          modified: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.modified : dayjs().format(),
        };
        i.processInput = kouteiInputArr;
        i.purchases = [];
        i.additions = kouteiCalArr;
        i.materialDetailPatterns = materialDetailPatterns;
        i.materialDetailSizes = materialDetailSizes;
        i.weight = 0;
        i.totalSurfaceArea = 0.0;
        i.partSizeX = 0;
        i.partSizeY = 0;
        i.partCount = 1;
        i.grabbingX = grabbingX;
        i.grabbingY = grabbingY;
        i.pierWidthX = pierWidthX;
        i.pierWidthY = pierWidthY;
        i.worlRangeX = worlRangeX;
        i.worlRangeY = worlRangeY;
        i.workCostUnitPrice = 0;
        i.workCostTotalPrice = 0;
        i.costUnitPrice = 0;
        i.costTotalPrice = 0;
        i.surfaceTotalPrice = 0;
        i.surfaceUnitPrice = 0;
        i.purchaseUnitPrice = 0;
        i.purchaseTotalPrice = 0;
        i.materialCostUnitPrice = 0;
        i.materialCostTotalPrice = 0;
      }
      return i;
    });
    return updatedList;
  };

  // 形鋼
  const getNewIQ5EstimateInfo = (lists, parameters, settings) => {
    // let parameters = props.selectedEstimateData?.estimateProducts?.calcParameters?.parameters;
    // let userSettingData = props.selectedEstimateData?.estimateProducts?.calcParameters?.settings?.userSettings;
    let userSettingData = settings.userSettings;

    const patternLst = parameters?.processPattern; // 工程パターンマスタデータ
    // let kouteiPatternList = patternLst?.filter((item) => item.id === userSettingData?.[0]?.users?.iq3ProcessPatternId);
    // IQX_WEBEST-323 新規処理の前回値の採用
    // if (userSettingData?.length > 0 && userSettingData?.[0].users.newSmInitialInfo.iq3ProcessPatternId !== undefined) {
    //   let userSettingProcessPattern = patternLst?.filter(
    //     (i) => i.id === userSettingData?.[0].users.newSmInitialInfo.iq3ProcessPatternId
    //   );
    //   kouteiPatternList = userSettingProcessPattern?.length > 0 ? userSettingProcessPattern : kouteiPatternList;
    // }
    let kouteiPatternList = [];
    if (kouteiPatternList?.length === 0) {
      kouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.Beams);
    }

    // 材料明細情報
    const materialIq5 = parameters?.materialIq5?.filter((item) => item.info.isUsed && !item.isDeleted)?.[0];
    // 材質情報
    const materialTypeIq5 = parameters?.materialTypeIq5?.filter(
      (item) => item.info.isUsed && !item.isDeleted && materialIq5?.materialTypeIq5Id === item.id
    )?.[0];
    // 鋼材区分情報
    const steelShape = parameters?.steelShape?.filter((item) => item.id === materialIq5?.steelShapeId)?.[0];

    let materialIq5Id = materialIq5 ? materialIq5?.id : 0;
    let materialName = materialIq5 ? materialIq5?.name : '';
    let materialTypeIq5Id = materialTypeIq5 ? materialTypeIq5?.id : 0;
    let materialTypeName = materialTypeIq5 ? materialTypeIq5?.name : '';
    let steelShapeId = steelShape ? steelShape?.id : 0;
    let steelShapeName = steelShape ? steelShape?.name : '';
    let steelShapeURL = steelShape ? STEEL_SHAPE_URL + steelShape?.shapeNo + PNG : '';
    // 工程マスタ情報取得
    let processMaster = [];
    const processMstData = parameters?.process; // 工程マスタデータ
    processMaster = processMstData?.filter((process) => process?.class === ServiceClass.Beams);

    // 工程入力
    let processSelectDetails = kouteiPatternList?.[0]?.details;
    let kouteiInputArr = [];
    if (processSelectDetails) {
      kouteiInputArr = processSelectDetails?.map((item, index) => {
        let data = {
          id: index + 1,
          processId: item.processId,
          deviceProcessInputDetails: [],
        };
        return data;
      });
    }

    //　工程積算
    let kouteiCalArr = [];
    if (processSelectDetails) {
      kouteiCalArr = processSelectDetails?.map((item, index) => {
        const dataItems = {
          totalDandoriTime: 0,
          totalDandoriAmt: 0,
          totalSagyoTime: 0,
          totalSagyoAmt: 0,
        };
        let addition = {
          no: item.processId,
          processId: item.processId,
          dataType: DataType.Data,
          deviceAdditionsDetails: [],
          dataItems: dataItems,
          editItems: dataItems,
          totalDataPrice: 0,
          totalDataTime: 0,
          totalEditPrice: 0,
          totalEditTime: 0,
          editDataFlg: false,
        };

        return addition;
      });
    }

    // 使用している装置の情報を取得する
    let grabbingX = 0;
    let grabbingY = 0;
    let pierWidthX = 0;
    let pierWidthY = 0;
    let worlRangeX = 0;
    let worlRangeY = 0;

    const updatedList = lists?.map((i, index) => {
      if (i?.id === 0) {
        i.no = 1;
        i.creationType = EstimateCreationType.Auto;
        i.drawingNo = 'IQ5Part-' + formatDateString(todayTime());
        i.name = 'IQ5Part-' + padWithLeadingZeros(index + 1, 5);
        i.surfaceProtection = SurfaceProtectionType.OneSideVinyl;
        i.materialIq5Id = materialIq5Id;
        i.materialName = materialName;
        i.materialTypeIq5Id = materialTypeIq5Id;
        i.materialTypeName = materialTypeName;
        i.steelShapeId = steelShapeId;
        i.steelShapeName = steelShapeName;
        i.imageId = steelShape ? steelShape?.shapeNo : 0;
        i.processSelect = {
          id: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.id : 0,
          name: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.name : '',
          details: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.details : [],
          modified: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.modified : dayjs().format(),
        };
        i.processInput = kouteiInputArr;
        i.purchases = [];
        i.additions = kouteiCalArr;
        i.weight = 0;
        i.totalSurfaceArea = 0.0;
        i.partCount = 1;
        i.size = 0;
        i.materail;
        i.workCostUnitPrice = 0;
        i.workCostTotalPrice = 0;
        i.costUnitPrice = 0;
        i.costTotalPrice = 0;
        i.surfaceTotalPrice = 0;
        i.surfaceUnitPrice = 0;
        i.purchaseUnitPrice = 0;
        i.purchaseTotalPrice = 0;
        i.materialCostUnitPrice = 0;
        i.materialCostTotalPrice = 0;
      }
      return i;
    });
    return updatedList;
  };

  // 2025-05-23 ローカルPMXファイル読み込み
  // 新規見積データ作成
  const getNewEstimateInfo = (newParameters, iq3Count) => {
    let orderCoeffs = [];
    let deliDateCoeffs = [];
    let purCoeffs = [];
    let mngCoeffs = [];
    let setupCoeffs = [];
    let productCoeffs = [];
    let costLst = [];
    let labelLst = [];
    let memoLst = [];
    let dateLst = [];
    let clientInfo = newParameters.client;
    let companyInfo = newParameters.company;
    let processInfo = newParameters.process;
    let deviceMasterInfo = newParameters.device;
    let processPattern = newParameters.processPattern;
    let estimateStatus = newParameters.estimateStatus;
    let purchaseAllocation = newParameters.purchaseAllocation;
    let purchaseCategoryInfo = newParameters.purchaseCategory;
    let purchasesData = newParameters.purchase;
    let staffList = newParameters.staff;
    let selectedStaff = staffList?.filter((i) => i?.info?.isUsed);
    let userSettingData = newParameters.userSettings;
    let companySettingData = newParameters.companySettings;
    //板金パラメータ情報
    let materialIq3 = newParameters.materialIq3;
    let materialSizeIq3 = newParameters.materialSizeIq3;
    let materialSurfaceIq3 = newParameters.materialSurfaceIq3;
    let materialType = newParameters.materialType;
    let materialTypeIq3 = newParameters.materialTypeIq3;

    //
    //板金パラメータ情報
    let materialIq5 = newParameters.materialIq5;
    let materialSizeIq5 = newParameters.materialSizeIq5;
    let materialSurfaceIq5 = newParameters.materialSurfaceIq5;
    // let materialType = newParameters.materialType;
    let materialTypeIq5 = newParameters.materialTypeIq5;
    let steelShape = newParameters.steelShape;

    let clientData = clientInfo?.filter((i) => !i.isDeleted && i?.info?.isUsed);
    let client = clientData?.length > 0 ? clientData[0] : {};
    if (companyInfo?.length > 0) {
      orderCoeffs = companyInfo[0].coeffOrders?.filter((i) => !i.isDeleted && i.isUsed);
      deliDateCoeffs = companyInfo[0].coeffDeliveryDates?.filter((i) => !i.isDeleted && i.isUsed);
      purCoeffs = companyInfo[0].coeffPurchases?.filter((i) => !i.isDeleted && i.isUsed);
      mngCoeffs = companyInfo[0].coeffManagements?.filter((i) => !i.isDeleted && i.isUsed);
      setupCoeffs = companyInfo?.[0]?.coeffSetups?.filter((i) => !i.isDeleted && i.isUsed);
      productCoeffs = companyInfo?.[0]?.coeffProducts?.filter((i) => !i.isDeleted && i.isUsed);
      costLst = companyInfo[0]?.additionalItemCosts
        ?.filter((item) => item.isUsed && !item.isDeleted)
        ?.map((item) => {
          return initAdditionalItemCost(item.id, item.code, item.name);
        });

      labelLst = companyInfo[0]?.additionalItemLabels
        ?.filter((item) => item.isUsed && !item.isDeleted)
        ?.map((item) => {
          return initAdditionalItemLabel(item.id, item.code, item.name);
        });

      memoLst = companyInfo[0]?.additionalItemMemos
        ?.filter((item) => item.isUsed && !item.isDeleted)
        ?.map((item) => {
          return initAdditionalItemMemo(item.id, item.code, item.name);
        });

      dateLst = companyInfo[0]?.additionalItemDates
        ?.filter((item) => item.isUsed && !item.isDeleted)
        ?.map((item) => {
          return initAdditionalItemDate(item.id, item.code, item.name);
        });
    }
    let kouteiPatternList = processPattern?.filter(
      (item) => item.id === userSettingData?.[0]?.users?.parentProcessPatternId
    );

    if (kouteiPatternList?.length === 0) {
      kouteiPatternList = processPattern?.filter((item) => item.class === ServiceClass.Parent);
    }

    let parameters = {
      company: companyInfo,
      client: clientInfo,
      process: processInfo,
      device: deviceMasterInfo,
      processPattern: processPattern,
      estimateStatus: estimateStatus,
      purchaseAllocation: purchaseAllocation,
      purchaseCategory: purchaseCategoryInfo,
      purchase: purchasesData,
      staff: staffList,
      materialIq3: materialIq3,
      materialSizeIq3: materialSizeIq3,
      materialSurfaceIq3: materialSurfaceIq3,
      materialType: materialType,
      materialTypeIq3: materialTypeIq3,
      materialIq5: materialIq5,
      materialSizeIq5: materialSizeIq5,
      materialSurfaceIq5: materialSurfaceIq5,
      materialTypeIq5: materialTypeIq5,
      steelShape: steelShape,
    };

    let settings = {
      userSettings: userSettingData,
      companySettings: companySettingData,
    };

    //親部品工程積算情報設定
    let kouteiCalArr = [];
    let processSelectDetails = kouteiPatternList?.[0]?.details;
    if (processSelectDetails) {
      kouteiCalArr = processSelectDetails?.map((item, index) => {
        const processInfoFilter = processInfo?.filter((i) => i.id === item.processId)?.[0] || [];
        let dataItems = [];
        if (item.multiprocesses?.length > 0) {
          for (let m = 0; m < item.multiprocesses?.length; m++) {
            let dataItem = {
              id: m + 1,
              processName: processInfoFilter?.name,
              processDetailTypeNo: item.multiprocesses[m]?.processDetailTypeId,
              dandoriAmt: 0,
              dandoriTime: 0,
              sagyoAmt: 0,
              sagyoTime: 0,
              processDetailWorkTypeGroup: item.multiprocesses[m]?.processDetailGroup,
              kasho: 1,
              isCommission: false,
              supplier: '',
              supplierCode: '',
              formula: '',
            };
            dataItems.push(dataItem);
          }
        }

        let addition = {
          no: index + 1,
          processId: item?.processId,
          dataType: DataType.Data,
          dataItems: dataItems,
          editItems: [],
          totalDandori: {
            dataItemsAmt: 0,
            dataItemsTime: 0,
            editItemsAmt: 0,
            editItemsTime: 0,
          },
          totalSagyo: {
            dataItemsAmt: 0,
            dataItemsTime: 0,
            editItemsAmt: 0,
            editItemsTime: 0,
          },
          totalDataPrice: 0,
          totalDataTime: 0,
          totalEditPrice: 0,
          totalEditTime: 0,
        };
        return addition;
      });
    }

    // 板金
    let iq3Data = [...iq3EstimateInitInfo];

    let newIQ3Data = getNewIQ3EstimateInfo(iq3Data, parameters, settings);

    let newIQ3 = JSON.parse(JSON.stringify(newIQ3Data));
    const aggregatedObject = newIQ3?.reduce((result, currentItem) => {
      return { ...result, ...currentItem };
    }, {});
    const iq3ItemList = [];

    for (let i = 1; i <= iq3Count; i++) {
      let aggregatedObjectIQ3 = JSON.parse(JSON.stringify(aggregatedObject));
      //  CardDetailsの行により、板金データ作成
      iq3ItemList.push({ ...aggregatedObjectIQ3, no: i });
    }

    // 形鋼
    let iq5Data = [...iq5EstimateInitInfo];

    let newIQ5Data = getNewIQ5EstimateInfo(iq5Data, parameters, settings);

    let newIQ5 = JSON.parse(JSON.stringify(newIQ5Data));

    const aggregatedObject2 = newIQ5?.reduce((result, currentItem) => {
      return { ...result, ...currentItem };
    }, {});
    const iq5ItemList = [];

    for (let i = 1; i <= iq3Count; i++) {
      let aggregatedObjectIQ5 = JSON.parse(JSON.stringify(aggregatedObject2));
      //  CardDetailsの行により、板金データ作成
      iq5ItemList.push({ ...aggregatedObjectIQ5, no: i });
    }

    // 段取係数
    // 2025-10-01 IQX_WEBEST-484 WEB データがない新規親品を保存してエラー
    let coeffSetupId = setupCoeffs?.length > 0 ? setupCoeffs?.[0].id : 0;
    let coeffSetupName = setupCoeffs?.length > 0 ? setupCoeffs?.[0].name : '';
    let coeffSetups = setupCoeffs?.length > 0 ? toDecimal(setupCoeffs?.[0].coeff, 2) : toDecimal(0, 2);
    // 子部品生産個数係数
    // 2025-10-01 IQX_WEBEST-484 WEB データがない新規親品を保存してエラー
    let coeffProductId = productCoeffs?.length > 0 ? productCoeffs?.[0].id : 0;
    let coeffProductName = productCoeffs?.length > 0 ? productCoeffs?.[0].name : '';
    let coeffProducts = productCoeffs?.length > 0 ? toDecimal(productCoeffs?.[0].coeff, 2) : toDecimal(0, 2);

    return {
      ...estimateInitInfo,
      estimateProducts: {
        ...estimateInitInfo.estimateProducts,
        modifierId:
          userSettingData?.length > 0
            ? userSettingData?.[0]?.users?.staffId
            : selectedStaff?.length > 0
            ? selectedStaff[0].id
            : '',
        // modifier: staffList?.length > 0 ? staffList[0].label : '',
        modifier:
          userSettingData?.length > 0
            ? userSettingData?.[0]?.users?.nickName
            : selectedStaff?.length > 0
            ? selectedStaff?.[0]?.name
            : '',
        drawingNo: 'Product-' + formatDateString(todayTime()),
        name: 'Product-' + formatDateString(todayTime()),
        clientId: client ? client?.id : 0,
        clientName: client ? client?.name : '',
        coeffOrdersId: orderCoeffs?.length > 0 ? orderCoeffs?.[0].id : undefined,
        coeffOrdersName: orderCoeffs?.length > 0 ? orderCoeffs?.[0].name : '',
        coeffDeliveryDatesId: deliDateCoeffs?.length > 0 ? deliDateCoeffs?.[0].id : undefined,
        coeffDeliveryDatesName: deliDateCoeffs?.length > 0 ? deliDateCoeffs?.[0].name : '',
        coeffPurchasesId: purCoeffs?.length > 0 ? purCoeffs?.[0].id : undefined,
        coeffPurchasesName: purCoeffs?.length > 0 ? purCoeffs?.[0].name : '',
        coeffManagementsId: mngCoeffs?.length > 0 ? mngCoeffs?.[0].id : undefined,
        coeffManagementsName: mngCoeffs?.length > 0 ? mngCoeffs?.[0].name : '',
        coeffSetupId: coeffSetupId,
        coeffSetupName: coeffSetupName,
        coeffProductId: coeffProductId,
        coeffProductName: coeffProductName,
        createrId:
          userSettingData?.length > 0
            ? userSettingData?.[0]?.users?.staffId
            : selectedStaff?.length > 0
            ? selectedStaff?.[0].id
            : '',
        // creater: staffList?.length > 0 ? staffList[0].label : '',
        creater:
          userSettingData?.length > 0
            ? userSettingData?.[0]?.users?.nickName
            : selectedStaff?.length > 0
            ? selectedStaff?.[0]?.name
            : '',
        estimateNo: formatDateString(todayTime()),
        estimateStatusId: estimateStatus?.length > 0 ? estimateStatus?.[0]?.id : 0,
        estimateStatus: estimateStatus?.length > 0 ? estimateStatus?.[0]?.name : '',
        otherProduct: {
          adjustment: 0,
          adjustmentMethod: '+',
          coeffClient: client
            ? toDecimal(client?.coeffClients?.find((item) => item.clientType === ClientType.Customer)?.coeff)
            : toDecimal(0, 2),
          coeffOrders: orderCoeffs?.length > 0 ? toDecimal(orderCoeffs?.[0].coeff) : 0.0,
          coeffDeliveryDates: deliDateCoeffs?.length > 0 ? toDecimal(deliDateCoeffs?.[0].coeff) : 0.0,
          coeffPurchases: purCoeffs?.length > 0 ? toDecimal(purCoeffs?.[0].coeff) : 0.0,
          coeffManagements: mngCoeffs?.length > 0 ? toDecimal(mngCoeffs?.[0].coeff) : 0.0,
          coeffSetups: coeffSetups,
          coeffProducts: coeffProducts,
        },
        processSelect: {
          id: kouteiPatternList?.length > 0 ? kouteiPatternList?.[0]?.id : 0,
          name: kouteiPatternList?.length > 0 ? kouteiPatternList?.[0]?.name : '',
          details: kouteiPatternList?.length > 0 ? kouteiPatternList?.[0]?.details : [],
          modified: kouteiPatternList?.length > 0 ? kouteiPatternList?.[0]?.modified : dayjs().format(),
        },
        processInput: {
          surfaceProcessInputInfo: [],
          assenbleProcessInputInfo: {
            no: 1,
            calcType: 1,
            smPartsCount: 1,
            purchaseInstTime: 0,
            assyList: [{ no: 1, name: '', workTime: 0, workCount: 0, workTotalTime: 0 }],
            autoExtract: 1, // IQX_WEBEST-179
          },
          inspectionProcessInputInfo: {
            no: 1,
            calcType: 1,
            smPartsCount: 1,
            autoExtract: 1, // IQX_WEBEST-179
          },
          packingProcessInputInfo: {
            no: 1,
            calcType: 1,
            smPartsCount: 1,
            autoExtract: 1, // IQX_WEBEST-179
          },
        },
        additions: kouteiCalArr,
        purchases: [],
        byQuantities: JSON.parse(JSON.stringify(byQuantities)),
        calcParameters: {
          settings: settings,
          parameters: parameters,
        },
      },
      epCustomCosts: costLst,
      epCustomDates: dateLst,
      epCustomLabels: labelLst,
      epCustomMemos: memoLst,
      esIq3Info: iq3ItemList,
      esIq5Info: iq5ItemList,
    };
  };

  // 2025-05-23 ローカルPMXファイル読み込み
  const getPMXEstimateInfoCloud = async () => {
    getPMXEstimateInfo();
  };

  // 2025-05-23 ローカルPMXファイル読み込み
  const getPMXEstimateInfo = async (data = []) => {
    let estimateData = [];
    // if (currentPMXMenu == 'local') {
    // 見積データ作成
    let newParameters = await GetParametersByCompId();
    data?.details?.sort((a, b) => a.id - b.id); // IDで昇順ソート
    let newEstimateInfo = getNewEstimateInfo(newParameters, data?.details?.length);
    estimateData = newEstimateInfo;
    // } else {
    //   estimateData = await pmxCloudParentRef?.current?.getPMXEstimateInfo();
    // }
    if (estimateData) {
      // ＊＊＊
      let parameters = estimateData?.estimateProducts?.calcParameters?.parameters;
      let settings = estimateData?.estimateProducts?.calcParameters?.settings;
      let userSettingData = settings?.userSettings;
      // 工程マスタデータ
      const patternLst = parameters?.processPattern;
      let parentKouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.Parent);
      let iq3KouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.SheetMetal);
      let iq5KouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.Beams);
      setPatternList(parentKouteiPatternList);
      let initParentKouteiPatternList = patternLst?.filter(
        (item) => item.id === userSettingData?.[0]?.users?.parentProcessPatternId
      );
      let initIq3KouteiPatternList = patternLst?.filter(
        (item) => item.id === userSettingData?.[0]?.users?.iq3ProcessPatternId
      );
      let parentPatternId =
        initParentKouteiPatternList?.length > 0 ? initParentKouteiPatternList[0].id : parentKouteiPatternList?.[0]?.id;
      let childPatternId =
        initIq3KouteiPatternList?.length > 0 ? initIq3KouteiPatternList[0].id : iq3KouteiPatternList?.[0]?.id;
      setIQ3PatternList(iq3KouteiPatternList);
      setChildPatternNo(childPatternId);
      // IQ5
      setChildIQ5PatternNo(iq5KouteiPatternList?.[0]?.id);
      setIQ5PatternList(iq5KouteiPatternList);
      //
      setParentPatternNo(parentPatternId);
      setSelectedPMXEstimateData(estimateData);
      setIsProcessSelectInfo(false);
      if (isCreatePMX === CreatePMXData.Update) {
        setIsNext(true);
        setCurrentStep(1);
      } else {
        setIsNext(false);
        setCurrentStep(0);
      }
      setIsPrepareInfo(true);
    }

    return estimateData;
  };

  //板金データにより元見積データを更新
  const updatedSelectedEstimateDataTemp = (data) => {
    if (selectedEstimateDataTemp?.esIq3Info == undefined) {
      // let updateSelectedInfo = selectedEstimateDataTemp;
      // updateSelectedInfo.esIq3Info = data?.esIq3Info;
      // setSelectedEstimateDataTemp(data);
    }
  };

  // 2025-05-23 ローカルPMXファイル読み込み
  // PMX取り込みコンテンツから選択した場合、
  const openPMXFileDialog = async (e, type, clickCon) => {
    props?.loading(true); // Waitingダイアログを表示にする
    setIsCreatePMX(clickCon);
    setIsLoadPMXProcess(false);
    setPmxProcessType(type);
    if (currentPMXMenu == 'local') {
      if (clickCon === CreatePMXData.SaveAndNew) {
        if (selectedEstimateData?.estimateProducts?.id === 0) {
          estimateNewDataSaveEvent();
        } else {
          saveByOverwriteOk();
        }
      } else {
        inputFile.current.click();
      }
    } else {
      // const tenjikaiSampleData = getTenjikaiSampleData();
      // const pmxList = tenjikaiSampleData.parentList_PMX_1;
      // setPMXSelectedEstimateData(pmxList[0]);
      // setPMXTabKey('1');
      if (clickCon === CreatePMXData.SaveAndNew) {
        if (selectedEstimateData?.estimateProducts?.id === 0) {
          estimateNewDataSaveEvent();
        } else {
          saveByOverwriteOk();
        }
      }
      setIsPMXCloudFileDialogOpen(true);
      // IQX_WEBEST-246
      let cardData = await getCardInfo(100, 0, '', '', '', '', '', '', 3);
      if (cardData) {
        const cardDatas = cardData?.data;
        const updatedData = cardDatas?.map((item) => ({
          ...item,
          modified: formatPMXDate(item.modified),
        }));
        setCardInfo(updatedData);
        const updatedDataTotalCount = cardData?.totalCount ? cardData?.totalCount : 0;
        setCardInfoCount(updatedDataTotalCount);
      }
    }
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  const openFileDialog_pcInput = () => {
    setPcInClk(true);
    if (editMode) {
      setConfirmScreenChangeModalOpen(true);
    } else {
      setConfirmDisplayDataSaveModalOpen(true);
    }
  };

  const openFileDialog_pcOutput = () => {
    setPcOutClk(true);
    if (editMode) {
      setConfirmScreenChangeModalOpen(true);
    } else {
      setConfirmDisplayDataSaveModalOpen(true);
    }
  };

  // 2025-05-23 ローカルPMXファイル読み込み
  const openPMXProcessPatternDialog = async (e) => {
    setIsPMXProcessPatternOpen(true);
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const base64String = await blobToBase64(file);

      const pmxFormData = new FormData();
      pmxFormData.append('cad3dId', 1);
      pmxFormData.append('pmxBase64String', base64String);
      pmxFormData.append('fileName', file.name);

      const pmxUrl = `${process.env.REACT_APP_BACKEND_API_URL}Card/GetPMXFileData`;

      const pmxDataResponse = await axios.post(pmxUrl, pmxFormData, {
        headers: {
          Authorization: 'Bearer ' + getAccessToken(),
          'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
        },
      });

      setSelectedCardData(pmxDataResponse?.data?.data);
      setIsProcessSelectInfo(true);

      let iq3CADData = pmxDataResponse?.data?.data?.details?.filter((i) => i.type !== 'SheetMetal');
      if (iq3CADData?.length > 0) {
        setNoIq3(true);
      }
      getPMXEstimateInfo(pmxDataResponse?.data?.data);
    } catch (error) {
      console.error('PMX解析中にエラーが発生しました:', error);
    }
  };

  const openPMXProcessPatternModal = (res, selectedCardData) => {
    setIsProcessSelectInfo(true);
    setIsPMXProcessPatternOpen(res);
    setSelectedCardData(selectedCardData);
    let iq3CADData = selectedCardData?.details?.filter((i) => i.type !== 'SheetMetal');
    if (iq3CADData?.length > 0) {
      setNoIq3(true);
    }
  };

  // PMXメニューイベント
  const pmxMenuChangeEvent = async (e) => {
    setClickPMX(true);
    setCurrentPMXMenu('local');
    if (editMode) {
      setConfirmScreenChangeModalOpen(true);
    } else {
      // if (e.key === 'cloud') {
      //   setCurrentStep(1);
      //   setIsLoadPMXProcess(true);
      // } else {
      // 2025-05-23 ローカルPMXファイル読み込み
      setCurrentStep(0);
      setIsLoadPMXProcess(true);
      // }
    }
  };

  const dxfMenuChangeEvent = async () => {
    // let companySetting = await getExistCompanySetting();
    let companySetting = await getExistCompanySetting(); // IQX_WEBEST-237
    if (companySetting !== undefined) {
      if (!Array.isArray(companySetting)) {
        companySetting = [companySetting];
      }
    }
    setDXFCompanySetting(companySetting);
    setIsDXFPrepareInfo(true);
    // 見積データ作成
    let newParameters = await GetParametersByCompId();
    // data?.details?.sort((a, b) => a.id - b.id); // IDで昇順ソート
    // let newEstimateInfo = getNewEstimateInfo(newParameters, data?.details?.length);
    // // ＊＊＊
    // let parameters = newEstimateInfo?.estimateProducts?.calcParameters?.parameters;
    // let settings = newEstimateInfo?.estimateProducts?.calcParameters?.settings;
    // let userSettingData = settings?.userSettings;
    // // 工程マスタデータ
    const patternLst = newParameters?.processPattern;
    let parentKouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.Parent);
    let iq3KouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.SheetMetal);
    setPatternList(parentKouteiPatternList);
    // let initParentKouteiPatternList = patternLst?.filter(
    //   (item) => item.id === userSettingData?.[0]?.users?.parentProcessPatternId
    // );
    let initParentKouteiPatternList =
      parentKouteiPatternList && parentKouteiPatternList.length > 0 ? parentKouteiPatternList[0] : null;

    // let initIq3KouteiPatternList = patternLst?.filter(
    //   (item) => item.id === userSettingData?.[0]?.users?.iq3ProcessPatternId
    // );

    let initIq3KouteiPatternList =
      iq3KouteiPatternList && iq3KouteiPatternList.length > 0 ? iq3KouteiPatternList[0] : null;

    let parentPatternId =
      initParentKouteiPatternList?.length > 0 ? initParentKouteiPatternList[0].id : parentKouteiPatternList?.[0]?.id;
    let childPatternId =
      initIq3KouteiPatternList?.length > 0 ? initIq3KouteiPatternList[0].id : iq3KouteiPatternList?.[0]?.id;
    setIQ3PatternList(iq3KouteiPatternList);
    setChildPatternNo(childPatternId);
    setParentPatternNo(parentPatternId);
    setSelectedPMXEstimateData(props.selectedEstimateData);

    //
    setDXFParentPatternNo(parentPatternId);
    setDXFChildPatternNo(childPatternId);

    setIsCreatePMX(CreatePMXData.New);

    // setIsProcessSelectInfo(false);
    // if (isCreatePMX === CreatePMXData.Update) {
    //   setIsNext(true);
    //   setCurrentStep(2);
    // } else {
    //   setIsNext(false);
    //   setCurrentStep(1);
    // }

    //
    setIsDXFFileUpload(true);
    setIsDXFProcessPatternOpen(true);
    setIsDXFPrepareInfo(false);
  };

  const pmxLocalProcessCancel = () => {
    // 2025-05-26 ローカルPMXファイル読み込み
    setCurrentPMXMenu(null);
    setIsLoadPMXProcess(false);
    setIsPMXCloudFileDialogOpen(false);
  };

  const fetchIndividualData = async () => {
    try {
      // IQX_WEBEST-365 クイック印刷機能が実装していない。
      let printOutputsInfo = {
        isUseQuickOutput: false,
        printOutputFormat: [],
      };
      let companySetting = await getExistCompanySetting(); // IQX_WEBEST-237
      if (companySetting !== undefined) {
        let selectedExelIndividualFormat = [];
        if (!Array.isArray(companySetting)) {
          companySetting = [companySetting];
        }
        // Check if companySetting is not null or undefined
        const formats = getExcelDatabyUseType(companySetting?.[0]?.excelFormats);
        const excelIndividualformats = formats[PrintTypes.individual];
        if (excelIndividualformats !== undefined && excelIndividualformats?.length > 0) {
          selectedExelIndividualFormat = formats[0]?.find(
            (format) => format.id === companySetting?.[0]?.printOutputs?.[PrintTypes.individual]?.formatsId
          );
          setExcelIndividualFormats(formats[PrintTypes.individual]);

          if (selectedExelIndividualFormat !== undefined) {
            setSelectedExeclIndividualFormat(selectedExelIndividualFormat);
          } else {
            setSelectedExeclIndividualFormat(formats[0][0]);
          }
        }
        // IQX_WEBEST-365 クイック印刷機能が実装していない。
        let isUsedQuick = companySetting[0]?.printOutputs?.[PrintTypes.individual]?.isUseQuickOutput;
        if (isUsedQuick) {
          printOutputsInfo.isUseQuickOutput = isUsedQuick;
          if (selectedExelIndividualFormat !== undefined) {
            printOutputsInfo.printOutputFormat = selectedExelIndividualFormat;
          } else {
            printOutputsInfo.printOutputFormat = formats[0][0];
          }
        }
      }
      return printOutputsInfo;
    } catch (error) {
      console.error(error);
    }
  };

  const updateEstimateInfo = (estimateInfo) => {
    setBasicInfoUpdate(!basicInfoUpdate);
    setSelectedEstimateData(estimateInfo);
  };

  const updateParentEstimateInfo = (estimateInfo) => {
    parentEstimateRef.current.updateEstimateInfo(estimateInfo);
  };

  const getCurrentIQ3 = () => {
    let currentIq3Data = iQ3EstimateRef?.current?.getEstimateIq3Info();
    return currentIq3Data;
  };

  const getParentQuantity = () => {
    return props?.selectedEstimateData?.estimateProducts?.quantity; //入力した数量情報を取得
  };

  // const changeIsReCalLoading = (flg) => {
  //   props?.loading(true);
  // };

  // 開発中ポップアップ
  const closeCommonTaiochuPopup = () => {
    setOpenCommonTaiochuPopup(false);
  };
  // 呼出
  const commonTaiochuPopupOpen = () => {
    setOpenCommonTaiochuPopup(true);
  };

  const discardConfirmOk = () => {
    setConfirmScreenChangeModalOpen(false);
    setConfirmDisplayDataSaveModalOpen(false);
    setEditMode(false);
    props.updateEstimateEditMode(false);

    if (clickPMX) {
      setClickPMX(false);
      setIsLoadPMXProcess(true);
    } else if (yobidashiClk) {
      // 子部品追加呼出
      setParentListDisplay(true);
      setYobidashiClk(false);
      setParentLoading(true); // Waitingダイアログを表示にする
    } else if (calClk) {
      setIsEstimateDataSaveConfirm(true);
      setChildTitle('確認');
      setCalClk(false);
    } else if (saveClk) {
      // setIsEstimateDataSaveConfirm(true);
      if (selectedSaveMenuKey === saveMenuChildItems[0].key) {
        setIsSaveByOtherName(true);
        // setInputDrawingNo(formatDateString(todayTime()));
        let currentEstimateData = parentEstimateRef?.current?.getParentEstimateInfo();
        const data = JSON.parse(JSON.stringify(currentEstimateData));
        setEstimateNo(data?.estimateProducts?.estimateNo + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
        setInputDrawingNo(data?.estimateProducts?.drawingNo + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
        setParentEstimateName(data?.estimateProducts?.name + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
      } else {
        setIsSaveByOverwrite(true);
      }
      setChildTitle('確認');
      setSaveClk(false);
      parentEstimateRef?.current?.discardConfirmOk();
    } else if (pcInClk) {
      inputFile_pcInput.current.click();
      setPcInClk(false);
    } else if (pcOutClk) {
      inputFile_pcOutput.current.click();
      setPcOutClk(false);
    } else if (reportClk) {
      setIsReportOutputOpen(true);
      setReportClk(false);
    } else if (csvClk) {
      setIsReportOutputOpen(true);
      setCsvClk(false);
    }

    if (clickMenu === '1') {
      setActivePartMenu('1');
      navigate(':estimate.parent');
      props?.updateActiveTabKey('1');
    } else if (clickMenu === '2') {
      setActivePartMenu('2');
      navigate(':estimate.iq3');
      props?.updateActiveTabKey('2');
    } else if (clickMenu === '3') {
      setActivePartMenu('3');
      navigate(':estimate.iq5');
      props?.updateActiveTabKey('3');
    }
  };

  const discardConfirmCancel = () => {
    setConfirmScreenChangeModalOpen(false);
    setConfirmDisplayDataSaveModalOpen(false);
    setClickPMX(false);
    // setClickAddNewModal(false);
  };
  const updateMainEstimateEditMode = (mode) => {
    setEditMode(mode);
    props.updateEstimateEditMode(mode);
  };

  const partMenuChange = (e) => {
    setClickMenu(e);
    // 親部品情報に変更があった場合、再計算ボタンを赤色にする。
    let differences = false;
    let beforeParentTabObj = props?.selectedEstimateDataBeforeParentTab;
    let afterParentTabObj = props?.selectedEstimateData;
    if (parentInfoChangeFlg !== undefined && !parentInfoChangeFlg) {
      differences = compareParentInfo(beforeParentTabObj, afterParentTabObj);
      if (differences) {
        setParentInfoChangeFlg(true);
      } else {
        setParentInfoChangeFlg(false);
      }
    }
    if (editMode) {
      setConfirmScreenChangeModalOpen(true);
    } else {
      setConfirmScreenChangeModalOpen(false);
      if (e === '1') {
        setNavigateTabName('parent');
        navigate(':estimate.parent');
        setActivePartMenu(e);
      } else if (e === '2') {
        setNavigateTabName('sheetMetal');
        setActivePartMenu(e);
        navigate(':estimate.iq3');
      } else if (e === '3') {
        setNavigateTabName('beams');
        setActivePartMenu(e);
        navigate(':estimate.iq5');
      }
      props?.updateActiveTabKey(e);
    }
    props.updateSelectedEstimateData(props.selectedEstimateData);
    setSelectedEstimateData(props.selectedEstimateData);
    props?.updateCreateNewEvent(false);
  };

  const updateClickMenu = () => {
    setClickMenu('');
  };

  const updateParentInfoChange = (flg) => {
    setParentInfoChangeFlg(flg);
  };

  const updateParentQuantityChange = (flg) => {
    setParentQuantityChangeFlg(flg);
  };

  // 2025-05-15 数量や粗利係数などを直接左側の画面から変更できない。
  const updateEstimateBasicInfoChangedFlg = (flg) => {
    setEstimateBaseInfoChangedFlg(flg);
  };

  // 帳票出力
  const reportOutputChangeEvent = async (e) => {
    // IQX_WEBEST-365 クイック印刷機能が実装していない。
    let printOutputsInfo = await fetchIndividualData(); // Call the async function
    if (printOutputsInfo?.isUseQuickOutput) {
      reportOutputOk(printOutputsInfo?.printOutputFormat, printOutputsInfo?.isUseQuickOutput);
    } else {
      setIsReportOutputOpen(true);
      setChildTitle('親部品帳票');
    }
  };

  // 再計算
  const calEstimateDataEvent = (e) => {
    setCalClk(true);
    if (editMode) {
      setConfirmScreenChangeModalOpen(true);
    } else {
      setConfirmDisplayDataSaveModalOpen(true);
    }
  };

  const estimateNewDataSaveEvent = () => {
    setNavigateTabName('');
    //setCreateConfirm(true);
    setCreateConfirm(props?.userSettingInfo?.[0]?.massages?.editOk);
    if (!props?.userSettingInfo?.[0]?.massages?.editOk) {
      createOk();
    }
  };
  // 別名保存・上書き保存
  const estimateDataSaveEvent = async (e) => {
    setSaveClk(true);
    setSelectedSaveMenuKey(e.key);
    if (editMode) {
      setConfirmScreenChangeModalOpen(true);
      return;
    }
    if (e.key === saveMenuChildItems[0].key) {
      setIsSaveByOtherName(true);
      /* setIsSaveByOtherName(props?.userSettingInfo?.[0]?.massages?.editOk);
      if (!props?.userSettingInfo?.[0]?.massages?.editOk) {
        saveByOtherNameOk();
      } */
      // setInputDrawingNo(formatDateString(todayTime()));
      let currentEstimateData = parentEstimateRef?.current?.getParentEstimateInfo();
      const data = JSON.parse(JSON.stringify(currentEstimateData));
      setEstimateNo(data?.estimateProducts?.estimateNo + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
      setInputDrawingNo(data?.estimateProducts?.drawingNo + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
      setParentEstimateName(data?.estimateProducts?.name + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
    } else {
      //setIsSaveByOverwrite(true);
      setIsSaveByOverwrite(props?.userSettingInfo?.[0]?.massages?.editOk);
      if (!props?.userSettingInfo?.[0]?.massages?.editOk) {
        saveByOverwriteOk();
      }
    }

    // setIsEstimateDataSaveConfirm(true);
    setChildTitle('確認');
  };

  const childModalTitle = (
    <div
      style={{
        width: 1490,
        backgroundColor: '#005fab',
        // marginLeft: isPMXCloudFileDialogOpen ? -10 : -24,
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>PMX取り込み</p>
    </div>
  );

  const dxfModalTitle = (
    <div
      style={{
        width: 1490,
        backgroundColor: '#005fab',
        // marginLeft: isPMXCloudFileDialogOpen ? -10 : -24,
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>DXF取り込み</p>
    </div>
  );

  const updateOk = () => {
    setIsPMXProcessPatternOpen(false);
    setClickPMX(false);
    setIsPMXCloudFileDialogOpen(false);
  };

  const updateCancel = () => {
    setIsPMXProcessPatternOpen(false);
    setClickPMX(false);
    setIsPMXCloudFileDialogOpen(false);
  };

  const cancelPMXImport = () => {
    setIsPMXProcessPatternOpen(false);
    setClickPMX(false);
  };
  const nextProcessPattern = () => {
    setIsPrepareInfo(true);
    setIsNext(true);
    setCurrentStep(currentStep + 1);
  };

  const dxfCancel = () => {
    setIsCreatePMX();
    setIsDXFPrepareInfo(false);
    setCurrentDXFStep(0);
    setIsDXFNext(false);
    setIsDXFNextIQ3(false);
    setDxfUpDataLst([]);
    setIsDXFProcessPatternOpen(false);
  };

  const backDXFProcessPattern = () => {
    if (isDXFNextIQ3) {
      setIsDXFNext(true);
      setCurrentDXFStep(1);
      setIsDXFNextIQ3(false);
    } else {
      setIsDXFFileUpload(true);
      setCurrentDXFStep(0);
      setIsDXFNext(false);
      setIsDXFNextIQ3(false);
    }
  };

  const nextDXFProcessPattern = () => {
    if (!dxfUpDataLst || dxfUpDataLst.length === 0) {
      error('DXFファイルをアップロードしてください。');
    } else {
      if (isDXFNext) {
        setCurrentDXFStep(2);
        setIsDXFNext(false);
        setIsDXFNextIQ3(true);
      } else {
        setCurrentDXFStep(1);
        setIsDXFNextIQ3(false);
        setIsDXFNext(true);
        setIsDXFFileUpload(false);
      }
      // setIsPrepareInfo(true);
      setIsDXFFileUpload(false);
      // setIsDXFNext(true);
    }
  };
  // ブランクの種類.形状により、データ設定
  const getSize = (id, size) => {
    return id === 3 || id === 4 ? toDecimal(size || 0, 2) : toDecimal(0, 2);
  };
  const getDiameter = (id, xl) => {
    return id <= 2 ? toDecimal(parseFloat(xl) || 0, 2) : toDecimal(0, 2);
  };

  // PMX取り込みの完了ボタン押下
  const completePMX = () => {
    if (isDXFProcessPatternOpen) {
      uploadDXFDataFile(dxfUpDataLst);
    } else {
      setIq3DataConfirm(noIq3);
      if (!noIq3) {
        completePMXData(selectedCardData, selectedPMXEstimateData);
      }
    }

    // 2025-05-26 ローカルPMXファイル読み込み
    setCurrentPMXMenu(null);
  };

  const modalCompletePMXData = async () => {
    completePMXData(selectedCardData, selectedPMXEstimateData);
  };

  const completePMXData = async (selectedCardData, selectedPMXEstimateData) => {
    setIsPMXCloudFileDialogOpen(false);
    setIsPMXProcessPatternOpen(false);
    setIq3DataConfirm(noIq3);
    props?.loading(true); // Waitingダイアログを表示にする
    let processMst = selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.process;
    let bendingTypes = [];
    let weldingTypes = [];
    let subWeldingTypes = [];
    let secWorkTypes = [];
    const bendingDetails = processMst?.filter((i) => i.workType === WorkType.SmBending);
    if (bendingDetails?.length > 0) {
      bendingTypes = bendingDetails[0]?.details?.processDetailTypes?.filter((i) => i.isUsed);
    }
    const weldingDetails = processMst?.filter((i) => i.workType === WorkType.SmWelding);
    if (weldingDetails?.length > 0) {
      weldingTypes = weldingDetails[0].details?.processDetailTypes?.filter(
        (i) => i.group === WorkTypeGroup.SmWelding && i.isUsed
      );

      subWeldingTypes = weldingDetails[0].details?.processDetailTypes?.filter(
        (i) => (i.group === WorkTypeGroup.SmInstSize && i.isUsed) || (i.group === WorkTypeGroup.SmInstThick && i.isUsed)
      );
    }
    const secWorkDetails = processMst?.filter((i) => i.workType === WorkType.SmSecondaryWork);
    if (secWorkDetails?.length > 0) {
      secWorkTypes = secWorkDetails[0].details?.processDetailTypes?.filter(
        (i) =>
          (i.group === WorkTypeGroup.SmSecondaryWorkSize && i.isUsed) ||
          (i.group === WorkTypeGroup.SmSecondaryWorkMillimeter && i.isUsed)
      );
    }
    // IQX_WEBEST-272 PMX取込時にPMXの付加情報を見積に反映させてほしい
    const customerInfo = selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.client;
    selectedPMXEstimateData.estimateProducts.name = selectedCardData?.name;
    selectedPMXEstimateData.estimateProducts.drawingNo = selectedCardData?.drawingNo;
    let customerNm = customerInfo?.filter((item) => item?.info?.isUsed && item?.name === selectedCardData?.customer);
    if (selectedCardData?.customer == '') {
      customerNm = customerInfo;
    }
    if (customerNm?.length > 0) {
      selectedPMXEstimateData.estimateProducts.clientName = customerNm?.[0]?.name;
      selectedPMXEstimateData.estimateProducts.clientId = customerNm?.[0]?.id;
    } else {
      if (customerInfo?.length > 0) {
        selectedPMXEstimateData.estimateProducts.clientName = customerInfo?.[0]?.name;
        selectedPMXEstimateData.estimateProducts.clientId = customerInfo?.[0]?.id;
      }
    }

    // IQ3　板金
    // selectedPMXEstimateData.esIq3Info = selectedPMXEstimateData.esIq3Info.filter((_, i) => {
    //   const detail = selectedCardData.details[i];
    //   return detail && detail.type === 'SheetMetal';
    // });

    const filteredData = selectedPMXEstimateData.esIq3Info.filter((_, i) => {
      const detail = selectedCardData.details[i];
      return detail && detail.type === 'SheetMetal';
    });

    if (filteredData.length > 0) {
      selectedPMXEstimateData.esIq3Info = filteredData;

      selectedPMXEstimateData.esIq3Info?.forEach((item, index) => {
        item.no = index + 1;
      });

      let IO3SelectedCardDataDetails = selectedCardData?.details?.filter((item) => item.type === 'SheetMetal');

      for (let i = 0; i < selectedPMXEstimateData?.esIq3Info?.length; i++) {
        let cardMainDataDetails = IO3SelectedCardDataDetails?.[i];

        let cardDetails = cardMainDataDetails?.processingInfo ? JSON.parse(cardMainDataDetails?.processingInfo) : {};

        // 基本情報設定
        if (cardMainDataDetails?.thumbPath !== undefined) {
          // 画像取得
          const imageData = [
            props?.hubConnectionToken,
            cardMainDataDetails.thumbPath,
            // process.env.REACT_APP_AUDI_FILE_UPLOAD_URL + '\\' + cad3dFileName,
          ];
          let iq3PmxImg = await getImageURL(imageData);

          // let iq3PmxImg = await getCardDetailImg(cardMainDataDetails?.id);
          if (iq3PmxImg !== undefined) {
            // IQX_WEBEST-207
            selectedPMXEstimateData.esIq3Info[i].imageId = cardMainDataDetails.thumbPath;
            selectedPMXEstimateData.esIq3Info[i]['imageUrl'] =
              iq3PmxImg === 'fail' ? iq3PmxImg : `data:image/png;base64,${iq3PmxImg}`;
          } else {
            selectedPMXEstimateData.esIq3Info[i].imageId = '';
          }
        }

        if (cardDetails?.contourLength?.outerCadItems !== undefined) {
          let outerCadItems = cardDetails?.contourLength?.outerCadItems;
          selectedPMXEstimateData.esIq3Info[i]['outerCadItems'] = outerCadItems;
        }

        selectedPMXEstimateData.esIq3Info[i].partCount = cardMainDataDetails?.quantity;
        selectedPMXEstimateData.esIq3Info[i].drawingNo = cardMainDataDetails?.drawingNo;
        selectedPMXEstimateData.esIq3Info[i].name = cardMainDataDetails?.name;
        // let pmxMaterialNm = cardMainDataDetails?.material;
        const __pmxRaw = ((cardMainDataDetails && (cardMainDataDetails.material ?? cardMainDataDetails.Material)) || '').trim();
        let __hasMaterialTypeMap = false;
        if (__pmxRaw) {
        const __m = __pmxRaw.match(/^[^_]*_(.+)$/);
          const __key = __m ? __m[1].trim() : null;
          if (__m) {
            const __mtList = selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.materialTypeIq3;
            const __mt = __mtList?.find((t) => (t.name || '').trim() === __key);
            if (__mt) {
              selectedPMXEstimateData.esIq3Info[i].materialTypeIq3Id = __mt.id;
              selectedPMXEstimateData.esIq3Info[i].materialTypeName = __mt.name;
              __hasMaterialTypeMap = true;
            } else {
            }
          }
        }
        let pmxThickness = cardDetails?.thickness;
        // 材料リスト
        let materialList = selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.materialIq3;
        let materialSurfaceLst =
          selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.materialSurfaceIq3;
        let materialNm = materialList?.filter((item) => item.info?.thick === pmxThickness && item.info.isUsed);

        let materialTypeList = selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.materialTypeIq3;
        let materialSurfaceList =
          selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.materialSurfaceIq3;
        let gravity = 0.0;
        const __g = materialList?.find(
          (item) => item.materialTypeIq3Id === selectedPMXEstimateData?.esIq3Info?.[i]?.materialTypeIq3Id
        );
        gravity = __g?.info?.gravity ?? 0.0;

        //　面積・重量設定
        //重量(kg) = 板厚(mm) X Xサイズ(mm) X Yサイズ(mm) ÷ 1000000 X 比重(g/㎤)
        let sizeX = cardDetails?.boundaryBoxSize?.width
          ? toDecimal(cardDetails?.boundaryBoxSize?.width, 2)
          : toDecimal(0, 2);
        let sizeY = cardDetails?.boundaryBoxSize?.height
          ? toDecimal(cardDetails?.boundaryBoxSize?.height, 2)
          : toDecimal(0, 2);

        const thicknessInfo = materialList?.find(
          (item) => item.materialTypeIq3Id === selectedPMXEstimateData?.esIq3Info?.[i]?.materialTypeIq3Id
        );
        let thicknessVal = 0;
        if (thicknessInfo != undefined) {
          thicknessVal = parseFloat(thicknessInfo?.info?.thick);
        }
        let weight = ((thicknessVal * parseInt(sizeX) * parseInt(sizeY)) / 1000000) * gravity;
        let reCalArea = Number.isFinite((sizeX * sizeY) / 100) ? (sizeX * sizeY) / 100 : toDecimal(0, 2);
        // IQX_WEBEST-84(Cardの面積(mm)をcmに変換)
        let cardDetailsArea = Number.isFinite(cardDetails?.area / 100) ? cardDetails?.area / 100 : reCalArea;
        cardDetailsArea = cardDetailsArea ? toDecimal(cardDetailsArea, 2) : toDecimal(0, 2);

        selectedPMXEstimateData.esIq3Info[i].partSizeX = sizeX;
        selectedPMXEstimateData.esIq3Info[i].partSizeY = sizeY;
        selectedPMXEstimateData.esIq3Info[i].totalSurfaceArea = cardDetailsArea;
        if (sizeX && sizeY && weight) {
          selectedPMXEstimateData.esIq3Info[i].weight = Number.isFinite(weight) ? weight : toDecimal(0, 2);
        }

        //板金子部品より親部品の重量と面積データ更新
        if (selectedPMXEstimateData?.esIq3Info[i]?.weight) {
          selectedPMXEstimateData.estimateProducts.totalWeight += selectedPMXEstimateData?.esIq3Info[i]?.weight
            ? selectedPMXEstimateData?.esIq3Info[i]?.weight
            : 0;
        }
        if (selectedPMXEstimateData?.esIq3Info[i]?.totalSurfaceArea) {
          selectedPMXEstimateData.estimateProducts.totalSurfaceArea += selectedPMXEstimateData?.esIq3Info[i]
            ?.totalSurfaceArea
            ? Number(selectedPMXEstimateData?.esIq3Info[i]?.totalSurfaceArea)
            : 0.0;
        }
        // 会社環境設定情報取得
        let companySettingInfo = settingInfo;
        //工程入力情報設定
        let updateProcessInputs = [];
        let processInputs = JSON.parse(JSON.stringify(selectedPMXEstimateData?.esIq3Info[i]?.processInput));
        for (let j = 0; j < processInputs?.length; j++) {
          let curWorkType = processMst?.filter((item) => item.id == processInputs[j].processId)?.[0]?.workType;
          // IQX_WEBEST-179
          processInputs[j].autoExtractXSize = sizeX ? Number(sizeX) : 0;
          processInputs[j].autoExtractYSize = sizeY ? Number(sizeY) : 0;
          if (curWorkType === WorkType.SmProgram) {
            let programProcessInput = processInputs[j];
            let cadDetailLen = cardDetails?.elements;
            // ブランク加工下穴計算有がONの場合、2次加工の個数をカウントする
            // ブランク加工下穴計算有情報取得
            let isBlankDrillingCalculation = companySettingInfo?.[0]?.environments?.isBlankDrillingCalculation;
            if (isBlankDrillingCalculation) {
              let secondaryWorkCnt = cardDetails?.burringTappings?.length;
              secondaryWorkCnt = secondaryWorkCnt ? secondaryWorkCnt : 0;
              cadDetailLen = cadDetailLen + secondaryWorkCnt;
            }
            programProcessInput.details[0].elements = cadDetailLen;
            programProcessInput.details[0].elementsAuto = cadDetailLen; // IQX_WEBEST-179
            updateProcessInputs.push(programProcessInput);
          } else if (
            curWorkType === WorkType.SmBlankCombi ||
            curWorkType === WorkType.SmBlankLaser ||
            curWorkType === WorkType.SmBlankPunch
          ) {
            // 空送線計算有情報取得
            let isAirLineCalculationFlg = companySettingInfo?.[0]?.environments?.isAirLineCalculation;

            let blankProcessInput = processInputs[j];
            blankProcessInput.details[0].dimensionData.outerDia = cardDetails?.contourLength?.outerLength
              ? toDecimal(cardDetails?.contourLength?.outerLength, 2)
              : toDecimal(0, 2);
            blankProcessInput.details[0].dimensionData.innerDia = cardDetails?.contourLength?.innerLength
              ? toDecimal(cardDetails?.contourLength?.innerLength, 2)
              : toDecimal(0, 2);
            // 空送線計算有にチェックありの場合、空送線長で計算する
            if (isAirLineCalculationFlg) {
              blankProcessInput.details[0].dimensionData.airFeedDistance = cardDetails?.airDistance
                ? toDecimal(cardDetails?.airDistance, 2)
                : toDecimal(0, 2);
              blankProcessInput.details[0].dimensionData.airFeedAutoExtract = cardDetails?.airDistance
                ? toDecimal(cardDetails?.airDistance, 2)
                : toDecimal(0, 2);
            } else {
              // 空送線計算有にチェック無しの場合、空送線長で計算しない。
              blankProcessInput.details[0].dimensionData.airFeedDistance = toDecimal(0, 2);
              blankProcessInput.details[0].dimensionData.airFeedAutoExtract = toDecimal(0, 2);
            }
            blankProcessInput.details[0].dimensionData.etchingLength = cardDetails?.etchingLength
              ? toDecimal(cardDetails?.etchingLength, 2)
              : toDecimal(0, 2);
            // IQX_WEBEST-179
            blankProcessInput.details[0].dimensionData.outerAutoExtract = cardDetails?.contourLength?.outerLength
              ? toDecimal(cardDetails?.contourLength?.outerLength, 2)
              : toDecimal(0, 2);
            blankProcessInput.details[0].dimensionData.innerAutoExtract = cardDetails?.contourLength?.innerLength
              ? toDecimal(cardDetails?.contourLength?.innerLength, 2)
              : toDecimal(0, 2);

            let qtyLen = blankProcessInput.details[0].quantityList?.length;
            if (cardDetails?.contourLength?.holes?.length > 0) {
              blankProcessInput.details[0].quantityList.shift();
              for (let k = 0; k < cardDetails?.contourLength?.holes?.length; k++) {
                if (cardDetails?.contourLength?.holes?.[k]?.name === 'HOLE') continue;
                let typeId = Types?.filter((item) => item.value === 'その他')?.[0]?.id;
                let holdType = BlankTypes?.filter(
                  (item) => item.value === cardDetails?.contourLength?.holes?.[k]?.name
                )?.[0]?.label;
                let blanktypes = Types?.filter((item) => item.value === holdType)?.[0];
                if (blanktypes) {
                  typeId = blanktypes?.id;
                }
                const hold = cardDetails?.contourLength?.holes?.[k];
                // console.log(
                //   '穴情報 --' +
                //     hold?.name +
                //     '(' +
                //     holdType +
                //     ')' +
                //     ', ' +
                //     hold?.xl +
                //     ',  周長 --' +
                //     toDecimal(hold?.length / hold?.number, 2)
                // );
                const newListRow = {
                  id: k + 1 + qtyLen,
                  types: typeId,
                  typesAutoExtract: typeId,
                  diameter: getDiameter(typeId, hold?.xl),
                  diameterAutoExtract: getDiameter(typeId, hold?.xl),
                  xsize: getSize(typeId, hold?.xl),
                  xsizeAutoExtract: getSize(typeId, hold?.xl),
                  ysize: getSize(typeId, hold?.yl),
                  ysizeAutoExtract: getSize(typeId, hold?.yl),
                  perimeter: hold?.length && hold?.number ? toDecimal(hold?.length / hold?.number, 2) : toDecimal(0, 2),
                  perimeterAutoExtract:
                    hold?.length && hold?.number ? toDecimal(hold?.length / hold?.number, 2) : toDecimal(0, 2),
                  count: hold?.number,
                  countAutoExtract: hold?.number,
                  combinedBorderLines: hold?.combinedBorderLines,
                };
                blankProcessInput.details[0].quantityList?.push(newListRow);
              }
            } else {
              blankProcessInput.details[0].quantityList[0].types = 1;
              blankProcessInput.details[0].quantityList[0].typesAutoExtract = 1;
              blankProcessInput.details[0].quantityList[0].diameter = toDecimal(0, 2);
              blankProcessInput.details[0].quantityList[0].diameterAutoExtract = toDecimal(0, 2);
              blankProcessInput.details[0].quantityList[0].xsize = toDecimal(0, 2);
              blankProcessInput.details[0].quantityList[0].xsizeAutoExtract = toDecimal(0, 2);
              blankProcessInput.details[0].quantityList[0].ysize = toDecimal(0, 2);
              blankProcessInput.details[0].quantityList[0].ysizeAutoExtract = toDecimal(0, 2);
              blankProcessInput.details[0].quantityList[0].perimeter = toDecimal(0, 2);
              blankProcessInput.details[0].quantityList[0].perimeterAutoExtract = toDecimal(0, 2);
              blankProcessInput.details[0].quantityList[0].count = 1;
              blankProcessInput.details[0].quantityList[0].countAutoExtract = 1;
              blankProcessInput.details[0].quantityList[0].combinedBorderLines = [];
            }
            updateProcessInputs.push(blankProcessInput);
          } else if (curWorkType === WorkType.SmBending) {
            let bendProcessInput = processInputs[j];
            const maxBendLength = cardDetails?.bendInfo
              ? cardDetails?.bendInfo?.reduce((max, item) => {
                  return item.width > max ? item.width : max;
                }, 0)
              : 0; // IQX_WEBEST-84
            bendProcessInput.details[0].bendingData.maxBendLength = maxBendLength
              ? toDecimal(maxBendLength, 2)
              : toDecimal(0, 2);
            // IQX_WEBEST-179
            bendProcessInput.details[0].bendingData.maxBendAutoExtract = maxBendLength
              ? toDecimal(maxBendLength, 2)
              : toDecimal(0, 2);
            let bendLen = bendProcessInput.details[0].bendingList?.length;
            if (cardDetails?.bendInfo?.length > 0) {
              bendProcessInput?.details[0]?.bendingList?.shift();
              for (let k = 0; k < cardDetails?.bendInfo?.length; k++) {
                const bend = cardDetails?.bendInfo[k];

                let typeId = bendingTypes?.[0]?.id;

                let bendId = BendingTypes?.filter((itemType) => itemType.value === bend?.name)?.[0]?.id;
                let result = bendingTypes?.filter((subWeldItem) => subWeldItem.id === bendId)?.[0];

                if (result) {
                  typeId = result?.id;
                }

                const newListRow = {
                  id: k + 1 + bendLen,
                  types: typeId,
                  typesAutoExtract: typeId,
                  bendLength: bend?.width ? toDecimal(bend?.width, 2) : toDecimal(0, 2),
                  bendLengthAutoExtract: bend?.width ? toDecimal(bend?.width, 2) : toDecimal(0, 2),
                  lines: bend?.number, // 曲げ回数（曲げ線数）// IQX_WEBEST-210
                  linesAutoExtract: bend?.number, // 曲げ回数（曲げ線数）// IQX_WEBEST-210
                  bendCount: bend?.name === FRBend ? bend?.amount : 1, // FR曲げ回数
                  bendCountAutoExtract: bend?.name === FRBend ? bend?.amount : 1, // FR曲げ回数
                };
                bendProcessInput?.details[0]?.bendingList?.push(newListRow);
              }
            } else {
              bendProcessInput.details[0].bendingList[0].types = 1;
              bendProcessInput.details[0].bendingList[0].typesAutoExtract = 1;
              bendProcessInput.details[0].bendingList[0].bendLength = toDecimal(0, 2);
              bendProcessInput.details[0].bendingList[0].bendLengthAutoExtract = toDecimal(0, 2);
              bendProcessInput.details[0].bendingList[0].lines = 1;
              bendProcessInput.details[0].bendingList[0].linesAutoExtract = 1;
              bendProcessInput.details[0].bendingList[0].bendCount = 1;
              bendProcessInput.details[0].bendingList[0].bendCountAutoExtract = 1;
            }
            updateProcessInputs.push(bendProcessInput);
          } else if (curWorkType === WorkType.SmWelding) {
            let weldProcessInput = processInputs?.[j];

            let weldLen = weldProcessInput?.details?.[0].weldingList?.length;
            if (cardDetails?.weldInfo?.length > 0) {
              weldProcessInput?.details?.[0]?.weldingList?.shift();
              for (let k = 0; k < cardDetails?.weldInfo?.length; k++) {
                const weld = cardDetails?.weldInfo?.[k];
                let typeId = weldingTypes?.[0]?.id;
                let weldId = weld?.weldType + 1;
                const result = weldingTypes?.find((weldItem) => {
                  return weldItem.id === weldId && weldItem.isUsed;
                });
                if (result) {
                  typeId = result?.id;
                }

                const newListRow = {
                  id: k + 1 + weldLen,
                  yousetsuType: typeId,
                  yousetsuTypeAutoExtract: typeId,
                  senchou: weld?.length ? toDecimal(weld?.length, 2) : toDecimal(0, 2), //連続/タップ溶接の長さ // IQX_WEBEST-193
                  senchouAutoExtract: weld?.length ? toDecimal(weld?.length, 2) : toDecimal(0, 2), //連続/タップ溶接の長さ // IQX_WEBEST-193
                  senchouKaisu: weld?.number ? weld?.number : 1, // 連続/タップ回数 // IQX_WEBEST-193
                  senchouKaisuAutoExtract: weld?.number ? weld?.number : 1, // 連続/タップ回数 // IQX_WEBEST-193
                  senchouYousetsushiage: 0,
                  senchouYousetsushiageAutoExtract: 0,
                  total1: weld?.length && weld?.number ? toDecimal(weld?.length * weld?.number, 2) : toDecimal(0, 2), // IQX_WEBEST-193

                  karitsukeCnt: weld?.tackLocations ? parseInt(weld?.tackLocations) : 0, // 仮付箇所数 // IQX_WEBEST-193
                  karitsukeCntAutoExtract: weld?.tackLocations ? parseInt(weld?.tackLocations) : 0, // 仮付箇所数 // IQX_WEBEST-193
                  karitsukeKaisu: weld?.tackNumber ? parseInt(weld?.tackNumber) : 1, // 仮付回数 // IQX_WEBEST-193
                  karitsukeKaisuAutoExtract: weld?.tackNumber ? parseInt(weld?.tackNumber) : 1, // 仮付回数 // IQX_WEBEST-193
                  karitsukeYousetsushiage: 0,
                  karitsukeYousetsushiageAutoExtract: 0,
                  total2:
                    weld?.tackLocations && weld?.tackNumber ? parseInt(weld?.tackLocations * weld?.tackNumber) : 0, // IQX_WEBEST-193
                };
                weldProcessInput?.details[0]?.weldingList?.push(newListRow);
              }
            } else {
              weldProcessInput.details[0].weldingList[0].yousetsuType = weldingTypes?.[0]?.id;
              weldProcessInput.details[0].weldingList[0].yousetsuTypeAutoExtract = weldingTypes?.[0]?.id;
              weldProcessInput.details[0].weldingList[0].senchou = toDecimal(0, 2);
              weldProcessInput.details[0].weldingList[0].senchouAutoExtract = toDecimal(0, 2);
              weldProcessInput.details[0].weldingList[0].senchouKaisu = 1;
              weldProcessInput.details[0].weldingList[0].senchouKaisuAutoExtract = 1;
              weldProcessInput.details[0].weldingList[0].senchouYousetsushiage = 0;
              weldProcessInput.details[0].weldingList[0].senchouYousetsushiageAutoExtract = 0;
              weldProcessInput.details[0].weldingList[0].total1 = toDecimal(0, 2);

              weldProcessInput.details[0].weldingList[0].karitsukeCnt = 0;
              weldProcessInput.details[0].weldingList[0].karitsukeCntAutoExtract = 0;
              weldProcessInput.details[0].weldingList[0].karitsukeKaisu = 1;
              weldProcessInput.details[0].weldingList[0].karitsukeKaisuAutoExtract = 1;
              weldProcessInput.details[0].weldingList[0].karitsukeYousetsushiage = 0;
              weldProcessInput.details[0].weldingList[0].karitsukeYousetsushiageAutoExtract = 0;
              weldProcessInput.details[0].weldingList[0].total2 = 0;
            }
            // サプ溶接種類
            let subWeldLen = weldProcessInput?.details?.[0]?.subWeldingList?.length;
            if (cardDetails?.subWeldInfo?.length > 0) {
              weldProcessInput?.details?.[0]?.subWeldingList?.shift();
              for (let k = 0; k < cardDetails?.subWeldInfo?.length; k++) {
                const subWeld = cardDetails?.subWeldInfo?.[k];
                let typeId = subWeldingTypes?.[0]?.id;
                let typeGroup = subWeldingTypes?.[0]?.group;
                // ***
                let subWeldType = SubWeldTypes?.filter(
                  (itemTyp) => itemTyp.value === cardDetails?.subWeldInfo?.[k]?.name
                )?.[0]?.id;
                let result = subWeldingTypes?.filter((subWeldItem) => subWeldItem.id == subWeldType)?.[0];

                if (result) {
                  typeId = result?.id;
                  typeGroup = result?.group;
                }

                const newListRow = {
                  id: k + 1 + subWeldLen,
                  subWeldingType: typeId,
                  subWeldingTypeAutoExtract: typeId,
                  daimeter: subWeld?.xl ? toDecimal(subWeld?.xl, 2) : toDecimal(0, 2),
                  daimeterAutoExtract: subWeld?.xl ? toDecimal(subWeld?.xl, 2) : toDecimal(0, 2),
                  number: subWeld?.number ? toDecimal(subWeld?.number, 2) : toDecimal(0, 2),
                  numberAutoExtract: subWeld?.number ? toDecimal(subWeld?.number, 2) : toDecimal(0, 2),
                  count: 1,
                  countAutoExtract: 1,
                  yousetsushiage: 0,
                  total: subWeld?.xl && subWeld?.number ? toDecimal(subWeld?.xl * subWeld?.number, 2) : toDecimal(0, 2), // IQX_WEBEST-208
                  subWeldingGroupType: typeGroup,
                  subWeldingGroupTypeAutoExtract: typeGroup,
                };
                weldProcessInput.details[0].subWeldingList.push(newListRow);
              }
            } else {
              weldProcessInput.details[0].subWeldingList[0].subWeldingType = subWeldingTypes?.[0]?.id;
              weldProcessInput.details[0].subWeldingList[0].subWeldingTypeAutoExtract = subWeldingTypes?.[0]?.id;
              (weldProcessInput.details[0].subWeldingList[0].daimeter = toDecimal(0, 2)),
                (weldProcessInput.details[0].subWeldingList[0].daimeterAutoExtract = toDecimal(0, 2)),
                (weldProcessInput.details[0].subWeldingList[0].number = toDecimal(0, 2)),
                (weldProcessInput.details[0].subWeldingList[0].numberAutoExtract = toDecimal(0, 2)),
                (weldProcessInput.details[0].subWeldingList[0].count = 1),
                (weldProcessInput.details[0].subWeldingList[0].countAutoExtract = 1),
                (weldProcessInput.details[0].subWeldingList[0].yousetsushiage = 0),
                (weldProcessInput.details[0].subWeldingList[0].total = toDecimal(0, 2));
              weldProcessInput.details[0].subWeldingList[0].subWeldingGroupType = subWeldingTypes?.[0]?.group;
              weldProcessInput.details[0].subWeldingList[0].subWeldingGroupTypeAutoExtract =
                subWeldingTypes?.[0]?.group;
            }

            updateProcessInputs.push(weldProcessInput);
          } else if (curWorkType === WorkType.SmSecondaryWork) {
            let secWorkProcessInput = processInputs[j];
            let secWorkLen = secWorkProcessInput?.details?.length;
            if (cardDetails?.burringTappings?.length > 0) {
              secWorkProcessInput?.details?.shift();
              for (let k = 0; k < cardDetails?.burringTappings?.length; k++) {
                const secWork = cardDetails?.burringTappings?.[k];
                let typeId = secWorkTypes?.[0]?.id;
                let typeGroup = secWorkTypes?.[0]?.group;
                // ***
                let secWorkType = SecondaryWorkTypes?.filter(
                  (itemType) => itemType.value === cardDetails?.burringTappings?.[k]?.name
                )?.[0]?.id;
                let result = secWorkTypes?.filter((subWeldItem) => subWeldItem.id == secWorkType)?.[0];

                if (result) {
                  typeId = result?.id;
                  typeGroup = result?.group;
                }

                const newListRow = {
                  id: k + 1 + secWorkLen,
                  types: typeId,
                  typesAutoExtract: typeId,
                  diameter: secWork?.size ? toDecimal(secWork?.size, 2) : toDecimal(0, 2),
                  diameterAutoExtract: secWork?.size ? toDecimal(secWork?.size, 2) : toDecimal(0, 2),
                  xsize: secWork?.cp?.x ? toDecimal(secWork?.cp?.x, 2) : toDecimal(0, 2),
                  xsizeAutoExtract: secWork?.cp?.x ? toDecimal(secWork?.cp?.x, 2) : toDecimal(0, 2),
                  ysize: secWork?.cp?.y ? toDecimal(secWork?.cp?.y, 2) : toDecimal(0, 2),
                  ysizeAutoExtract: secWork?.cp?.y ? toDecimal(secWork?.cp?.y, 2) : toDecimal(0, 2),
                  perimeter: toDecimal(0, 2),
                  perimeterAutoExtract: toDecimal(0, 2),
                  count: secWork?.number ? Number(secWork?.number) : 1, // IQX_WEBEST-209
                  countAutoExtract: secWork?.number ? Number(secWork?.number) : 1, // IQX_WEBEST-209
                  blankFlag: false,
                  blankFlagAutoExtract: false,
                  workTypeGroup: typeGroup,
                  workTypeGroupAutoExtract: typeGroup,
                };
                secWorkProcessInput.details.push(newListRow);
              }
            } else {
              secWorkProcessInput.details[0].types = secWorkTypes?.[0]?.id;
              secWorkProcessInput.details[0].typesAutoExtract = secWorkTypes?.[0]?.id;
              secWorkProcessInput.details[0].diameter = toDecimal(0, 2);
              secWorkProcessInput.details[0].diameterAutoExtract = toDecimal(0, 2);
              secWorkProcessInput.details[0].xsize = toDecimal(0, 2);
              secWorkProcessInput.details[0].xsizeAutoExtract = toDecimal(0, 2);
              secWorkProcessInput.details[0].ysize = toDecimal(0, 2);
              secWorkProcessInput.details[0].ysizeAutoExtract = toDecimal(0, 2);
              secWorkProcessInput.details[0].perimeter = toDecimal(0, 2);
              secWorkProcessInput.details[0].perimeterAutoExtract = toDecimal(0, 2);
              secWorkProcessInput.details[0].count = 1;
              secWorkProcessInput.details[0].countAutoExtract = 1;
              secWorkProcessInput.details[0].blankFlag = false;
              secWorkProcessInput.details[0].blankFlagAutoExtract = false;
              secWorkProcessInput.details[0].workTypeGroup = secWorkTypes?.[0]?.group;
              secWorkProcessInput.details[0].workTypeGroupAutoExtract = secWorkTypes?.[0]?.group;
            }
            updateProcessInputs.push(secWorkProcessInput);
          } else if (curWorkType === WorkType.SmDeburringAuto) {
            let autoDeburProcessInput = processInputs[j];
            autoDeburProcessInput.details[0].area = cardDetailsArea;
            autoDeburProcessInput.details[0].areaAutoExtract = cardDetailsArea; // IQX_WEBEST-179
            // if (weight) {
            autoDeburProcessInput.details[0].weight = Number.isFinite(weight) ? toDecimal(weight, 2) : toDecimal(0, 2);
            autoDeburProcessInput.details[0].weightAutoExtract = Number.isFinite(weight)
              ? toDecimal(weight, 2)
              : toDecimal(0, 2); // IQX_WEBEST-179
            // }
            autoDeburProcessInput.details[0].countAutoExtract = 1;
            updateProcessInputs.push(autoDeburProcessInput);
          } else if (curWorkType === WorkType.SmDeburringManual) {
            let manualDeburProcessInput = processInputs[j];
            manualDeburProcessInput.details[0].length = cardDetails?.contourLength?.outerLength
              ? toDecimal(cardDetails?.contourLength?.outerLength, 2)
              : toDecimal(0, 2);
            manualDeburProcessInput.details[0].autoExtract = cardDetails?.contourLength?.outerLength
              ? toDecimal(cardDetails?.contourLength?.outerLength, 2)
              : toDecimal(0, 2); // IQX_WEBEST-179
            manualDeburProcessInput.details[0].count = 1;
            manualDeburProcessInput.details[0].countAutoExtract = 1;

            manualDeburProcessInput.details[1].length = cardDetails?.contourLength?.innerLength
              ? toDecimal(cardDetails?.contourLength?.innerLength, 2)
              : toDecimal(0, 2);
            manualDeburProcessInput.details[1].autoExtract = cardDetails?.contourLength?.innerLength
              ? toDecimal(cardDetails?.contourLength?.innerLength, 2)
              : toDecimal(0, 2); // IQX_WEBEST-179
            manualDeburProcessInput.details[1].count = 1;
            manualDeburProcessInput.details[1].countAutoExtract = 1;
            updateProcessInputs.push(manualDeburProcessInput);
          } else if (curWorkType === WorkType.SmSurface) {
            let surfaceProcessInput = processInputs[j];

            // 2025-10-01 IQX_WEBEST-470 表面処理費が表示されないバグ
            let surfaceProcessSelect = selectedPMXEstimateData?.esIq3Info[i]?.processSelect;
            //
            if (surfaceProcessSelect?.details?.length) {
              const matched = surfaceProcessSelect.details.find((d) => d.processId === surfaceProcessInput.processId);

              if (matched) {
                if (!surfaceProcessInput.details || !Array.isArray(surfaceProcessInput.details)) {
                  surfaceProcessInput.details = [];
                }

                let no = 0;
                matched.multiprocesses.forEach((mp) => {
                  if (mp.processDetailGroup > 0) {
                    if (!surfaceProcessInput.details[no]) {
                      surfaceProcessInput.details[no] = {};
                    }

                    surfaceProcessInput.details[no].no = no + 1;
                    surfaceProcessInput.details[no].calcType = 1;
                    surfaceProcessInput.details[no].workType = 300;

                    surfaceProcessInput.details[no].processDetailTypeNo = mp.processDetailTypeId;
                    surfaceProcessInput.details[no].processDetailWorkTypeGroup = mp.processDetailGroup;

                    surfaceProcessInput.details[no].areaUnitPrice = cardDetailsArea;
                    surfaceProcessInput.details[no].areaAutoExtract = cardDetailsArea;
                    surfaceProcessInput.details[no].totalArea = cardDetailsArea * 1;
                    surfaceProcessInput.details[no].areaCount = 1;
                    surfaceProcessInput.details[no].areaCountAutoExtract = 1;

                    surfaceProcessInput.details[no].weightUnitPrice = Number.isFinite(weight)
                      ? toDecimal(weight, 2)
                      : toDecimal(0, 2);

                    surfaceProcessInput.details[no].weightAutoExtract = Number.isFinite(weight)
                      ? toDecimal(weight, 2)
                      : toDecimal(0, 2);

                    surfaceProcessInput.details[no].totalWeight = Number.isFinite(weight)
                      ? toDecimal(weight, 2) * 1
                      : toDecimal(0, 2);

                    surfaceProcessInput.details[no].weightCount = 1;
                    surfaceProcessInput.details[no].weightCountAutoExtract = 1;

                    no++;
                  }
                });
              } else {
                if (surfaceProcessInput?.details) {
                  surfaceProcessInput.details[0].areaUnitPrice = cardDetailsArea;
                  surfaceProcessInput.details[0].areaAutoExtract = cardDetailsArea; // IQX_WEBEST-179
                  surfaceProcessInput.details[0].totalArea = cardDetailsArea * 1;
                  surfaceProcessInput.details[0].areaCount = 1;
                  surfaceProcessInput.details[0].areaCountAutoExtract = 1;
                  surfaceProcessInput.details[0].weightUnitPrice = Number.isFinite(weight)
                    ? toDecimal(weight, 2)
                    : toDecimal(0, 2);
                  surfaceProcessInput.details[0].weightAutoExtract = Number.isFinite(weight)
                    ? toDecimal(weight, 2)
                    : toDecimal(0, 2); // IQX_WEBEST-179
                  surfaceProcessInput.details[0].totalWeight = Number.isFinite(weight)
                    ? toDecimal(weight, 2) * 1
                    : toDecimal(0, 2);
                  surfaceProcessInput.details[0].weightCount = 1;
                  surfaceProcessInput.details[0].weightCountAutoExtract = 1;
                }
              }
            }
            updateProcessInputs.push(surfaceProcessInput);
          } else if (curWorkType === WorkType.SmShearing) {
            let shearingProcessInput = processInputs[j];
            shearingProcessInput.details[0].numOfCuts = 1;
            shearingProcessInput.details[0].autoExtract = 1; // IQX_WEBEST-179
            updateProcessInputs.push(shearingProcessInput);
          } else if (curWorkType === WorkType.SmInspection) {
            let inspectionProcessInput = processInputs[j];
            inspectionProcessInput.details[0].autoExtract = 1;
            updateProcessInputs.push(inspectionProcessInput);
          }
        }
        //updateProcessInputs
        selectedPMXEstimateData.esIq3Info[i].processInput = updateProcessInputs;
      }
    }

    if (props?.setSelectedEstimateData) {
      props.setSelectedEstimateData(JSON.parse(JSON.stringify(selectedPMXEstimateData)));
    }

    // Beam
    let hyoumenData = null;
    if ((hyoumenData = selectedPMXEstimateData?.esIq5Info?.length > 0)) {
      hyoumenData = selectedPMXEstimateData?.esIq5Info[0]?.processSelect?.hyoumen;
    }

    selectedPMXEstimateData.esIq5Info = selectedPMXEstimateData.esIq5Info.filter((_, i) => {
      const detail = selectedCardData.details[i];
      return detail && detail.type === 'Beam';
    });

    const steelMaterialClassLists = await getSteelMaterialClassList();

    let IO5SelectedCardDataDetails = selectedCardData?.details?.filter((item) => item.type === 'Beam');

    const materialIQ5Parameter = selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.materialIq5;

    let failedMatches = [];

    // 2025-12-02 IQX_WEBEST-497 形鋼のPMX読み込み
    for (let i = 0; i < selectedPMXEstimateData?.esIq5Info?.length; i++) {
      let isCalc = true;
      let isPink = false;
      let cardMainDataDetails = IO5SelectedCardDataDetails?.[i];

      let cardDetails = cardMainDataDetails?.processingInfo ? JSON.parse(cardMainDataDetails?.processingInfo) : {};
      const cardInfo = cardDetails?.materialInfo;

      const partName = cardMainDataDetails?.name || `[部品 ${i + 1}]`;

      selectedPMXEstimateData.esIq5Info[i].no = i + 1;
      selectedPMXEstimateData.esIq5Info[i].partCount = cardMainDataDetails?.quantity;
      selectedPMXEstimateData.esIq5Info[i].name = cardMainDataDetails?.name;
      selectedPMXEstimateData.esIq5Info[i].size = Math.round(cardInfo?.length) || 0;
      selectedPMXEstimateData.esIq5Info[i].materialUnitType = 1;

      // 鋼材情報を再設定
      const beamTypeId = cardInfo?.beamTypeId;

      const steelShapeIdByCompany = beamTypeId ? 1000 * settingInfo[0].companyId + beamTypeId : beamTypeId;

      let steelShapeId = null;
      let steelShapeName = null;
      let materialTypeIq5Id = null;
      let materialTypeName = null;
      let materialIq5Id = null;
      let materialName = null;
      let imageId = null;

      if (!steelShapeIdByCompany) {
        failedMatches.push({ name: partName, reason: 'steelShapedIdが見つかりません' });
        continue;
      }

      if (steelShapeIdByCompany) {
        const allSteelShapes = selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.steelShape;

        let foundSteelShape = null;
        if (Array.isArray(allSteelShapes)) {
          foundSteelShape = allSteelShapes.find((shape) => shape.id === steelShapeIdByCompany);
        }

        if (!foundSteelShape) {
          failedMatches.push({ name: partName, reason: 'steelShapedIdが見つかりません' });
          continue;
        }

        if (foundSteelShape) {
          steelShapeId = foundSteelShape?.id;
          steelShapeName = foundSteelShape?.name;

          let matchingMaterials = materialIQ5Parameter.filter((m) => m.steelShapeId === steelShapeId);

          if (matchingMaterials.length > 0) {
            if (cardInfo.materialName !== '') {
              const requiredMaterialName = cardInfo.materialName;

              const nameFilteredMaterials = matchingMaterials.filter((material) => {
                let matTypeName =
                  selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters?.materialTypeIq5?.filter(
                    (item) => item.id === material?.materialTypeIq5Id
                  )?.[0]?.name;

                return matTypeName === requiredMaterialName;
              });

              if (nameFilteredMaterials.length > 0) {
                matchingMaterials = nameFilteredMaterials;
              } else {
                failedMatches.push({
                  name: partName,
                  reason: 'サイズに一致した材質の材料を追加してください。',
                });
              }
            } else {
              isPink = true;
              failedMatches.push({
                name: '',
                reason: '適切な材質の鋼材を選択してください。',
              });
            }
          }

          let finalMatchMaterial = null;

          if (matchingMaterials.length === 0) {
            isCalc = false;
            failedMatches.push({ name: partName, reason: '鋼材は合っていません。' });
          } else {
            const isValidValue = (val) => val !== null && val !== undefined;

            for (const material of matchingMaterials) {
              const materialInfo = material.info;
              let dimensionsMatch = true;

              // Check 'a'
              if (isValidValue(materialInfo?.a) && isValidValue(cardInfo?.a)) {
                if (materialInfo.a !== cardInfo.a) dimensionsMatch = false;
              }

              // Check 'b'
              if (isValidValue(materialInfo?.b) && isValidValue(cardInfo.b)) {
                if (materialInfo.b !== cardInfo.b) dimensionsMatch = false;
              }

              // Check 'c'
              if (isValidValue(materialInfo?.c) && isValidValue(cardInfo.c)) {
                if (materialInfo.c !== cardInfo.c) dimensionsMatch = false;
              }

              // Check 't1'
              if (isValidValue(materialInfo?.t1) && isValidValue(cardInfo.t1)) {
                if (materialInfo.t1 !== cardInfo.t1) dimensionsMatch = false;
              }

              // Check 't2'
              if (isValidValue(materialInfo?.t2) && isValidValue(cardInfo.t2)) {
                if (materialInfo.t2 !== cardInfo.t2) dimensionsMatch = false;
              }

              if (dimensionsMatch) {
                finalMatchMaterial = material;

                break;
              }
            }

            if (finalMatchMaterial) {
            } else {
              isCalc = false;

              const firstMaterial = matchingMaterials[0];
              let mismatchReasons = [];

              if (
                isValidValue(firstMaterial.info?.a) &&
                isValidValue(cardInfo?.a) &&
                firstMaterial.info.a !== cardInfo.a
              ) {
                mismatchReasons.push('a');
              }

              failedMatches.push({
                name: partName,
                reason: `${mismatchReasons.join(' と ')} が一致しません`,
              });
            }
          }

          if (finalMatchMaterial) {
            if (finalMatchMaterial.info?.isUsed !== true) {
              isCalc = false;
              failedMatches.push({ name: partName, reason: 'このmaterialIq5情報は使用できません' });
            }

            if (isCalc) {
              materialTypeIq5Id = finalMatchMaterial?.materialTypeIq5Id;
              materialTypeName = steelMaterialClassLists?.filter(
                (item) => item.id === finalMatchMaterial?.materialTypeIq5Id
              )?.[0]?.name;
              materialName = finalMatchMaterial?.name;
              materialIq5Id = finalMatchMaterial?.id;
              imageId = steelMaterialClassLists?.filter((item) => item.id === finalMatchMaterial?.steelShapeId)?.[0]
                ?.shapeNo;
            }
          }
        }
      }

      selectedPMXEstimateData.esIq5Info[i].isPink = isPink;
      selectedPMXEstimateData.esIq5Info[i].steelShapeId = steelShapeIdByCompany ? steelShapeIdByCompany : 0;
      selectedPMXEstimateData.esIq5Info[i].steelShapeName = steelShapeName ? steelShapeName : '';
      selectedPMXEstimateData.esIq5Info[i].materialTypeIq5Id = materialTypeIq5Id ? materialTypeIq5Id : 0;
      selectedPMXEstimateData.esIq5Info[i].materialTypeName = materialTypeName ? materialTypeName : '';
      selectedPMXEstimateData.esIq5Info[i].materialName = materialName ? materialName : '';
      selectedPMXEstimateData.esIq5Info[i].materialIq5Id = materialIq5Id ? materialIq5Id : 0;
      selectedPMXEstimateData.esIq5Info[i].imageId = imageId ? imageId : 0;

      let parameters = selectedPMXEstimateData?.estimateProducts?.calcParameters?.parameters;
      let processMstData = parameters?.process?.filter((process) => process?.class === ServiceClass.Beams);

      let updateBeamProcessInputs = [];
      let updateSelectedProcessAdditions = JSON.parse(JSON.stringify(selectedPMXEstimateData.esIq5Info[i].additions));
      let processInputsBeam = JSON.parse(JSON.stringify(selectedPMXEstimateData?.esIq5Info[i]?.processInput));

      if (isCalc) {
        for (let j = 0; j < processInputsBeam?.length; j++) {
          let curBeamWorkType = processMstData?.filter((item) => item.id == processInputsBeam[j].processId)?.[0]
            ?.workType;

          let curProcessMasterInfo = processMstData?.filter((item) => item.workType === curBeamWorkType)?.[0];

          let curProcessSelect = selectedPMXEstimateData.esIq5Info[i].processSelect?.details.filter(
            (item) => item.processId === processInputsBeam[j]?.processId
          );

          let curDevice = parameters.device.filter((dev) => dev.id === curProcessSelect[0].deviceId);

          if (curBeamWorkType === WorkType.PaSteelWeld) {
            let weldProcessInput = processInputsBeam[j];

            if (cardDetails?.weldInfo && cardDetails.weldInfo.length > 0) {
              let newDeviceProcessDetail = {
                no: 1,
                deviceId: curDevice[0].id,
                deviceNm: curDevice[0].name,
                details: [],
              };

              let deviceAdditionsDetails = {
                no: 1,
                deviceId: curDevice[0].id,
                deviceNm: curDevice[0].name,
                dandoriTime: 0,
                dandoriAmt: 0,
                sagyoTime: 0,
                sagyoAmt: 0,
                sagyoDetails: [],
              };

              let kindNo = curDevice?.[0]?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                (k) => k.name === WeldFinish_IQ5ManufactSizeKind[5]
              )?.[0]?.no;

              for (let k = 0; k < cardDetails.weldInfo.length; k++) {
                let typeDetail = {
                  no: k + 1,
                  processDetailTypeNo: 1, // 確認
                  kindNo: kindNo,
                  count: cardDetails?.weldInfo?.[k].number,
                  dimension: cardDetails?.materialInfo?.length,
                  weldLength: cardDetails?.weldInfo?.[k].length,
                };

                let saGyoDetail = {
                  no: k + 1,
                  processDetailTypeNo:
                    curProcessMasterInfo?.details?.processDetailTypes?.length > 0
                      ? curProcessMasterInfo?.details?.processDetailTypes?.[0]?.id
                      : 0,
                  sagyoTime: 0,
                  sagyoAmt: 0,
                };

                newDeviceProcessDetail.details.push(typeDetail);
                deviceAdditionsDetails.sagyoDetails.push(saGyoDetail);
              }

              weldProcessInput.deviceProcessInputDetails.push(newDeviceProcessDetail);
              updateBeamProcessInputs.push(weldProcessInput);

              let additionsDetails = [];

              additionsDetails.push(deviceAdditionsDetails);

              updateSelectedProcessAdditions?.map((item) => {
                if (item.processId === curProcessMasterInfo?.id) {
                  item.deviceAdditionsDetails = additionsDetails;
                }
              });
            } else {
              updateBeamProcessInputs.push(weldProcessInput);
            }
          } else if (curBeamWorkType === WorkType.PaSteelWeldFinish) {
            let weldFinishProcessInput = processInputsBeam[j];

            if (cardDetails?.subWeldInfo && cardDetails?.subWeldInfo?.length > 0) {
              let newDeviceProcessDetail = {
                no: 1,
                deviceId: curDevice[0].id,
                deviceNm: curDevice[0].name,
                details: [],
              };

              let deviceAdditionsDetails = {
                no: 1,
                deviceId: curDevice[0].id,
                deviceNm: curDevice[0].name,
                dandoriTime: 0,
                dandoriAmt: 0,
                sagyoTime: 0,
                sagyoAmt: 0,
                sagyoDetails: [],
              };

              let kindNo = curDevice?.[0]?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                (k) => k.name === WeldFinish_IQ5ManufactSizeKind[5]
              )?.[0]?.no;

              for (let k = 0; k < cardDetails?.subWeldInfo?.length; k++) {
                let typeDetail = {
                  no: k + 1,
                  processDetailTypeNo: 1, // 確認
                  kindNo: kindNo,
                  count: cardDetails?.weldInfosubWeldInfo?.[k].number,
                  dimension: cardDetails?.materialInfo?.length,
                  weldLength: cardDetails?.subWeldInfo?.[k]?.xL ? cardDetails?.subWeldInfo?.[k]?.xL : 0,
                };

                let saGyoDetail = {
                  no: k + 1,
                  processDetailTypeNo:
                    curProcessMasterInfo?.details?.processDetailTypes?.length > 0
                      ? curProcessMasterInfo?.details?.processDetailTypes?.[0]?.id
                      : 0,
                  sagyoTime: 0,
                  sagyoAmt: 0,
                };

                newDeviceProcessDetail.details.push(typeDetail);
                deviceAdditionsDetails.sagyoDetails.push(saGyoDetail);
              }

              weldFinishProcessInput.deviceProcessInputDetails.push(newDeviceProcessDetail);
              updateBeamProcessInputs.push(weldFinishProcessInput);

              let additionsDetails = [];

              additionsDetails.push(deviceAdditionsDetails);

              updateSelectedProcessAdditions?.map((item) => {
                if (item.processId === curProcessMasterInfo?.id) {
                  item.deviceAdditionsDetails = additionsDetails;
                }
              });
            } else {
              updateBeamProcessInputs.push(weldFinishProcessInput);
            }
          } else if (curBeamWorkType === WorkType.PaSteelBend) {
            let bendProcessInput = processInputsBeam[j];

            if (cardDetails?.bendInfo && cardDetails?.bendInfo?.length > 0) {
              let newDeviceProcessDetail = {
                no: 1,
                deviceId: curDevice[0].id,
                deviceNm: curDevice[0].name,
                details: [],
              };

              let deviceAdditionsDetails = {
                no: 1,
                deviceId: curDevice[0].id,
                deviceNm: curDevice[0].name,
                dandoriTime: 0,
                dandoriAmt: 0,
                sagyoTime: 0,
                sagyoAmt: 0,
                sagyoDetails: [],
              };

              let kindNo = curDevice?.[0]?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                (k) => k.name === Bend_IQ5ManufactSizeKind[2]
              )?.[0]?.no;

              for (let k = 0; k < cardDetails?.bendInfo?.length; k++) {
                let typeDetail = {
                  no: k + 1,
                  processDetailTypeNo: 1,
                  kindNo: kindNo,
                  dimension: cardDetails?.materialInfo?.length,
                  bendLength: cardDetails?.bendInfo?.[k].width,
                  bendSize: cardDetails?.bendInfo?.[k].number,
                  count: cardDetails?.bendInfo?.[k].amount,
                };

                let saGyoDetail = {
                  no: k + 1,
                  processDetailTypeNo:
                    curProcessMasterInfo?.details?.processDetailTypes?.length > 0
                      ? curProcessMasterInfo?.details?.processDetailTypes?.[0]?.id
                      : 0,
                  sagyoTime: 0,
                  sagyoAmt: 0,
                };

                newDeviceProcessDetail.details.push(typeDetail);
                deviceAdditionsDetails.sagyoDetails.push(saGyoDetail);
              }

              bendProcessInput.deviceProcessInputDetails.push(newDeviceProcessDetail);
              updateBeamProcessInputs.push(bendProcessInput);

              let additionsDetails = [];

              additionsDetails.push(deviceAdditionsDetails);

              updateSelectedProcessAdditions?.map((item) => {
                if (item.processId === curProcessMasterInfo?.id) {
                  item.deviceAdditionsDetails = additionsDetails;
                }
              });
            } else {
              updateBeamProcessInputs.push(bendProcessInput);
            }
          } else if (curBeamWorkType === WorkType.PaSteelHole) {
            let holeProcessInput = processInputsBeam[j];

            if (cardDetails?.holes && cardDetails?.holes?.length > 0) {
              let newDeviceProcessDetail = {
                no: 1,
                deviceId: curDevice[0].id,
                deviceNm: curDevice[0].name,
                details: [],
              };

              let deviceAdditionsDetails = {
                no: 1,
                deviceId: curDevice[0].id,
                deviceNm: curDevice[0].name,
                dandoriTime: 0,
                dandoriAmt: 0,
                sagyoTime: 0,
                sagyoAmt: 0,
                sagyoDetails: [],
              };

              let kindNo = curDevice?.[0]?.details?.iQ5ManufactSizeInfo?.kinds?.filter(
                (k) => k.name === Hole_IQ5ManufactSizeKind[0]
              )?.[0]?.no;

              for (let k = 0; k < cardDetails?.holes?.length; k++) {
                let holeTypeName = BlankTypes?.filter((item) => item.value === cardDetails?.holes?.[k]?.name)?.[0]
                  ?.label;

                let holeTypeId = curProcessMasterInfo?.details?.processDetailTypes?.filter(
                  (item) => item.name === holeTypeName
                )?.[0]?.id;

                if (holeTypeId === undefined) {
                  holeTypeId = curProcessMasterInfo?.details?.processDetailTypes?.filter((item) =>
                    item.name.includes('その他')
                  )?.[0]?.id;
                }
                let typeDetail = {
                  no: k + 1,
                  processDetailTypeNo: holeTypeId ? holeTypeId : 1,
                  kindNo: kindNo,
                  xL: cardDetails?.holes?.[k]?.xl,
                  yL: cardDetails?.holes?.[k]?.yl,
                  holeLength: cardDetails?.holes?.[k]?.length,
                  count: cardDetails?.holes?.[k]?.number,
                };

                let saGyoDetail = {
                  no: k + 1,
                  processDetailTypeNo: curProcessMasterInfo?.details?.processDetailTypes?.length > 0 ? holeTypeId : 1,
                  sagyoTime: 0,
                  sagyoAmt: 0,
                };

                newDeviceProcessDetail.details.push(typeDetail);
                deviceAdditionsDetails.sagyoDetails.push(saGyoDetail);
              }

              holeProcessInput.deviceProcessInputDetails.push(newDeviceProcessDetail);
              updateBeamProcessInputs.push(holeProcessInput);

              let additionsDetails = [];

              additionsDetails.push(deviceAdditionsDetails);

              updateSelectedProcessAdditions?.map((item) => {
                if (item.processId === curProcessMasterInfo?.id) {
                  item.deviceAdditionsDetails = additionsDetails;
                }
              });
            } else {
              updateBeamProcessInputs.push(holeProcessInput);
            }
          } else {
            let otherProcessInput = JSON.parse(JSON.stringify(processInputsBeam[j]));
            updateBeamProcessInputs.push(otherProcessInput);
          }
        }
      }

      selectedPMXEstimateData.esIq5Info[i].processInput = updateBeamProcessInputs;
      selectedPMXEstimateData.esIq5Info[i].additions = updateSelectedProcessAdditions;

      if (!selectedPMXEstimateData.esIq5Info[i].processSelect.hyoumen) {
        selectedPMXEstimateData.esIq5Info[i].processSelect.hyoumen = {};
      }
      selectedPMXEstimateData.esIq5Info[i].processSelect.hyoumen = hyoumenData;
    }

    if (failedMatches.length > 0) {
      const errorSummary = {};
      for (const failure of failedMatches) {
        if (!errorSummary[failure.reason]) {
          errorSummary[failure.reason] = [];
        }
        if (!errorSummary[failure.reason].includes(failure.name)) {
          errorSummary[failure.reason].push(failure.name);
        }
      }

      let finalWarning = '一致しない鋼材情報がありました。\n';
      for (const reason in errorSummary) {
        const parts = errorSummary[reason].join(', ');
        if (parts !== '') {
          finalWarning += `\n- ${reason} (該当部品: ${parts})`;
        } else {
          finalWarning += `\n- ${reason}`;
        }
      }

      error(finalWarning);
    }

    setCheckPMXOrNot(true);
    let totalWeight = 0;
    let totalArea = 0;
    let totalPartCount = 0;
    if (isCreatePMX === CreatePMXData.Update) {
      if (props.selectedEstimateData.esIq3Info?.length > 0) {
        const listData = selectedPMXEstimateData?.esIq3Info;
        const updatedInfoArray = listData?.map((item, index) => ({
          ...item,
          no: props.selectedEstimateData?.esIq3Info?.length + 1 + index,
        }));

        setSelectediq3Data([...selectediq3Data, ...updatedInfoArray]);

        // IQ5
        const listData5 = selectedPMXEstimateData?.esIq5Info;
        const updatedInfoArray5 = listData5?.map((item, index) => ({
          ...item,
          no: props.selectedEstimateData?.esIq5Info?.length + 1 + index,
        }));

        setSelectediq5Data([...selectediq5Data, ...updatedInfoArray5]);

        let iq3List = [...props.selectedEstimateData?.esIq3Info, ...updatedInfoArray];
        totalWeight = iq3List?.reduce((total, item) => {
          return total + Number(item.weight) * Number(item.partCount); // IQX_WEBEST-308 親工程 －表面処置、工程入力画面の「面積/重量」の値変更
        }, 0);
        totalWeight = totalWeight ? totalWeight : 0;
        totalArea = iq3List?.reduce((total, item) => {
          return total + Number(item.totalSurfaceArea) * Number(item.partCount); // IQX_WEBEST-308 親工程 －表面処置、工程入力画面の「面積/重量」の値変更
        }, 0);
        totalArea = totalArea ? totalArea : 0;
        // IQX_WEBEST-68
        totalPartCount = iq3List?.reduce((total, item) => {
          return total + Number(item.partCount);
        }, 0);
        // 2025-10-02 IQX_WEBEST-483 PMXファイルの呼び込み問題
        totalPartCount = totalPartCount ? totalPartCount : 0;
        // IQX_WEBEST-68
        let assenbleProcessInput = selectedEstimateData?.estimateProducts?.processInput?.assenbleProcessInputInfo;
        let inspectionProcessInput = selectedEstimateData?.estimateProducts?.processInput?.inspectionProcessInputInfo;
        let packingProcessInput = selectedEstimateData?.estimateProducts?.processInput?.packingProcessInputInfo;
        if (assenbleProcessInput) {
          assenbleProcessInput.smPartsCount = totalPartCount;
          assenbleProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
          selectedEstimateData.estimateProducts.processInput.assenbleProcessInputInfo = assenbleProcessInput;
        }
        if (inspectionProcessInput) {
          inspectionProcessInput.smPartsCount = totalPartCount;
          inspectionProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
          selectedEstimateData.estimateProducts.processInput.inspectionProcessInputInfo = inspectionProcessInput;
        }
        if (packingProcessInput) {
          packingProcessInput.smPartsCount = totalPartCount;
          packingProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
          selectedEstimateData.estimateProducts.processInput.packingProcessInputInfo = packingProcessInput;
        }

        let updatedEstimateData = {
          ...selectedEstimateData,
          estimateProducts: {
            ...selectedEstimateData?.estimateProducts,
            totalWeight: totalWeight,
            totalSurfaceArea: totalArea,
          },
          esIq3Info: [...selectedEstimateData?.esIq3Info, ...updatedInfoArray],
        };
        setSelectedEstimateData(updatedEstimateData);
        props.selectedEstimateData.estimateProducts.totalQuantitySm = totalPartCount; // 2025-10-02 IQX_WEBEST-483 PMXファイルの呼び込み問題
        props.selectedEstimateData.estimateProducts.totalWeight = totalWeight;
        props.selectedEstimateData.estimateProducts.totalWeightSm = totalWeight;
        props.selectedEstimateData.estimateProducts.totalSurfaceArea = totalArea;
        props.selectedEstimateData.esIq3Info = [...props.selectedEstimateData?.esIq3Info, ...updatedInfoArray];
        props.updateSelectedEstimateDataByPMX(updatedEstimateData);
        setIsPMXEvent(true);
      } else {
        // IQ5
        setSelectediq5Data([...selectediq5Data, ...selectedPMXEstimateData.esIq5Info]);

        // IQ3
        setSelectediq3Data([...selectediq3Data, ...selectedPMXEstimateData.esIq3Info]);
        setSelectedEstimateData({
          ...selectedEstimateData,
          esIq3Info: [...selectedEstimateData?.esIq3Info, ...selectedPMXEstimateData.esIq3Info],
        });
        props.selectedEstimateData.esIq3Info = [
          ...props.selectedEstimateData?.esIq3Info,
          ...selectedPMXEstimateData.esIq3Info,
        ];
        props.updateSelectedEstimateDataByPMX(selectedPMXEstimateData);
        setIsPMXEvent(true);
      }
    } else {
      // IQX_WEBEST-68
      let iq3List = selectedPMXEstimateData.esIq3Info;
      totalWeight = iq3List?.reduce((total, item) => {
        return total + Number(item.weight) * Number(item.partCount); // IQX_WEBEST-308 親工程 －表面処置、工程入力画面の「面積/重量」の値変更
      }, 0);
      totalWeight = totalWeight ? totalWeight : 0;
      totalArea = iq3List?.reduce((total, item) => {
        return total + Number(item.totalSurfaceArea) * Number(item.partCount); // IQX_WEBEST-308 親工程 －表面処置、工程入力画面の「面積/重量」の値変更
      }, 0);
      totalArea = totalArea ? totalArea : 0;
      totalPartCount = iq3List?.reduce((total, item) => {
        return total + Number(item.partCount);
      }, 0);
      // 2025-10-02 IQX_WEBEST-483 PMXファイルの呼び込み問題
      totalPartCount = totalPartCount ? totalPartCount : 0;
      let assenbleProcessInput = selectedPMXEstimateData?.estimateProducts?.processInput?.assenbleProcessInputInfo;
      let inspectionProcessInput = selectedPMXEstimateData?.estimateProducts?.processInput?.inspectionProcessInputInfo;
      let packingProcessInput = selectedPMXEstimateData?.estimateProducts?.processInput?.packingProcessInputInfo;
      if (assenbleProcessInput) {
        assenbleProcessInput.smPartsCount = totalPartCount;
        assenbleProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
        selectedPMXEstimateData.estimateProducts.processInput.assenbleProcessInputInfo = assenbleProcessInput;
      }
      if (inspectionProcessInput) {
        inspectionProcessInput.smPartsCount = totalPartCount;
        inspectionProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
        selectedPMXEstimateData.estimateProducts.processInput.inspectionProcessInputInfo = inspectionProcessInput;
      }
      if (packingProcessInput) {
        packingProcessInput.smPartsCount = totalPartCount;
        packingProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
        selectedPMXEstimateData.estimateProducts.processInput.packingProcessInputInfo = packingProcessInput;
      }
      // 2025-10-02 IQX_WEBEST-483 PMXファイルの呼び込み問題
      selectedPMXEstimateData.estimateProducts.totalQuantitySm = totalPartCount;
      selectedPMXEstimateData.estimateProducts.totalWeight = totalWeight;
      selectedPMXEstimateData.estimateProducts.totalWeightSm = totalWeight;
      selectedPMXEstimateData.estimateProducts.totalSurfaceArea = totalArea;
      setSelectedEstimateData({ ...selectedPMXEstimateData });
      props.updateSelectedEstimateDataByPMX(selectedPMXEstimateData);
      setIsPMXEvent(true);
    }
    // 2025-09-19 IQX_WEBEST-470 表面処理費が表示されないバグ
    setPmxRead(true);
    setIq3DataConfirm(false);

    // 2025-05-23 ローカルPMXファイル読み込み
    setCurrentPMXMenu(null);
  };

  const uploadDXFDataFile = async (uploadFiles) => {
    setDXFCalculateLoading(true);
    let pmxDataDetail = {};
    let estimateName = '';
    // let companySetting = await getExistCompanySetting(); // IQX_WEBEST-237
    // if (companySetting !== undefined) {
    //   if (!Array.isArray(companySetting)) {
    //     companySetting = [companySetting];
    //   }
    // }
    for (let i = 0; i < uploadFiles.length; i++) {
      let uploadFile = uploadFiles[i];
      // 命名規則：yyyymmddhhmmssfff+ランダム生成された3桁の数字+拡張子
      // let dxfFileName = generateTimestamp() + getFileExtension(uploadFile?.name);
      // let dxfFileName = '20250829113708148653.dxf';
      let dxfFileName = uploadFile?.name;

      let dxfFile = new File([uploadFile], dxfFileName, {
        type: 'application/octet-stream',
      });

      if (props?.hubConnection?.state === signalR.HubConnectionState.Disconnected) {
        await props?.hubConnection?.start();
      }

      //
      let dxfFileFormData = new FormData();
      dxfFileFormData.append('file', dxfFile);
      dxfFileFormData.append('parentDirectory', process.env.REACT_APP_AUDI_FILE_UPLOAD_URL);
      let generatePMXURL = process.env.REACT_APP_AUDI_BACKEND_API_GENERATE_PMX_URL;
      // DXFファイルアップロード対応
      let pmxfilePath = '';

      if (AllowedExtensionsDxf.some((ext) => dxfFileName.toLowerCase().endsWith(ext))) {
        // let dxfOptions =
        //   Object.keys(dxfCompanySetting?.[0]?.dxfOptionsSetting)?.length === 0
        //     ? JSON.stringify(getDefaultJellDOptions())
        //     : dxfCompanySetting?.[0]?.dxfOptionsSetting;
        const optionsSetting = dxfCompanySetting?.[0]?.dxfOptionsSetting;

        const dxfOptions =
          !optionsSetting || optionsSetting === '{}' ? JSON.stringify(getDefaultJellDOptions()) : optionsSetting;

        let dxfTypeCode = uploadFile.dxfType ? uploadFile.dxfType : dxfTypes[0]?.id;
        dxfFileFormData.append('dxfTypeCode', dxfTypeCode);
        dxfFileFormData.append('jellDDXFToPMXOptions', dxfOptions);
        generatePMXURL = process.env.REACT_APP_WEB3D_API_DXF_UPLOAD_URL;
        let dxfFileNm = dxfFileName?.replace(/\.[^/.]+$/, ''); // 拡張子を削除
        pmxfilePath = process.env.REACT_APP_AUDI_FILE_UPLOAD_URL + '\\' + dxfFileNm;

        // 親部品名称
        if (estimateName === '') {
          estimateName = dxfFileNm;
        }
      }

      let headers = getRequestHeader();

      // Audiへ3Dファイルアップロード
      await axios
        .post(generatePMXURL, dxfFileFormData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${props?.hubConnectionToken}`,
          },
          reportProgress: true,
          responseType: 'json',
        })
        .then(async (generatePMXRes) => {
          // Audiへ3Dファイルアップロードが成功してPMXファイルが生成された場合、
          if (generatePMXRes.status === 200) {
            // PMX情報取得API（AudiからPMX取得）
            let pmxFullPath = pmxfilePath;

            let route = '?filePath=' + pmxFullPath;
            // ストレージに３Dファイルアップロード成功後にPMX解析とストレージに保持。
            const audiPMXUrl = process.env.REACT_APP_AUDI_BACKEND_API_DOWNLOAD_PMX_URL + route;
            await axios
              .get(audiPMXUrl, {
                headers: {
                  Authorization: `Bearer ${props?.hubConnectionToken}`,
                },
                responseType: 'blob',
              })
              .then(async (audiPMXResponse) => {
                // PMXファイルダウンロードが成功した場合
                if (audiPMXResponse.status === 200) {
                  let audiPMXFile = audiPMXResponse?.data;
                  if (audiPMXFile) {
                    // StreamをBlobに変換
                    const blob = new Blob([audiPMXFile], { type: 'application/octet-stream' });
                    const base64String = await blobToBase64(blob);
                    const pmxFileNm = uploadFile?.name + '.PMX';
                    const pmxFormData = new FormData();
                    pmxFormData.append('cad3dId', uploadFile.id);
                    pmxFormData.append('pmxBase64String', base64String);
                    pmxFormData.append('fileName', pmxFileNm);

                    const pmxUrl = `${process.env.REACT_APP_BACKEND_API_URL}Card/GetPMXFileData`;

                    const pmxDataResponse = await axios.post(pmxUrl, pmxFormData, {
                      headers: {
                        Authorization: 'Bearer ' + getAccessToken(),
                        'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
                      },
                    });

                    if (pmxDataResponse.data.data.details[0]) {
                      pmxDataResponse.data.data.details[0].thumbPath = pmxFullPath + getFileExtension(uploadFile?.name);
                      // pmxDataDetail?.details?.push(pmxDataResponse?.data?.data?.details?.[0]);
                    }

                    if (Object.keys(pmxDataDetail)?.length === 0) {
                      pmxDataDetail = pmxDataResponse?.data?.data;
                    } else {
                      pmxDataDetail?.details?.push(pmxDataResponse?.data?.data?.details?.[0]);
                    }
                  }
                }
              })
              .catch(async (error) => {
                console.log(error);
              });
          }
        })
        .catch(async (error) => {
          console.log(error);
        });
    }

    if (pmxDataDetail && pmxDataDetail?.details?.length > 0) {
      if (pmxDataDetail?.name || pmxDataDetail?.name === '') {
        pmxDataDetail.name = estimateName;
      }

      if (pmxDataDetail?.drawingNo || pmxDataDetail?.drawingNo === '') {
        pmxDataDetail.drawingNo = estimateName;
      }
      let estimateData = await getPMXEstimateInfo(pmxDataDetail);
      if (estimateData) {
        if (dxfParentPatternNo) {
          const selectedPatternInfo = patternList?.filter((item) => item.id == dxfParentPatternNo);
          // data.esIq3Info[0].processSelect = selectedPatternInfo[0];
          // setSelectedPMXEstimateData(data);
          estimateData.estimateProducts.processSelect = selectedPatternInfo[0];

          // setSelectedPMXEstimateData(data);
        }

        if (dxfChildPatternNo) {
          const selectedPatternInfo = iq3PatternList?.filter((item) => item.id == dxfChildPatternNo);
          // data.esIq3Info[0].processSelect = selectedPatternInfo[0];
          const updatedLists = estimateData?.esIq3Info?.map((item) => ({
            ...item,
            processSelect: selectedPatternInfo[0],
          }));
          estimateData.esIq3Info = updatedLists;

          // setSelectedPMXEstimateData(data);
        }
      }
      completePMXData(pmxDataDetail, estimateData);
    }

    // setIsDXFProcessPatternOpen(false);
    setDXFCalculateLoading(false);
    setIsCreatePMX();
    setIsProcessSelectInfo(false);
    setIsDXFPrepareInfo(false);
    setCurrentDXFStep(0);
    setIsDXFNext(false);
    setIsDXFNextIQ3(false);
    setDxfUpDataLst([]);
    setIsDXFProcessPatternOpen(false);
  };

  const backProcessPattern = () => {
    setIsPrepareInfo(true);
    setIsNext(false);
    setCurrentStep(currentStep > 0 ? currentStep - 1 : 0);
  };

  const nextIQ3FileLoad = () => {
    if (pmxTabKey == '1') {
      setPMXTabKey('2');
    }
  };
  const cloudPMXFileLoadOk = () => {
    setIsPMXCloudFileDialogOpen(false);
    openPMXProcessPatternDialog();
  };
  const cloudPMXFileLoadCancel = () => {
    setIsPMXCloudFileDialogOpen(false);
  };
  const onChangeProcessPatternInfo = (type, key) => {
    // const pmxCloudSelectedData = pmxCloudParentRef?.current?.getSelectedParent();
    const data = { ...selectedPMXEstimateData };

    // const data = { ...pmxSelectedEstimateData };
    if (type == 0) {
      if (isDXFProcessPatternOpen) {
        setDXFParentPatternNo(key);
      }
      setParentPatternNo(key);
      const selectedPatternInfo = patternList?.filter((item) => item.id == key);
      // data.esIq3Info[0].processSelect = selectedPatternInfo[0];
      // setSelectedPMXEstimateData(data);
      data.estimateProducts.processSelect = selectedPatternInfo[0];

      setSelectedPMXEstimateData(data);

      // data.kouteiSentakuPatternNo = key;
      // setSelectedEstimateData(data);
    } else if (type == 1) {
      if (isDXFProcessPatternOpen) {
        setDXFChildPatternNo(key);
      }
      setChildPatternNo(key);
      const selectedPatternInfo = iq3PatternList?.filter((item) => item.id == key);
      // data.esIq3Info[0].processSelect = selectedPatternInfo[0];
      const updatedLists = data?.esIq3Info?.map((item) => ({
        ...item,
        processSelect: selectedPatternInfo[0],
      }));
      data.esIq3Info = updatedLists;

      setSelectedPMXEstimateData(data);
      // props.updateSelectedEstimateData(selectedPMXEstimateData);

      // data.iq3DataLst[0].iq3KouteiSentakuPatternNo = key;
      // setSelectedEstimateData(data);
    } else {
      setChildIQ5PatternNo(key);
      const selectedPatternInfo = iq5PatternList?.filter((item) => item.id == key);
      // data.esIq3Info[0].processSelect = selectedPatternInfo[0];
      const updatedLists = data?.esIq5Info?.map((item) => ({
        ...item,
        processSelect: selectedPatternInfo[0],
      }));
      data.esIq5Info = updatedLists;

      setSelectedPMXEstimateData(data);
    }

    // setPatternNo(id);
    // let patternList = props.listData;
    // const selectedPatternInfo = patternList?.filter((item) => item.id == id);
    // setSelectedPatternInfo(selectedPatternInfo[0]);
    // if (selectedPatternInfo?.length > 0) {
    //   if (props.isParameter) {
    //     // 選択したパターンキーより一覧の選択行を変更
    //     props.updateSelectedData(selectedPatternInfo[0]);
    //   } else {
    //     // 選択したパターンキーより親部品工程選択・子部品工程選択の選択パターン番号を変更
    //     props.updateKouteiSentakuInfo(selectedPatternInfo[0], patternList);
    //   }
    // }
  };
  const reportOutputOk = async (printOutputsInfo, isUsedQuickOutput) => {
    props?.loading(true); // Waitingダイアログを非表示にする
    let excelData =
      isUsedQuickOutput && printOutputsInfo !== undefined ? printOutputsInfo : selectedExeclIndividualFormat; // IQX_WEBEST-365 クイック印刷機能が実装していない。
    convertServerExcelToHtml(excelData, props.selectedEstimateData, props.selectedEstimateData.esIq3Info);
    setIsReportOutputOpen(false);
    setIsEstimateDataSaveConfirm(false);
    setIsListOutputOpen(false);
    props?.loading(false); // Waitingダイアログを非表示にする
    Modal.success({
      width: 465,
      className: 'modal-complete',
      title: '完了',
      content: (
        <p style={{ fontSize: '13.5px', whiteSpace: 'pre-line', lineHeight: 2 }}>
          {'個別帳票出力処理が完了しました。'}
        </p>
      ),
    });
  };
  const reportOutputCancel = () => {
    setIsReportOutputOpen(false);
    setIsEstimateDataSaveConfirm(false);
    setIsListOutputOpen(false);
  };

  useImperativeHandle(
    ref,
    () => ({
      getSelectedEstimateData: () => {
        return selectedEstimateData;
      },
      getParentEstimateData: getParentEstimate,
      getEstimateIq3Data: getEstimateIq3,
      callFormValidation: formValidation,
      updateEstimateInfo: updateEstimateInfo,
      getParentEstimateRef: () => {
        return parentEstimateRef;
      },
      getPMXEstimateInof: () => {
        return selectedPMXEstimateData;
      },
      getSelectedEstimateDataOrg: () => {
        return selectedEstimateDataTemp;
      },
      isChangedEstimateInfo: () => {
        return isChangedEstimateInfo();
      },
    }),
    [selectedEstimateData, editMode, selectedEstimateDataTemp]
  );

  const formValidation = () => {
    let validation = parentEstimateRef?.current?.kihonFormValidation();
    if (validation) {
      validation = iQ3EstimateRef?.current?.kihonFormValidation();
    }
    return validation;
  };

  // 見積情報に変更があるかチェック
  const isChangedEstimateInfo = () => {
    let currentEstInfo = props?.selectedEstimateData;
    let oldEstInfo = selectedEstimateDataTemp;
    let currentEstProductInfo = currentEstInfo?.estimateProducts;
    let oldEstProductInfo = oldEstInfo?.estimateProducts;
    let currentEstIq3Info = currentEstInfo?.esIq3Info;
    let oldEstIq3Info = oldEstInfo?.esIq3Info;

    // 追加項目・費用
    let isEqual = lodash.isEqual(oldEstInfo?.epCustomCosts, currentEstInfo?.epCustomCosts);
    if (!isEqual) return true;
    // 追加項目・日付
    isEqual = lodash.isEqual(oldEstInfo?.epCustomDates, currentEstInfo?.epCustomDates);
    if (!isEqual) return true;
    // 追加項目・ラベル
    isEqual = lodash.isEqual(oldEstInfo?.epCustomLabels, currentEstInfo?.epCustomLabels);
    if (!isEqual) return true;
    // 追加項目・メモ
    isEqual = lodash.isEqual(oldEstInfo?.epCustomMemos, currentEstInfo?.epCustomMemos);
    if (!isEqual) return true;
    // 工程選択
    isEqual = lodash.isEqual(oldEstProductInfo?.processSelect, currentEstProductInfo?.processSelect);
    if (!isEqual) return true;
    // 工程入力
    isEqual = lodash.isEqual(oldEstProductInfo?.processInput, currentEstProductInfo?.processInput);
    if (!isEqual) return true;
    // 購入品
    isEqual = lodash.isEqual(oldEstProductInfo?.purchases, currentEstProductInfo?.purchases);
    if (!isEqual) return true;
    // 係数項目
    isEqual = lodash.isEqualWith(
      oldEstProductInfo?.otherProduct,
      currentEstProductInfo?.otherProduct,
      isEqualOtherProduct
    );
    if (!isEqual) return true;
    // その他情報
    isEqual = lodash.isEqual(oldEstProductInfo?.info, currentEstProductInfo?.info);
    if (!isEqual) return true;
    // 工程積算
    isEqual = lodash.isEqualWith(oldEstProductInfo?.additions, currentEstProductInfo?.additions, isEqualAdditions);
    if (!isEqual) return true;
    // // 添付ファイル
    // isEqual = lodash.isEqual(oldEstProductInfo?.attachments, currentEstProductInfo?.attachments);
    // if (!isEqual) return true;
    // 数量別見積確認情報
    isEqual = lodash.isEqual(oldEstProductInfo?.byQuantities, currentEstProductInfo?.byQuantities);
    if (!isEqual) return true;
    // 基本情報
    isEqual = lodash.isEqual(oldEstProductInfo, currentEstProductInfo);
    if (!isEqual) return true;

    for (var i = 0; i < currentEstIq3Info?.length; i++) {
      let currentIq3Info = currentEstIq3Info?.[i];
      let oldIq3Info = oldEstIq3Info?.[i];
      isEqual = lodash.isEqual(oldIq3Info?.additions, currentIq3Info?.additions, isEqualAdditions);
      if (!isEqual) break;
      // 板金、その他情報
      isEqual = lodash.isEqual(oldIq3Info?.info, currentIq3Info?.info);
      if (!isEqual) break;
      // 板金、材料詳細のサイズ情報
      isEqual = lodash.isEqual(oldIq3Info?.materialDetailSizes, currentIq3Info?.materialDetailSizes);
      if (!isEqual) break;
      // 板金、材料詳細のパターン情報
      isEqual = lodash.isEqual(oldIq3Info?.materialDetailPatterns, currentIq3Info?.materialDetailPatterns);
      if (!isEqual) break;
      // 板金、工程選択
      isEqual = lodash.isEqual(oldIq3Info?.processSelect, currentIq3Info?.processSelect);
      if (!isEqual) break;
      // 板金、工程入力
      isEqual = lodash.isEqual(oldIq3Info?.processInput, currentIq3Info?.processInput);
      if (!isEqual) break;
      // 板金、購入品
      isEqual = lodash.isEqual(oldIq3Info?.purchases, currentIq3Info?.purchases);
      if (!isEqual) break;
    }
    if (!isEqual) return true;
    // 板金見積情報
    isEqual = lodash.isEqual(oldEstIq3Info, currentEstIq3Info);
    return !isEqual;
  };

  // 係数項目
  const isEqualOtherProduct = (objValue, othValue) => {
    if (Number(objValue?.adjustment) !== Number(othValue?.adjustment)) return false;
    if (objValue?.adjustmentMethod !== othValue?.adjustmentMethod) return false;
    if (Number(objValue?.coeffClient) !== Number(othValue?.coeffClient)) return false;
    if (Number(objValue?.coeffOrders) !== Number(othValue?.coeffOrders)) return false;
    if (Number(objValue?.coeffPurchases) !== Number(othValue?.coeffPurchases)) return false;
    if (Number(objValue?.coeffManagements) !== Number(othValue?.coeffManagements)) return false;
    if (Number(objValue?.coeffDeliveryDates) !== Number(othValue?.coeffDeliveryDates)) return false;
    return true;
  };

  // 工程積算項目
  const isEqualAdditions = (objValue, othValue) => {
    objValue?.sort((a, b) => a?.processId - b?.processId);
    othValue?.sort((a, b) => a?.processId - b?.processId);
    let isEqual = false;
    isEqual = lodash.isEqual(objValue, othValue);
    return isEqual;
  };

  const getParentEstimate = () => {
    let currentEstimateData = parentEstimateRef?.current?.getParentEstimateInfo();
    let iq3EstimateData = iQ3EstimateRef?.current?.getIQ3EstimateDetailInfo();
    if (iq3EstimateData) currentEstimateData.esIq3Info = iq3EstimateData?.esIq3Info;
    // currentEstimateData.estimateProducts.calcParameters.parameters = oldParameters;
    return currentEstimateData;
  };

  const getEstimateIq3 = () => {
    let currentEstimateIq3Data = iQ3EstimateRef?.current?.getEstimateIq3Info();
    return currentEstimateIq3Data;
  };

  // 新規作成ボタンを押した場合(IQX_WEBEST-172)
  const createNewParentInfo = () => {
    props?.updateNewModeByParent(true);
  };

  // CURT.パラボタンを押した場合(IQX_WEBEST-171)
  const currentParamInfo = async () => {
    setIsCurtParam(true);
    let userSetting = await getExistUserSetting();
    if (userSetting?.length > 0 && userSetting != []) {
      let paramUpdateFlgInfos = userSetting?.[0]?.parametersUpdateFlgInfos;
      if (
        paramUpdateFlgInfos?.isMaterialParam === undefined &&
        paramUpdateFlgInfos?.isProcessParam === undefined &&
        paramUpdateFlgInfos?.isPurchaseParam === undefined &&
        paramUpdateFlgInfos?.isOtherParam === undefined
      ) {
        setParamUpdateFlgInfos(JSON.parse(JSON.stringify(getInitParamUpdateFlgInfos)));
      } else {
        setParamUpdateFlgInfos(paramUpdateFlgInfos);
      }
      // 2025-06-02 ヘッダーの設定画面だと「CURT.パラ更新」でチェックボックスをいじれるが、
      // CURTボタンでもチェックボックスをいじれるようにしてほしい
      setUpdateUserCURTSetting(userSetting);
    }
  };

  //　追加呼出ボタンの押下
  const displayAddParentInfo = async () => {
    let newParameters = await GetParametersByCompId();
    newParameters.estimateStatus = newParameters?.estimateStatus?.filter((item) => item.info.isUsed);
    newParameters.staff = newParameters?.staff?.filter((item) => item.info.isUsed);
    newParameters.client = newParameters?.client?.filter((item) => item.info.isUsed);
    setNewParameters(newParameters);
    setYobidashiClk(true);
    if (editMode) {
      setConfirmScreenChangeModalOpen(true);
      return;
    }
    // 子部品追加呼出
    setParentListDisplay(true);
    setParentLoading(true); // Waitingダイアログを表示にする
  };

  // 2025-09-16 IQX_WEBEST-418 複数子部品の呼び出しは行えないか？
  const [selectedRowsFromChild, setSelectedRowsFromChild] = useState([]);

  const selectParentInfoOk = async (selectedRows = []) => {
    setParentListDisplay(false);
    props?.loading(true); // Waitingダイアログを表示にする

    if (selectedRows.length > 0) {
      if (activePartMenu === '2') {
        let selectIq3Data = JSON.parse(JSON.stringify(selectedEstimateData?.esIq3Info)) || [];
        let lastRecord = selectIq3Data.length > 0 ? selectIq3Data[selectIq3Data.length - 1] : undefined;
        let no = lastRecord ? lastRecord.no + 1 : 1;
        const allNewIQ3Lst = [];

        for (const row of selectedRows) {
          if (!row?.estimateProducts?.id) continue;
          const addIQ3Lst = await getEstimateIq3Info(row.estimateProducts.id);

          for (let i = 0; i < addIQ3Lst.length; i++) {
            let iq3Data = { ...addIQ3Lst[i], id: 0, no };
            allNewIQ3Lst.push(iq3Data);
            no++;
          }
        }

        setSelectediq3Data([...selectediq3Data, ...allNewIQ3Lst]);
        setSelectedEstimateData({
          ...selectedEstimateData,
          esIq3Info: [...selectedEstimateData?.esIq3Info, ...allNewIQ3Lst],
        });
        props.selectedEstimateData.esIq3Info = [...props.selectedEstimateData?.esIq3Info, ...allNewIQ3Lst];
      }

      if (activePartMenu === '3') {
        let selectIq5Data = JSON.parse(JSON.stringify(selectedEstimateData?.esIq5Info)) || [];
        let lastRecord = selectIq5Data.length > 0 ? selectIq5Data[selectIq5Data.length - 1] : undefined;
        let no = lastRecord ? lastRecord.no + 1 : 1;
        const allNewIQ5Lst = [];

        for (const row of selectedRows) {
          if (!row?.estimateProducts?.id) continue;
          const addIQ5Lst = await getEstimateIq5Info(row.estimateProducts.id);

          for (let i = 0; i < addIQ5Lst.length; i++) {
            let iq5Data = { ...addIQ5Lst[i], id: 0, no };
            allNewIQ5Lst.push(iq5Data);
            no++;
          }
        }

        setSelectedEstimateData({
          ...selectedEstimateData,
          esIq5Info: [...selectedEstimateData?.esIq5Info, ...allNewIQ5Lst],
        });
        props.selectedEstimateData.esIq5Info = [...props.selectedEstimateData?.esIq5Info, ...allNewIQ5Lst];
      }

      props.updateIsRecal(true);
    }

    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // 追加呼出ダイアログのOKボタン押下
  // const selectParentInfoOk = async () => {
  //   setParentListDisplay(false);
  //   props?.loading(true); // Waitingダイアログを表示にする
  //   if (selectedParentAddEstimate !== undefined && selectedParentAddEstimate?.estimateProducts?.id) {
  //     let estimateProductId = selectedParentAddEstimate?.estimateProducts?.id;

  //     if (activePartMenu === '2') {
  //       const addIQ3Lst = await getEstimateIq3Info(estimateProductId);
  //       let selectIq3Data = JSON.parse(JSON.stringify(selectedEstimateData?.esIq3Info));
  //       var lastRecord = selectIq3Data?.length > 0 ? selectIq3Data[selectIq3Data?.length - 1] : undefined;
  //       let no = lastRecord ? lastRecord?.no + 1 : 1;

  //       const addNewIQ3Lst = [];
  //       for (let i = 0; i < addIQ3Lst?.length; i++) {
  //         var iq3Data = { ...addIQ3Lst[i] };
  //         iq3Data.id = 0;
  //         iq3Data.no = no;
  //         addNewIQ3Lst.push(iq3Data);
  //         no++;
  //       }
  //       setSelectediq3Data([...selectediq3Data, ...addNewIQ3Lst]);
  //       setSelectedEstimateData({
  //         ...selectedEstimateData,
  //         esIq3Info: [...selectedEstimateData?.esIq3Info, ...addNewIQ3Lst],
  //       });
  //       props.selectedEstimateData.esIq3Info = [...props.selectedEstimateData?.esIq3Info, ...addNewIQ3Lst];
  //     }

  //     //
  //     if (activePartMenu === '3') {
  //       const addIQ5Lst = await getEstimateIq5Info(estimateProductId);
  //       let selectIq5Data = JSON.parse(JSON.stringify(selectedEstimateData?.esIq5Info));
  //       var lastRecord = selectIq5Data?.length > 0 ? selectIq5Data[selectIq5Data?.length - 1] : undefined;
  //       let no = lastRecord ? lastRecord?.no + 1 : 1;
  //       const addNewIQ5Lst = [];

  //       for (let i = 0; i < addIQ5Lst?.length; i++) {
  //         var iq5Data = { ...addIQ5Lst[i] };
  //         iq5Data.id = 0;
  //         iq5Data.no = no;
  //         addNewIQ5Lst.push(iq5Data);
  //         no++;
  //       }
  //       setSelectedEstimateData({
  //         ...selectedEstimateData,
  //         esIq5Info: [...selectedEstimateData?.esIq5Info, ...addNewIQ5Lst],
  //       });
  //       props.selectedEstimateData.esIq5Info = [...props.selectedEstimateData?.esIq5Info, ...addNewIQ5Lst];
  //     }
  //     //
  //   }
  //   props?.loading(false); // Waitingダイアログを非表示にする
  // };

  // 追加呼出ダイアログのCancelボタン押下
  const selectParentInfoCancel = () => {
    setParentListDisplay(false);
  };

  const getSelectedEstimateData = (estimateData, iq3RowKey, estimateEditMode) => {
    setSelectedParentAddEstimate(estimateData);
  };

  const updateSelectedPatternNo = (id) => {
    setChildPatternNo(id);
  };

  const updateSelectedIQ5PatternNo = (id) => {
    setChildIQ5PatternNo(id);
  };

  const updateSelectedParentPatternNo = (id) => {
    setParentPatternNo(id);
  };

  const updateSelectedDXFParentPatternNo = (id) => {
    setDXFParentPatternNo(id);
  };

  const updateSelectedDXFPatternNo = (id) => {
    setDXFChildPatternNo(id);
  };

  const updatePatternList = (selectedProcessPattern, list, type) => {
    const data = { ...pmxSelectedEstimateData };

    if (type === 'iQ3') {
      data.iq3DataLst[0].iq3KouteiSentakuPatternNo[0].id = selectedProcessPattern.id;
      setPMXSelectedEstimateData(data);
    } else {
      data.kouteiSentakuPatternNo = selectedProcessPattern.id;
      setPMXSelectedEstimateData(data);
    }
  };

  const updatePMXEvent = () => {
    setIsPMXEvent(false);
    props?.loading(false); // PMXデータ読み取り、完了後Waitingダイアログを非表示にする
  };

  const updateCheckPMXOrNot = () => {
    setCheckPMXOrNot(false);
  };

  // 保存ボタン
  const saveMenuItems = [
    {
      label: <Image preview={false} width={33} src={save} style={{ marginRight: '6px' }}></Image>,
      key: 'save',
      children: [
        {
          label: saveMenuChildItems[0]?.label,
          key: saveMenuChildItems[0]?.key,
        },
        {
          label: saveMenuChildItems[1]?.label,
          key: saveMenuChildItems[1]?.key,
        },
      ],
    },
  ];

  const reportOutputMenuitems = [
    {
      label: <Image preview={false} width={30} src={export_report} style={{ marginLeft: '25px' }}></Image>,
      key: 'reportOutput',
      children: [
        {
          label: 'リスト帳票',
          key: 'listReport',
        },
        {
          label: '親部品帳票',
          key: 'parentReport',
        },
      ],
    },
  ];
  const listOutputMenuitems = [
    {
      label: (
        <Image
          preview={false}
          width={iconWidth}
          src={export_csv_icon}
          style={{ marginLeft: '30px', textDecoration: 'none' }}
        ></Image>
      ),
      key: 'listOutput',
      children: [
        {
          label: 'CSV出力(表示)',
          key: 'csvReport',
        },
        {
          label: 'CSV出力(全て)',
          key: 'csvAllReport',
        },
        {
          label: 'iQ見積アナライザ',
          key: 'iQReport',
        },
        {
          label: '明細出力',
          key: 'detailsReport',
        },
      ],
    },
  ];

  const pmxMenuItems = [
    {
      label: (
        <Image preview={false} width={28} src={pmx_import} style={{ marginLeft: '0px', marginTop: '0px' }}></Image>
      ),
      key: 'save',
      children: [
        {
          label: 'クラウド',
          key: 'cloud',
        },
        // 2025-05-23 ローカルPMXファイル読み込み
        {
          label: 'ローカル',
          key: 'local',
        },
      ],
    },
  ];

  const pcSaveMenuitems = [
    {
      label: <Image preview={false} width={28} src={pc_save} style={{ marginLeft: '10px' }}></Image>,
      key: 'pcSave',
      children: [
        {
          label: 'PC保存',
          key: 'pcSave',
        },
        {
          label: 'PC呼出',
          key: 'pcLoad',
        },
      ],
    },
  ];

  const reportModalTitle = (
    <div
      style={{
        width: 600,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
        display: 'flex',
      }}
    >
      <Image
        preview={false}
        width={20}
        src={confirm_icon}
        style={{ marginTop: 9, marginLeft: 7, display: isEstimateDataSaveConfirm ? '' : 'none' }}
      ></Image>
      <p style={{ marginLeft: 7, paddingTop: 8, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const pmxConfirmModalTitle = (
    <div
      style={{
        width: 300,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
        display: 'flex',
      }}
    >
      <Image preview={false} width={20} src={logo} style={{ marginTop: 9, marginLeft: 7 }}></Image>
      <p style={{ marginLeft: 10, paddingTop: 8, color: 'white' }}>PMX取り込み</p>
    </div>
  );

  const commonModalTitle = (
    <div
      style={{
        width: 520,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const sameDrawingNoModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>確認</p>
    </div>
  );

  const curtParamModalTitle = (
    <div
      style={{
        width: 520,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>CURT.パラメータの読込確認</p>
    </div>
  );

  /* 確認メッセージのタイトル */
  const confirmModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>確認</p>
    </div>
  );

  // 帳票出力
  const reportParentList = (
    <>
      <Row style={{ marginTop: 10 }}>
        <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>
          {isListOutputOpen
            ? 'CSV出力するフォーマットを選択してください'
            : '帳票出力するフォーマットを選択してください'}
        </p>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Col span={7}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>出力フォーマット：</p>
        </Col>
        <Col span={17}>
          {excelIndividualFormats !== undefined && excelIndividualFormats?.length > 0 ? (
            <Select
              style={{ width: 300, fontSize: 11 }}
              value={selectedExeclIndividualFormat?.id}
              onChange={(e) => {
                const selectedData = excelIndividualFormats?.find((item) => item?.id === e);
                if (selectedData !== undefined) {
                  setSelectedExeclIndividualFormat(selectedData);
                }
              }}
            >
              {excelIndividualFormats?.map((item) => (
                <Select.Option key={item?.id} value={item?.id}>
                  {item?.fileName}
                </Select.Option>
              ))}
            </Select>
          ) : (
            <Select style={{ width: 300, fontSize: 11 }} />
          )}
        </Col>
      </Row>
      {/* <Row style={{ marginTop: 10 }}>
        <Col span={7}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>出力元ファイル：</p>
        </Col>
        <Col span={17}>
          <Input className="input-editable" style={{ width: 300 }} />
          <Upload>
            <Button style={{ fontSize: '13.5px', marginLeft: '5px' }}>参照</Button>
          </Upload>
        </Col>
      </Row> */}
      <Row style={{ marginTop: '17px' }}>
        <Col span={24} style={{ textAlign: 'right' }} offset={0}>
          <Button onClick={reportOutputOk} className="mainButton" id="update">
            OK
          </Button>

          <Button onClick={reportOutputCancel} className="cancelButton" style={{ marginLeft: 10 }} id="discard">
            キャンセル
          </Button>
        </Col>
      </Row>
    </>
  );

  // PC保存
  const estimateDataSaveContent = (
    <>
      <Row style={{ marginTop: 0 }}>
        <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>
          パラメータが更新されています。最新を使用する項目を選択して下さい
        </p>
      </Row>
      <Row style={{ marginTop: '0px' }}>
        <Col span={2}>
          <Checkbox checked></Checkbox>
        </Col>
        <Col span={22}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>材料費</p>
        </Col>
      </Row>
      <Row style={{ marginTop: '0px' }}>
        <Col span={2}>
          <Checkbox></Checkbox>
        </Col>
        <Col span={22}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>装置のチャージ金額/係数</p>
        </Col>
      </Row>
      <Row style={{ marginTop: '0px' }}>
        <Col span={2}>
          <Checkbox checked></Checkbox>
        </Col>
        <Col span={22}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>購入品</p>
        </Col>
      </Row>
      <Row style={{ marginTop: '10px' }}>
        <Col span={24} style={{ textAlign: 'right' }} offset={0}>
          <Button onClick={reportOutputOk} className="mainButton" id="update">
            再計算
          </Button>

          <Button onClick={reportOutputCancel} className="cancelButton" style={{ marginLeft: 10 }} id="discard">
            キャンセル
          </Button>
        </Col>
      </Row>
    </>
  );

  // PMX取り込みコンテンツ
  const pmxConfirmContent = (
    <>
      <Row style={{ marginTop: 10 }}>
        <a
          onClick={(e) => openPMXFileDialog(e, '編集中見積り保存して、新規見積', CreatePMXData.SaveAndNew)}
          style={{ textDecoration: 'underline', color: '#1063aa', fontWeight: 'bold', textAlign: 'right' }}
        >
          編集中見積り保存して、新規見積
        </a>
      </Row>
      <Row style={{ marginTop: 7 }}>
        <a
          onClick={(e) => openPMXFileDialog(e, '新規見積', CreatePMXData.New)}
          style={{ textDecoration: 'underline', color: '#1063aa', fontWeight: 'bold', textAlign: 'right' }}
        >
          新規見積
        </a>
      </Row>
      <Row style={{ marginTop: 7 }}>
        <a
          onClick={(e) => openPMXFileDialog(e, '編集中見積に追加', CreatePMXData.Update)}
          style={{ textDecoration: 'underline', color: '#1063aa', fontWeight: 'bold', textAlign: 'right' }}
        >
          編集中見積に追加
        </a>
      </Row>
      <Row
        justify="end"
        style={{
          marginBottom: 0,
          marginTop: 15,
        }}
      >
        <Button className="cancelButton" onClick={pmxLocalProcessCancel}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  // 別名保存
  const saveByOtherNameInfoContent = (
    <>
      <p style={{ fontSize: '13.5px', height: 10, borderBottom: 10 }}>
        表示中の見積データを別名で保存します。必要な項目を編集してください。
      </p>
      <RTable className="propertiesTbl">
        <thead>
          <tr>
            <td className="detail-tbl-val-title">
              <label className="detail-tbl-val-title-label">図番</label>
            </td>
            <td colSpan={6} style={{ verticalAlign: 'middle' }}>
              <Input
                style={{ padding: 5, marginLeft: 5, width: '98.2%' }}
                className="input-editable "
                // ref={ref}
                name="inputDrawingNo"
                id="inputDrawingNo"
                value={inputDrawingNo}
                type="text"
                onChange={(e) => {
                  setInputDrawingNo(e.target.value);
                }}
              />
            </td>
          </tr>
          <tr>
            <td className="detail-tbl-val-title">
              <label className="detail-tbl-val-title-label">名称</label>
            </td>
            <td colSpan={6} style={{ verticalAlign: 'middle' }}>
              <Input
                style={{ padding: 5, marginLeft: 5, width: '98.2%' }}
                className="input-editable "
                name="parentEstimateName"
                id="parentEstimateName"
                value={parentEstimateName}
                type="text"
                onChange={(e) => {
                  setParentEstimateName(e.target.value);
                }}
              />
            </td>
          </tr>
          <tr>
            <td className="detail-tbl-val-title">
              <label className="detail-tbl-val-title-label">見積番号</label>
            </td>
            <td colSpan={6} style={{ verticalAlign: 'middle' }}>
              <Input
                style={{ padding: 5, marginLeft: 5, width: '98.2%' }}
                className="input-editable "
                name="estimateNo"
                id="estimateNo"
                value={estimateNo}
                type="text"
                onChange={(e) => {
                  setEstimateNo(e.target.value);
                }}
              />
            </td>
          </tr>
        </thead>
      </RTable>
    </>
  );

  // CURT.パラメータの読込確認のフォーム
  const curtParamInfoContent = (
    <>
      <p style={{ fontSize: '13.5px', height: 10, borderBottom: 10 }}>
        チェックされた項目の情報をCURT.パラに更新します。よろしいでしょうか。
      </p>
      <Row className="mt-1">
        <Col span={2}>
          <Checkbox
            checked={paramUpdateFlgInfos?.isMaterialParam}
            // 2025-06-02 ヘッダーの設定画面だと「CURT.パラ更新」でチェックボックスをいじれるが、
            // CURTボタンでもチェックボックスをいじれるようにしてほしい
            onChange={(e) => {
              const newValue = e.target.checked;

              setParamUpdateFlgInfos((prev) => {
                const updated = { ...(prev ?? {}), isMaterialParam: newValue };

                if (updateUserCURTSetting?.[0]?.parametersUpdateFlgInfos) {
                  updateUserCURTSetting[0].parametersUpdateFlgInfos.isMaterialParam = newValue;
                  setUpdateUserCURTSetting([...updateUserCURTSetting]);
                }

                return updated;
              });
            }}
          />
        </Col>
        <Col>
          <label>材料系（材質区分、材質名称、材料名称・重量単価）</label>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col span={2}>
          <Checkbox
            // 2025-06-02 ヘッダーの設定画面だと「CURT.パラ更新」でチェックボックスをいじれるが、
            // CURTボタンでもチェックボックスをいじれるようにしてほしい
            checked={paramUpdateFlgInfos?.isProcessParam}
            onChange={(e) => {
              const newValue = e.target.checked;

              setParamUpdateFlgInfos((prev) => {
                const updated = { ...(prev ?? {}), isProcessParam: newValue };

                if (updateUserCURTSetting?.[0]?.parametersUpdateFlgInfos) {
                  updateUserCURTSetting[0].parametersUpdateFlgInfos.isProcessParam = newValue;
                  setUpdateUserCURTSetting([...updateUserCURTSetting]);
                }

                return updated;
              });
            }}
          />
        </Col>
        <Col>
          <label>加工系（工程マスター、装置設定、工程パターン）</label>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col span={2}>
          <Checkbox
            checked={paramUpdateFlgInfos?.isPurchaseParam}
            // 2025-06-02 ヘッダーの設定画面だと「CURT.パラ更新」でチェックボックスをいじれるが、
            // CURTボタンでもチェックボックスをいじれるようにしてほしい
            onChange={(e) => {
              const newValue = e.target.checked;

              setParamUpdateFlgInfos((prev) => {
                const updated = { ...(prev ?? {}), isPurchaseParam: newValue };

                if (updateUserCURTSetting?.[0]?.parametersUpdateFlgInfos) {
                  updateUserCURTSetting[0].parametersUpdateFlgInfos.isPurchaseParam = newValue;
                  setUpdateUserCURTSetting([...updateUserCURTSetting]);
                }

                return updated;
              });
            }}
          />
        </Col>
        <Col>
          <label>購入品</label>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col span={2}>
          <Checkbox
            checked={paramUpdateFlgInfos?.isOtherParam}
            // 2025-06-02 ヘッダーの設定画面だと「CURT.パラ更新」でチェックボックスをいじれるが、
            // CURTボタンでもチェックボックスをいじれるようにしてほしい
            onChange={(e) => {
              const newValue = e.target.checked;

              setParamUpdateFlgInfos((prev) => {
                const updated = { ...(prev ?? {}), isOtherParam: newValue };

                if (updateUserCURTSetting?.[0]?.parametersUpdateFlgInfos) {
                  updateUserCURTSetting[0].parametersUpdateFlgInfos.isOtherParam = newValue;
                  setUpdateUserCURTSetting([...updateUserCURTSetting]);
                }

                return updated;
              });
            }}
          />
        </Col>
        <Col>
          <label>その他全て（係数、カスタマイズ・・・）</label>
        </Col>
      </Row>
      <Row className="mt-1" style={{ display: isCurtParam ? '' : 'none' }}>
        <Col>
          <Typography.Text type="secondary" style={{ fontSize: '11px', marginLeft: '5px' }}>
            ※更新する項目は、ユーザー設定画面の「CURT.パラ更新」で変更できます。
          </Typography.Text>
        </Col>
      </Row>
    </>
  );

  // 別名保存入力ボックスのOKボタン押下
  const saveByOtherNameOk = async () => {
    props?.loading(true); // Waitingダイアログを表示にする
    setIsSaveByOtherName(false);
    // if (activePartMenu === '1') {
    if (!formValidation()) {
      props?.loading(false); // Waitingダイアログを非表示にする
      return;
    }

    let currentEstimateData = parentEstimateRef?.current?.getParentEstimateInfo();
    let iq3EstimateData = iQ3EstimateRef?.current?.getIQ3EstimateDetailInfo();
    if (iq3EstimateData) currentEstimateData.esIq3Info = iq3EstimateData?.esIq3Info;
    let copyData = JSON.parse(JSON.stringify(currentEstimateData));

    copyData.estimateProducts = {
      ...copyData.estimateProducts,
      id: 0,
      estimateNo: estimateNo,
      drawingNo: inputDrawingNo,
      name: parentEstimateName,
    };

    // 同一図番があるか存在チェックする
    let companySetting = props?.companySettingInfo?.[0];
    if (!isSaveSameDrawingNo && !companySetting?.environments?.isUseSameName) {
      let estProducts = copyData.estimateProducts;
      let saveSameType = companySetting?.environments?.saveSameType;
      let isExist = await getIsExistSameEstimate(estProducts, saveSameType);
      if (isExist) {
        props?.loading(false); // Waitingダイアログを非表示にする
        setSaveSameDrawingNoFncName('saveByOtherNameOk');
        setIsSaveSameDrawingNo(true);
        return;
      }
    } else {
      setIsSaveSameDrawingNo(false);
    }

    copyData.epCustomCosts = copyData?.epCustomCosts?.map((cost) => {
      return { ...cost, id: 0 };
    });
    copyData.epCustomDates = copyData?.epCustomDates?.map((date) => {
      return { ...date, id: 0 };
    });
    copyData.epCustomLabels = copyData?.epCustomLabels?.map((label) => {
      return { ...label, id: 0 };
    });
    copyData.epCustomMemos = copyData?.epCustomMemos?.map((memo) => {
      return { ...memo, id: 0 };
    });

    copyData.esIq3Info = copyData?.esIq3Info?.map((item) => ({ ...item, id: 0 }));

    copyData.esIq5Info = copyData?.esIq5Info?.map((item) => ({ ...item, id: 0 }));

    // IQX_WEBEST-348 「別名保存」されたデータの作成日と更新日
    copyData.estimateProducts.created = dayjs(today).format('YYYY-MM-DD');
    copyData.estimateProducts.modified = dayjs(today).format('YYYY-MM-DD');

    let createdData = await createEstimateProductInfo(copyData);
    if (createdData && createdData?.estimateProducts !== undefined && createdData?.estimateProducts?.id !== undefined) {
      //データ保存成功の場合
      props.selectedEstimateData.estimateProducts.id = createdData?.estimateProducts?.id;
      props.selectedEstimateData.estimateProducts = createdData?.estimateProducts; // IQX_WEBEST-347 「別名保存」後に扱う見積データ
      props.selectedEstimateData.esIq3Info = createdData?.esIq3Info;
      props.selectedEstimateData.epCustomCosts = createdData?.epCustomCosts;
      props.selectedEstimateData.epCustomDates = createdData?.epCustomDates;
      props.selectedEstimateData.epCustomLabels = createdData?.epCustomLabels;
      props.selectedEstimateData.epCustomMemos = createdData?.epCustomMemos;

      copyData = createdData; // IQX_WEBEST-347 「別名保存」後に扱う見積データ
      setSelectedEstimateDataTemp(JSON.parse(JSON.stringify(createdData)));
      setSelectedEstimateData(JSON.parse(JSON.stringify(createdData)));
      props?.setTempEstimateData(JSON.parse(JSON.stringify(createdData)));
      props?.setSelectedEstimateData(JSON.parse(JSON.stringify(createdData)));
    } else {
      //データ保存失敗の場合
      props.selectedEstimateData.estimateProducts.id = 0;
      copyData.estimateProducts.id = 0;
      setSelectedEstimateDataTemp(JSON.parse(JSON.stringify(copyData)));
      setSelectedEstimateData(JSON.parse(JSON.stringify(copyData)));
      props?.setTempEstimateData(JSON.parse(JSON.stringify(copyData)));
      props?.setSelectedEstimateData(JSON.parse(JSON.stringify(copyData)));
    }

    setSaveDiscardConfirmPopup(false);
    // if (navigateTabName === 'sheetMetal') {
    //   navigate(':estimate.iq3');
    //   setActivePartMenu('2');
    // } else if (navigateTabName === 'parent') {
    //   navigate(':estimate.parent');
    //   setActivePartMenu('1');
    // }
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // 別名保存入力ボックスのCancelボタン押下
  const saveByOtherNameCancel = () => {
    setIsSaveByOtherName(false);
  };

  // 同一図面で保存する確認メッセージのOkボタン押下
  const saveSameDrawingNoOk = async () => {
    await eval(saveSameDrawingNoFncName + '()');
  };

  // 同一図面で保存する確認メッセージのCancelボタン押下
  const saveSameDrawingNoCancel = () => {
    setIsSaveSameDrawingNo(false);
  };

  // 上書き保存のOKボタン押下
  const saveByOverwriteOk = async () => {
    props?.loading(true); // Waitingダイアログを表示にする
    setIsSaveByOverwrite(false);
    // if (activePartMenu === '1') {
    if (!formValidation()) {
      props?.loading(false); // Waitingダイアログを非表示にする
      return;
    }
    let currentEstimateData = parentEstimateRef?.current?.getParentEstimateInfo();

    // 同一図番があるか存在チェックする
    let companySetting = props?.companySettingInfo?.[0];
    if (!isSaveSameDrawingNo && !companySetting?.environments?.isUseSameName) {
      let estProducts = currentEstimateData?.estimateProducts;
      let saveSameType = companySetting?.environments?.saveSameType;
      let isExist = await getIsExistSameEstimate(estProducts, saveSameType);
      if (isExist) {
        props?.loading(false); // Waitingダイアログを非表示にする
        setSaveSameDrawingNoFncName('saveByOverwriteOk');
        setIsSaveSameDrawingNo(true);
        return;
      }
    } else {
      setIsSaveSameDrawingNo(false);
    }

    let iq3EstimateData = iQ3EstimateRef?.current?.getIQ3EstimateDetailInfo();
    if (iq3EstimateData) currentEstimateData.esIq3Info = iq3EstimateData?.esIq3Info;
    let updatedData = await updateEstimateProductInfo(currentEstimateData);
    if (updatedData) {
      // setSelectedEstimateDataTemp(currentEstimateData);
      currentEstimateData.estimateProducts.modified = updatedData?.estimateProducts?.modified;
      setSelectedEstimateDataTemp(JSON.parse(JSON.stringify(currentEstimateData)));
      setSelectedEstimateData(JSON.parse(JSON.stringify(currentEstimateData)));
      props?.setTempEstimateData(JSON.parse(JSON.stringify(currentEstimateData)));
      props?.setSelectedEstimateData(JSON.parse(JSON.stringify(currentEstimateData)));
      // IQX_WEBEST-339 保存していたデータを呼び出し、上賀書き保存しても更新日が変わりません。
      props.selectedEstimateData.estimateProducts.modified = updatedData?.estimateProducts?.modified;
    }

    // await getEstiamteIQ3Data(updatedData?.estimateProducts?.id);
    // } else {
    // }
    setSaveDiscardConfirmPopup(false);
    props.updateNewMode(false);
    // if (navigateTabName === 'sheetMetal') {
    //   navigate(':estimate.iq3');
    //   setActivePartMenu('2');
    // } else if (navigateTabName === 'parent') {
    //   navigate(':estimate.parent');
    //   setActivePartMenu('1');
    // }
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  // 上書き保存のCancelボタン押下
  const saveByOverwriteCancel = () => {
    setIsSaveByOverwrite(false);
  };
  //新規保存
  const createOk = async () => {
    props?.loading(true); // Waitingダイアログを表示にする
    setCreateConfirm(false);
    // if (activePartMenu == '1') {
    // 親部品見積のデータ保存
    let parentValidation = parentEstimateRef?.current?.kihonFormValidation();
    if (!parentValidation) {
      props?.loading(false); // Waitingダイアログを非表示にする
      return;
    }
    let iq3Validation = iQ3EstimateRef?.current?.kihonFormValidation();
    if (!iq3Validation) {
      props?.loading(false); // Waitingダイアログを非表示にする
      return;
    }

    let currentEstimateData = parentEstimateRef?.current?.getParentEstimateInfo();

    // 同一図番があるか存在チェックする
    let companySetting = props?.companySettingInfo?.[0];
    if (!isSaveSameDrawingNo && !companySetting?.environments?.isUseSameName) {
      let estProducts = currentEstimateData?.estimateProducts;
      let saveSameType = companySetting?.environments?.saveSameType;
      let isExist = await getIsExistSameEstimate(estProducts, saveSameType);
      if (isExist) {
        props?.loading(false); // Waitingダイアログを非表示にする
        setSaveSameDrawingNoFncName('createOk');
        setIsSaveSameDrawingNo(true);
        return;
      }
    } else {
      setIsSaveSameDrawingNo(false);
    }

    let iq3EstimateData = iQ3EstimateRef?.current?.getIQ3EstimateDetailInfo();
    if (iq3EstimateData) currentEstimateData.esIq3Info = iq3EstimateData?.esIq3Info;

    // 2025-05-23 ローカルPMXファイル読み込み
    let createdData = await createEstimateProductInfo(currentEstimateData, false);
    if (createdData && createdData?.estimateProducts !== undefined && createdData?.estimateProducts?.id !== undefined) {
      //データ保存成功の場合
      props.selectedEstimateData.estimateProducts.id = createdData?.estimateProducts?.id;
      props.selectedEstimateData.estimateProducts = createdData?.estimateProducts; // IQX_WEBEST-347 「別名保存」後に扱う見積データ
      props.selectedEstimateData.esIq3Info = createdData?.esIq3Info;
      props.selectedEstimateData.epCustomCosts = createdData?.epCustomCosts;
      props.selectedEstimateData.epCustomDates = createdData?.epCustomDates;
      props.selectedEstimateData.epCustomLabels = createdData?.epCustomLabels;
      props.selectedEstimateData.epCustomMemos = createdData?.epCustomMemos;

      currentEstimateData = createdData; // IQX_WEBEST-347 「別名保存」後に扱う見積データ
      setSelectedEstimateData(JSON.parse(JSON.stringify(createdData)));
      setSelectedEstimateDataTemp(JSON.parse(JSON.stringify(createdData)));
      props?.setTempEstimateData(JSON.parse(JSON.stringify(createdData)));
      props?.setSelectedEstimateData(JSON.parse(JSON.stringify(createdData)));

      // 2025-05-23 ローカルPMXファイル読み込み
      Modal.success({
        width: 465,
        className: 'modal-complete',
        title: '完了',
        content: (
          <p style={{ fontSize: '13.5px', whiteSpace: 'pre-line', lineHeight: 2 }}>データ保存は正常に完了しました。</p>
        ),
        onOk: () => {
          //
          if (currentPMXMenu === 'local') {
            inputFile.current.click();
          }
        },
      });
    } else {
      //データ保存失敗の場合
      props.selectedEstimateData.estimateProducts.id = 0;
      currentEstimateData.estimateProducts.id = 0;
      setSelectedEstimateData(JSON.parse(JSON.stringify(currentEstimateData)));
      setSelectedEstimateDataTemp(JSON.parse(JSON.stringify(currentEstimateData)));
      props?.setTempEstimateData(JSON.parse(JSON.stringify(currentEstimateData)));
      props?.setSelectedEstimateData(JSON.parse(JSON.stringify(currentEstimateData)));
    }
    // await getEstiamteIQ3Data(createdData?.estimateProducts?.id);
    setCreateConfirm(false);
    setSaveDiscardConfirmPopup(false);
    props.updateNewMode(false);
    // if (navigateTabName === 'sheetMetal') {
    //   navigate(':estimate.iq3');
    //   setActivePartMenu('2');
    // }
    // } else {
    //   // 板金の見積データ保存
    //   if (navigateTabName === 'parent') {
    //     navigate(':estimate.parent');
    //     setActivePartMenu('1');
    //   }
    // }
    props?.loading(false); // Waitingダイアログを非表示にする
  };
  // 新規保存のCancelボタン押下
  const createCancel = () => {
    setCreateConfirm(false);

    // 2025-05-23 ローカルPMXファイル読み込み
    if (currentPMXMenu === 'local') {
      inputFile.current.click();
    }
  };

  // 破壊確認メッセージのOKボタン押下
  const discardOk = async () => {
    props?.loading(true); // Waitingダイアログを表示にする
    const data = JSON.parse(JSON.stringify(selectedEstimateDataTemp));
    if (data) {
      let calEstimateData = updateEstimateInfoByReCal(data, props?.isEstimateOpen, props?.hyoumenProcess); // IQX_WEBEST-305 過去データを開いた直後、再計算をしない限りはタブ切替しても計算しないでほしい。
      updateEstimateInfo(calEstimateData);
      props.updateSelectedEstimateData(calEstimateData);
    }
    setDiscardConfirm(false);
    setSaveDiscardConfirmPopup(false);
    if (navigateTabName === 'sheetMetal') {
      navigate(':estimate.iq3');
      setActivePartMenu('2');
      props?.updateActiveTabKey('2');
    } else if (navigateTabName === 'parent') {
      navigate(':estimate.parent');
      setActivePartMenu('1');
      props?.updateActiveTabKey('1');
    } else if (navigateTabName === 'beams') {
      navigate(':estimate.iq5');
      setActivePartMenu('3');
      props?.updateActiveTabKey('3');
    }
    props?.loading(false); // Waitingダイアログを非表示にする
  };

  const discardCancel = () => {
    setDiscardConfirm(false);
  };

  // CURT.パラチェックなしのOKボタン押下
  const curtParmNoCheckOk = () => {
    setNoCheckMsg(false);
  };

  // CURT.パラチェックなしのCancelボタン押下
  const curtParmNoCheckCancel = () => {
    setNoCheckMsg(false);
  };

  // CURT.パラメータ読込確認のOKボタン押下
  const curtParamOk = () => {
    setUpdateConfirm(true);
  };

  // CURT.パラメータ読込確認のCancelボタン押下
  const curtParamCancel = () => {
    setIsCurtParam(false);
  };

  // 更新確認メッセージのOKボタン押下
  const confirmOk = async () => {
    if (isCurtParam) {
      if (
        paramUpdateFlgInfos?.isMaterialParam ||
        paramUpdateFlgInfos?.isOtherParam ||
        paramUpdateFlgInfos?.isProcessParam ||
        paramUpdateFlgInfos?.isPurchaseParam
      ) {
        props?.loading(true); // Waitingダイアログを表示にする
        setIsCurtParam(false);
        setUpdateConfirm(false);
        let msgStr = 'CURT.パラに以下の項目が更新されました。\n更新されたパラメータ情報により、再計算されます。\n';
        if (paramUpdateFlgInfos?.isMaterialParam) msgStr += '・材料系\n';
        if (paramUpdateFlgInfos?.isProcessParam) msgStr += '・加工系\n';
        if (paramUpdateFlgInfos?.isPurchaseParam) msgStr += '・購入品\n';
        if (paramUpdateFlgInfos?.isOtherParam) msgStr += '・その他全て（係数。カスタマイズ・・・）\n';
        complete(msgStr);
        let flgInfos = paramUpdateFlgInfos;
        props?.settingParametersByReCal(
          // 選択した、パラメータタイプを更新して再計算する
          ParamCalType.NewParam,
          flgInfos?.isMaterialParam,
          flgInfos?.isProcessParam,
          flgInfos?.isPurchaseParam,
          flgInfos?.isOtherParam
        );
        // 2025-06-02 ヘッダーの設定画面だと「CURT.パラ更新」でチェックボックスをいじれるが、
        // CURTボタンでもチェックボックスをいじれるようにしてほしい
        if (updateUserCURTSetting) {
          await updateUserSetting(updateUserCURTSetting[0], 3);
        }
      } else {
        setIsCurtParam(false);
        setUpdateConfirm(false);
        setNoCheckMsg(true);
      }
    }
  };

  // 更新確認メッセージのCancelボタン押下
  const confirmCancel = () => {
    setUpdateConfirm(false);
  };

  const parentListModalTitle = (
    <div
      style={{
        width: 1670,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 33,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 5, paddingLeft: 18, color: 'white' }}>追加呼出</p>
    </div>
  );
  const estimateDataDiscardEvent = () => {
    //setDiscardConfirm(true);

    let editCancel =
      props?.userSettingInfo?.[0]?.massages?.editCancel == undefined
        ? true
        : props?.userSettingInfo?.[0]?.massages?.editCancel;
    setDiscardConfirm(editCancel);
    if (!editCancel) {
      discardOk();
    }
  };

  const closeOk = () => {
    setSaveDiscardConfirmPopup(false);
  };

  // 別名保存の入力フォーム
  const saveEstimateDataByOtherName = () => {
    setIsSaveByOtherName(true);
    // setInputDrawingNo(formatDateString(todayTime()));
    let currentEstimateData = parentEstimateRef?.current?.getParentEstimateInfo();
    const data = JSON.parse(JSON.stringify(currentEstimateData));
    setEstimateNo(data?.estimateProducts?.estimateNo + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
    setInputDrawingNo(data?.estimateProducts?.drawingNo + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
    setParentEstimateName(data?.estimateProducts?.name + ' ' + formatDateString(todayTime())); // IQX_WEBEST-346 見積データ「別名保存」操作時の図番、名称、見積番号の初期値変更
  };

  const cancelOk = () => {
    setSaveDiscardConfirmPopup(false);
  };

  const updateSteelList = () => {
    setIsUpdateSteel(true);
    // setBulkIQ5DataLst(JSON.parse(JSON.stringify(selectedEstimateData?.esIq5Info)));
    setBulkIQ5DataLst(selectedEstimateData?.esIq5Info);
    setSizeForBulkEdit(0);
    setPartCountForBulkEdit(0);
    setChkRowsCount(0);
    setBulkEditSelectedRowId([]);
    setBulkEditSelectedRow([]);
    setProcessSelectedDataUpdate(false);

    setChildTitle('選択したデータをまとめて編集');
  };

  // まとめて編集(IQX_WEBEST-177)
  const updateAll = () => {
    setIsUpdate(true);
    setMaterialTypeId('');
    setThickness('');
    setMaterialSurfaceId('');
    setPartCount('');
    setBulkIQ3DataLst(selectedEstimateData?.esIq3Info);
    const patternLst = estimateParameters?.processPattern;
    let kouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.SheetMetal);
    setListData(kouteiPatternList);
    setProcessSelectedData(kouteiPatternList[0]);
    setChkRowsCount(0);
    setBulkEditSelectedRowId([]);
    setBulkEditSelectedRow([]);
    setProcessSelectedDataUpdate(false);
    // タブの初期表示
    let iq3ActiveTabKey = iQ3EstimateRef?.current?.getIQ3ActiveTabKey();
    if (iq3ActiveTabKey === '2') {
      setActiveBulkEditTabKey('2');
    } else {
      setActiveBulkEditTabKey('1');
    }
    setChildTitle('選択したデータをまとめて編集');
    setIsAllEdit(true);
  };

  // 一括編集-開始
  let checkedRow = [];
  const onRowCheckboxSelect = (checked, record) => {
    checkedRow = [...checked];
    setBulkEditSelectedRow([...record]);
    setBulkEditSelectedRowId(checkedRow);
    setChkRowsCount(checkedRow?.length);
    setSteelMaterialName(record?.[0]?.materialName);
    setSteelMaterialId(record?.[0]?.materialIq5Id);
    setSizeForBulkEdit(record?.[0]?.size);
    setPartCountForBulkEdit(record?.[0]?.partCount);
  };

  const updateDataIq5 = () => {
    setIsUpdateSteel(false);
    setIsUpdate(false);

    const updatedEsIq5Info = [...selectedEstimateData?.esIq5Info];

    if (bulkEditSelectedRow?.length > 0) {
      // bulkEditSelectedRow.map((item) => {
      //   const updatedItem = {
      //     ...item, // Copy all properties of the current item
      //     size: sizeForBulkEdit,
      //     partCount: partCountForBulkEdit,
      //     steelShapeId: selectedSteelSelect?.steelShapeId,
      //     steelShapeName: selectedSteelClassList?.filter(
      //       (s) => s.id === selectedSteelSelect?.steelShapeId
      //     )?.[0]?.name,
      //     materialTypeIq5Id: selectedSteelSelect?.materialTypeIq5Id,
      //     materialTypeName: selectedSteelTypeList?.filter(
      //       (s) => s.id === selectedSteelSelect?.materialTypeIq5Id
      //     )?.[0]?.name,
      //     materialName: selectedSteelSelect?.name,
      //     materialIq5Id: selectedSteelSelect?.id,
      //     imageId: selectedSteelClassList?.filter(
      //       (s) => s.id === selectedSteelSelect?.steelShapeId
      //     )?.[0]?.shapeNo,
      //   };

      //   // Find the corresponding item in esIq5Info and update it
      //   const indexToUpdate = updatedEsIq5Info.findIndex(
      //     (esItem) => esItem.no === item.no // Match based on 'no' or another unique identifier
      //   );

      //   if (indexToUpdate !== -1) {
      //     // Update the matching item in the array
      //     updatedEsIq5Info[indexToUpdate] = updatedItem;
      //   }
      // });

      // setSelectedEstimateData((prevState) => ({
      //   ...prevState,
      //   esIq5Info: updatedEsIq5Info, // Update only the modified data in esIq5Info
      // }));

      // iQ5EstimateRef?.current?.updateiq5ActionForCal(true);

      bulkEditSelectedRow.map((item) => {
        item.size = sizeForBulkEdit;
        item.partCount = partCountForBulkEdit;
        item.steelShapeId = selectedSteelSelect?.steelShapeId;

        item.steelShapeName = selectedSteelClassList?.filter(
          (item) => item.id === selectedSteelSelect?.steelShapeId
        )?.[0]?.name;
        item.materialTypeIq5Id = selectedSteelSelect?.materialTypeIq5Id;
        item.materialTypeName = selectedSteelTypeList?.filter(
          (item) => item.id === selectedSteelSelect?.materialTypeIq5Id
        )?.[0]?.name;
        item.materialName = selectedSteelSelect?.name;
        item.materialIq5Id = selectedSteelSelect?.id;
        item.imageId = selectedSteelClassList?.filter(
          (item) => item.id === selectedSteelSelect?.steelShapeId
        )?.[0]?.shapeNo;
      });

      selectedEstimateData?.esIq5Info.map((item) => {
        let curMaterialIq5 = estimateParameters?.materialIq5?.find(
          (mat) => mat.id === item?.materialIq5Id && mat?.info?.isUsed
        );
        iQ5EstimateRef?.current?.calMaterialAndProcessingAmtByAllWorkType(curMaterialIq5, item);
      });

      iQ5EstimateRef?.current?.updateiq5ActionForCal(true);

      // Uncomment and implement these lines if needed
      // iQ3EstimateRef?.current?.updateIq3ActionForCal(true);
      // setIsAllUpdateOK(true);
    }
  };

  const updateData = () => {
    setIsUpdateSteel(false);
    setIsUpdate(false);
    if (bulkEditSelectedRow?.length > 0) {
      iQ3EstimateRef?.current?.updateIq3ActionForCal(true);
      setIsAllUpdateOK(true);
    }
  };

  const discardData = () => {
    setIsUpdateSteel(false);
    setIsUpdate(false);
  };

  const bulkEditRowSelect = {
    onChange: onRowCheckboxSelect,
  };

  // タブの切り替え
  const onChangeBulkEditTab = (key) => {
    setActiveBulkEditTabKey(key);
  };

  const updateKouteiSentakuInfo = (selectedProcessPattern, list) => {
    setProcessSelectedData(selectedProcessPattern);
    setProcessSelectedDataUpdate(true);
  };

  // 部品追加ボタンの押下
  const addPart = () => {
    let iq3Data = [...iq3EstimateInitInfo];
    var copyPart = iQ3EstimateRef?.current?.getNewIQ3EstimateInfo(JSON.parse(JSON.stringify(iq3Data)));
    if (copyPart?.length > 0) copyPart = copyPart[0];
    let tempIQ3List = [...bulkIQ3DataLst];
    if (bulkIQ3DataLst != undefined && bulkIQ3DataLst?.length > 0) {
      var lastRecord = tempIQ3List.sort((a, b) => b.no - a.no)?.[0];
      copyPart = {
        ...copyPart,
        no: lastRecord?.no + 1,
        name: 'Part_' + padWithLeadingZeros(lastRecord?.no + 1, 5),
        materialCostUnitPrice: 0,
        materialCostTotalPrice: 0,
        costUnitPrice: 0,
      };
    } else {
      copyPart = {
        ...copyPart,
        no: lastRecord?.no + 1,
        materialCostUnitPrice: 0,
        materialCostTotalPrice: 0,
        costUnitPrice: 0,
      };
    }
    if (tempIQ3List?.length > 0) {
      tempIQ3List?.push(copyPart);
      tempIQ3List?.sort((a, b) => a?.no - b?.no);
      setBulkIQ3DataLst(tempIQ3List);
    }
  };

  // 部品削除ボタンの押下
  const deletePart = () => {
    if (bulkIQ3DataLst?.length <= 1) return;
    let tempIQ3List = [...bulkIQ3DataLst];
    for (let i = 0; i < bulkEditSelectedRow?.length; i++) {
      tempIQ3List = tempIQ3List?.filter((item) => item.no !== bulkEditSelectedRow[i].no);
      tempIQ3List = tempIQ3List?.map((item, index) => {
        return { ...item, no: index + 1 };
      });
    }
    if (bulkEditSelectedRow?.length > 0) {
      tempIQ3List?.sort((a, b) => a?.no - b?.no);
      if (tempIQ3List?.length > 0) setBulkIQ3DataLst(tempIQ3List);
      setBulkEditSelectedRow([]);
      setBulkEditSelectedRowId([]);
    }
  };

  const saveDiscardConfirmContent = (
    <>
      <Row>
        <p style={{ fontSize: '13.5px' }}>
          見積データが保存されていません。
          <br />
          そのまま画面を切り替えると編集データが削除されます。
          <br /> 保存しますか？
        </p>
      </Row>
      <Row align="middle">
        <Col span={8}>
          {selectedEstimateData?.estimateProducts?.id === 0 ? (
            <>
              <Button className="mainButton" onClick={createOk}>
                保存
              </Button>
            </>
          ) : (
            <>
              <Space size={'middle'}>
                <Button className="mainButton" onClick={saveEstimateDataByOtherName}>
                  別名保存
                </Button>
                <Button className="mainButton" onClick={saveByOverwriteOk}>
                  上書保存
                </Button>
              </Space>
            </>
          )}
        </Col>

        <Col span={8} offset={7}>
          <Space size={'middle'}>
            <Button className="discardButton" style={{ textAlign: 'center' }} onClick={discardOk}>
              {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
              {/* 破棄 */}
              戻る
            </Button>
            <Button className="cancelButton" onClick={cancelOk}>
              キャンセル
            </Button>
          </Space>
        </Col>
      </Row>
    </>
  );

  const steelEditModalTitle = (
    <div
      style={{
        width: isUpdateSteel ? 1790 : 520,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );

  const editModalTitle = (
    <div
      style={{
        width: isUpdate ? 1790 : 520,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{childTitle}</p>
    </div>
  );
  const bulkEditTabItems = [
    {
      key: '1',
      label: `基本情報`,
    },
    {
      key: '2',
      label: `工程選択`,
    },
  ];

  // 一括編集画面で員数を変更した場合、
  const onChangePartCount = (value, isCheckZenkaku = true) => {
    let partCnt = value;
    if (regexExp.test(partCnt) && !isDigitZenkaku(partCnt)) return;
    if (isCheckZenkaku && regexExp.test(partCnt)) {
      // 全角の場合、
      partCnt = toHalfWidth(partCnt); // 半角へ変換
      if (!isDigit(partCnt)) return;
    }
    setPartCount(partCnt);
  };

  // 形鋼一括編集
  const editSteelAllContent = (
    <>
      <Row style={{ paddingBottom: 0, paddingTop: 0 }}>
        {/** 一覧 */}
        <Col span={16}>
          <div style={{ display: 'flex' }}>
            <Table
              id="iq3EstimateTbl"
              showSorterTooltip={false}
              rowClassName={(record) => (record.no == bulkEditSelectedRowId ? 'active-row' : 'data-row')}
              columns={iq5Columns}
              rowKey={(record) => record.no}
              dataSource={bulkIQ5DataLst}
              className="parent-detail-EditTable"
              pagination={false}
              scroll={{ y: 250, x: '10vw' }}
              rowSelection={bulkEditRowSelect}
            />
          </div>
        </Col>
        <Col span={8}>
          <div
            style={{
              marginTop: 40,
              marginLeft: 10,
            }}
          >
            <div style={{ display: 'flex' }}>
              <RTable className="propertiesTbl">
                <thead>
                  <tr>
                    <td className="detail-tbl-val-title">
                      <label className="detail-tbl-val-title-label">材料名</label>
                    </td>
                    <td className="detail-tbl-val">
                      <Row>
                        <Input
                          style={{ padding: 5, marginLeft: 5, width: '70.5%' }}
                          className="input-editable"
                          name="partCount"
                          value={steelMaterialName}
                        />
                        <div style={{ textAlign: 'center', marginLeft: 5 }}>
                          <Button className={'iq5-material-select-btn'} onClick={() => showSteelMaterial()}>
                            選択
                          </Button>
                        </div>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    <td className="detail-tbl-val-title">
                      <label className="detail-tbl-val-title-label">寸法</label>
                    </td>
                    <td className="detail-tbl-val">
                      <Input
                        style={{ padding: 5, marginLeft: 5, width: '90.5%' }}
                        className="input-editable"
                        name="size"
                        value={sizeForBulkEdit}
                        onChange={(e) => {
                          let inputVal = e.target.value;
                          if (sizeForBulkEdit !== inputVal) {
                            setSizeForBulkEdit(inputVal);
                          }
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="detail-tbl-val-title">
                      <label className="detail-tbl-val-title-label">員数</label>
                    </td>
                    <td className="detail-tbl-val">
                      <Input
                        style={{ padding: 5, marginLeft: 5, width: '90.5%' }}
                        className="input-editable"
                        name="partCount"
                        value={partCountForBulkEdit}
                        onChange={(e) => {
                          let inputVal = e.target.value;
                          if (partCountForBulkEdit !== inputVal) {
                            setPartCountForBulkEdit(inputVal);
                          }
                        }}
                      />
                    </td>
                  </tr>
                </thead>
              </RTable>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        justify="end"
        style={{
          marginBottom: 0,
          marginTop: -40,
        }}
      >
        <Button className="mainButton" onClick={updateDataIq5} style={{ marginRight: 5 }}>
          OK
        </Button>
        <Button className="cancelButton" onClick={discardData}>
          {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
          {/* 破棄 */}
          戻る
        </Button>
      </Row>
    </>
  );

  // 一括編集
  const editAllContent = (
    <>
      <Row style={{ paddingBottom: 0, paddingTop: 0 }}>
        {/** 一覧 */}
        <Col span={11}>
          <div style={{ display: 'flex' }}>
            <p style={{ fontSize: '13.5px', fontWeight: 'bold', marginTop: 6 }}>{chkrowscount}件を選択中</p>
            <Tooltip title="部品追加" placement="bottom" overlayClassName="tooltip-text">
              <a
                onClick={() => {
                  addPart();
                }}
              >
                <Image preview={false} width={27} src={child_add} style={{ marginLeft: '10px' }}></Image>
              </a>
            </Tooltip>
            <Tooltip title="部品削除" placement="bottom" overlayClassName="tooltip-text">
              <a
                onClick={() => {
                  deletePart();
                }}
              >
                <Image
                  preview={false}
                  width={23}
                  src={child_delete}
                  style={{ marginLeft: '25px', marginTop: '2px' }}
                ></Image>
              </a>
            </Tooltip>
          </div>
          <Table
            id="iq3EstimateTbl"
            showSorterTooltip={false}
            rowClassName={(record) => (record.no == bulkEditSelectedRowId ? 'active-row' : 'data-row')}
            columns={iq3Columns}
            rowKey={(record) => record.no}
            dataSource={bulkIQ3DataLst}
            className="parent-detail-EditTable"
            pagination={false}
            scroll={{ y: 250, x: '10vw' }}
            rowSelection={bulkEditRowSelect}
          />
        </Col>
        {/** プロパティレイアウト */}
        <Col span={13}>
          <div
            style={{
              marginTop: 40,
              marginLeft: 10,
            }}
          >
            {/* 工程選択警告文章 */}
            <div
              style={{
                display: 'flex',
              }}
            >
              <Tabs
                id="iq3-detail-tab"
                className="iq3-detail-tab iq3-detail-tab-bulkedit"
                type="card"
                activeKey={activeBulkEditTabKey}
                defaultActiveKey="1"
                items={bulkEditTabItems}
                onChange={onChangeBulkEditTab}
              />
              {/* IQX_WEBEST-367 板金子部品の一括編集画面の工程選択タブにある「変更していない項目も一括で変更する」チェックにチェックできない。 */}
              <div style={{ textAlign: 'right', display: activeBulkEditTabKey == '2' ? 'block' : 'none' }}>
                <Checkbox
                  style={{ marginRight: 10 }}
                  type="checkbox"
                  checked={isAllEdit}
                  onChange={(e) => {
                    setIsAllEdit(e.target.checked);
                  }}
                >
                  変更していない項目も一括編集する
                </Checkbox>
              </div>
            </div>
            {/* 基本情報 */}
            <div
              style={{ display: activeBulkEditTabKey == '1' ? 'block' : 'none', marginTop: 10 }}
              className="iq3-tab-div"
            >
              <RTable className="propertiesTbl">
                <thead>
                  <tr>
                    <td className="detail-tbl-val-title">
                      <label className="detail-tbl-val-title-label">員数</label>
                    </td>
                    <td className="detail-tbl-val">
                      <Input
                        style={{ padding: 5, marginLeft: 5, width: '35.5%' }}
                        // className={editMode ? 'input-editable ' : 'input-non-editable '}
                        className="input-editable"
                        name="partCount"
                        value={partCount}
                        onKeyPress={(e) => {
                          handleKeyPress(e, true);
                        }}
                        // ref={(ref) => {
                        //   if (ref) inputItemRef['partCount'] = ref;
                        // }}
                        onPressEnter={(e) => onChangePartCount(e.target.value)}
                        onBlur={(e) => onChangePartCount(e.target.value)}
                        onChange={(e) => onChangePartCount(e.target.value, false)}
                        // disabled
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="detail-tbl-val-title">
                      <label className="detail-tbl-val-title-label">材質</label>
                    </td>
                    <td className="detail-tbl-val">
                      <Select
                        showSearch
                        className="iq3-detail-select"
                        name="materialTypeId"
                        value={materialTypeId ? materialTypeId : ''}
                        onChange={(e) => {
                          setMaterialTypeId(e);
                        }}
                        filterOption={filterOption}
                        style={{ marginLeft: 5, width: '98.2%' }}
                      >
                        {materialTypeLst
                          ?.filter(
                            (item) => materialLst?.findIndex((mItem) => mItem.materialTypeIq3Id === item.id) > -1
                          )
                          ?.map((option, index) => (
                            <Select.Option key={index} value={option.id}>
                              {option.name}
                            </Select.Option>
                          ))}
                      </Select>
                    </td>
                  </tr>
                  {/* <tr>
                    <td className="detail-tbl-val-title">
                      <label className="detail-tbl-val-title-label">材料名称</label>
                    </td>
                    <td className="detail-tbl-val">
                      <Select
                        className="iq3-detail-select"
                        name="materialId"
                        value={materialId ? materialId : ''}
                        onChange={(e) => {
                          setMaterialId(e);
                          setThickness(e);
                        }}
                        style={{ marginLeft: 5, width: '98.2%' }}
                      >
                        {materialLst
                          ?.filter((item) => item.info.isUsed && item.materialTypeIq3Id === materialTypeId)
                          ?.map((option, index) => (
                            <Select.Option key={index} value={option.id}>
                              {option.name}
                            </Select.Option>
                          ))}
                      </Select>
                    </td>
                  </tr> */}
                  <tr>
                    <td className="detail-tbl-val-title">
                      <label className="detail-tbl-val-title-label">板厚</label>
                    </td>
                    <td className="detail-tbl-val">
                      {/* {editMode ? ( */}
                      <Select
                        name="thickness"
                        className="iq3-detail-select"
                        value={thickness ? thickness : ''}
                        onChange={(e) => {
                          setThickness(e);
                        }}
                        style={{ marginLeft: 5, width: '35.5%' }}
                      >
                        {materialLst
                          ?.filter((item) => item.info.isUsed && item.materialTypeIq3Id === materialTypeId)
                          ?.map((option, index) => (
                            <Select.Option key={index} value={option.id}>
                              {option.info.thick}
                            </Select.Option>
                          ))}
                      </Select>
                      {/* ) : (
                    <Input
                      style={{ padding: 5, marginLeft: 5, width: '98.2%' }}
                      className={'input-non-editable '}
                      type="text"
                      value={getMaterialThickById(thickness, materialNmLst)}
                    />
                  )} */}
                    </td>
                  </tr>
                  <tr>
                    <td className="detail-tbl-val-title">
                      <label className="detail-tbl-val-title-label">表面保護</label>
                    </td>
                    <td className="detail-tbl-val">
                      {/* {editMode ? ( */}
                      <Select
                        name="materialSurface"
                        className="iq3-detail-select"
                        value={materialSurfaceId ? materialSurfaceId : ''}
                        onChange={(e) => {
                          setMaterialSurfaceId(e);
                        }}
                        style={{ marginLeft: 5, width: '35.5%' }}
                      >
                        {materialSurfaceLst
                          ?.filter((item) => item.info.isUsed && item.materialTypeIq3Id === materialTypeId)
                          ?.map((option, index) => (
                            <Select.Option key={index} value={option.id}>
                              {option.name}
                            </Select.Option>
                          ))}
                      </Select>
                    </td>
                  </tr>
                </thead>
              </RTable>
              {/* 2025-05-27 一括編集にて材料費￥０に編集したい。できないか？の対応 */}
              {/* <Checkbox
                checked={props?.isZeroMaterialCost}
                onChange={(e) => props?.setIsZeroMaterialCost(e.target.checked)}
              >
                材料費を0にする
              </Checkbox> */}
            </div>
            {/* 工程選択 */}
            <div
              style={{
                display: activeBulkEditTabKey == '2' ? 'block' : 'none',
                marginTop: 10,
                height: 710,
                overflowY: 'auto',
              }}
              className="iq3-tab-div"
            >
              <ProcessPatternForm
                ref={patternformRef}
                selectedData={processSelectedData}
                listData={listData}
                editMode={true}
                page={patternPage[1]}
                isParameter={false}
                updateKouteiSentakuInfo={updateKouteiSentakuInfo}
                kouteiSentakuEditMode={true}
                pmxMode={true}
                processMasterData={estimateParameters?.process}
                deviceMasterData={estimateParameters?.device}
                clientMasterData={estimateParameters?.client}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row
        justify="end"
        style={{
          marginBottom: 0,
          marginTop: -40,
        }}
      >
        <Button className="mainButton" onClick={updateData} style={{ marginRight: 5 }}>
          OK
        </Button>
        <Button className="cancelButton" onClick={discardData}>
          {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
              編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
              破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
          {/* 破棄 */}
          戻る
        </Button>
      </Row>
    </>
  );

  // Waitingダイアログを表示・非表示に更新する
  const updateLoading = (load) => {
    setParentLoading(load);
  };

  const updateIsPrepareInfoFlg = (flg) => {
    setIsPrepareInfo(flg);
  };

  const tabItems = [
    {
      key: '1',
      label: (
        <Button
          key="parent-tab"
          type="primary"
          className={activePartMenu == '1' ? 'estimate-tab-btn-active first-btn' : 'estimate-tab-btn first-btn'}
        >
          親部品
        </Button>
      ),
    },
    {
      key: '2',
      label: (
        <Button
          key="iq3-tab"
          type="primary"
          className={activePartMenu == '2' ? 'estimate-tab-btn-active middle-btn' : 'estimate-tab-btn middle-btn'}
        >
          iQ3板金
        </Button>
      ),
    },
    {
      key: '3',
      label: (
        <Button
          key="iq5-tab"
          type="primary"
          className={activePartMenu == '3' ? 'estimate-tab-btn-active last-btn' : 'estimate-tab-btn last-btn'}
        >
          iQ5形鋼
        </Button>
      ),
    },
  ];

  // 2025-05-21 親部品をデータとして保存することはできません
  // PC保存
  const savePCLocal = async (e) => {
    setUploadLoading(true);

    try {
      let currentEstimateData = parentEstimateRef?.current?.getParentEstimateInfo();
      const downloadFileName = currentEstimateData?.estimateProducts?.drawingNo;
      const data = JSON.stringify(currentEstimateData);
      const zip = new JSZip();
      zip.file('data.json', JSON.stringify(data, null, 2));

      const content = await zip.generateAsync({ type: 'blob' });

      // ダウンロード用URLを作成
      const url = URL.createObjectURL(content);

      // ダウンロード用リンクを作成してクリック
      const a = document.createElement('a');
      a.href = url;
      a.download = downloadFileName + '.iq3';
      a.click();

      // 使用後はURLを解放
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    } finally {
      setUploadLoading(false);
    }
  };

  // 2025-05-21 親部品をデータとして保存することはできません
  const downloadedFileUpload = () => {
    upload3DFileRef.current?.click();
  };

  // 2025-05-21 親部品をデータとして保存することはできません
  // PC に保存された `.iq3` ファイルのローカルアップロードを処理する
  const uploadPCLocal = async (event) => {
    // ファイル入力から選択されたファイルを取得する
    const file = event.target.files[0];
    if (!file) return; // ファイルが選択されていない場合は終了する

    setUploadLoading(true);

    try {
      // JSZipの新しいインスタンスを作成する
      const zip = new JSZip();
      // ファイルを非同期的に読み込んで解凍する
      const zipContent = await zip.loadAsync(file);

      // zipアーカイブ内のdata.jsonファイルを探す
      const jsonFile = zipContent.file('data.json');
      if (!jsonFile) {
        return; // data.json が見つからない場合は終了します（ファイル構造が無効です）
      }

      // data.json の内容を読み取り解析する
      const string = await jsonFile.async('string');
      // 最初の解析: 二重エンコードされたJSONをエスケープ解除する
      const jsonString = JSON.parse(string);
      // 2回目の解析: 実際のオブジェクト構造を取得する
      const parsedData = JSON.parse(jsonString);

      // 参照を使用して親の見積情報を更新します
      parentEstimateRef.current?.setParentEstimateInfo(parsedData);
    } catch (err) {
      // アップロードまたは解析中に発生したエラーをログに記録します
      console.error(err);
    } finally {
      setUploadLoading(false);
    }
  };

  return (
    <Spin spinning={uploadLoading} tip="Loading...">
      <>
        {location.pathname === '/home/:estimate.parent' ||
        location.pathname === '/home/:estimate.iq3' ||
        location.pathname === '/home/:estimate.iq5' ? (
          <div style={{ overflow: 'hidden' }}>
            <Form className="components-table-demo-control-bar">
              {/** 共通操作 */}
              <div
                style={{
                  borderBottom: 'solid',
                  borderBottomWidth: '1px',
                  borderBottomColor: '#212529',
                  backgroundColor: '#fafafc',
                }}
              >
                <Row style={{ marginLeft: '10px' }}>
                  <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', width: '60%' }}>
                    <Row style={{ marginTop: '1px', marginLeft: '0' }}>
                      <Col span={9}>
                        <Space size="middle" style={{ columnGap: 35 }}>
                          {/** IQX_WEBEST-172 */}
                          {/* 2025-08-05 IQX_WEBEST-456 表記変更の依頼 */}
                          <Tooltip title="新規作成" placement="top" overlayClassName="tooltip-text">
                            <a onClick={createNewParentInfo}>
                              <Image preview={false} width={30} src={new_icon} style={{ marginLeft: '10px' }}></Image>
                            </a>
                          </Tooltip>
                          <Tooltip title="CURT.パラ" placement="top" overlayClassName="tooltip-text">
                            <a onClick={currentParamInfo}>
                              <Image preview={false} width={35} src={curt} style={{ marginLeft: '5px' }}></Image>
                            </a>
                          </Tooltip>
                          {/* <Tooltip title="一括編集" placement="bottom" overlayClassName="tooltip-text">
                          <a onClick={updateAll}>
                            <Image preview={false} width={28} src={edit_list} style={{ marginLeft: '5px' }}></Image>
                          </a>
                        </Tooltip> */}
                          <Tooltip title="子部品追加呼出" placement="top" overlayClassName="tooltip-text">
                            <a onClick={displayAddParentInfo}>
                              <Image
                                preview={false}
                                width={30}
                                src={parent_call_detail}
                                style={{ marginLeft: '5px' }}
                              ></Image>
                            </a>
                          </Tooltip>

                          {/* <Tooltip title="再計算" placement="top" overlayClassName="tooltip-text">
                      <a onClick={calEstimateDataEvent}>
                        <Image
                          preview={false}
                          width={iconWidth}
                          src={calculator}
                          style={{ marginLeft: '5px', marginTop: '2px' }}
                        ></Image>
                      </a>
                    </Tooltip> */}

                          {/*ファーストリリースで不要*/}
                          {/* <Tooltip title="PC保存・PC呼出" placement="top" overlayClassName="tooltip-text">
                      <Menu
                        onClick={reportOutputChangeEvent}
                        mode="horizontal"
                        items={pcSaveMenuitems}
                        style={{
                          marginLeft: '-19px',
                          marginTop: '-24px',
                          height: 0,
                          color: 'white',
                        }}
                      />
                      <input
                        type="file"
                        id="file"
                        ref={inputFile_pcOutput}
                        style={{ display: 'none' }}
                        accept=".*"
                        onChange={(e) => openDialogOK(e)}
                        onClick={(e) => (e.target.value = null)}
                      />
                      <input
                        type="file"
                        id="file"
                        ref={inputFile_pcInput}
                        style={{ display: 'none' }}
                        accept=".*"
                        onChange={(e) => openDialogOK(e)}
                        onClick={(e) => (e.target.value = null)}
                      />
                    </Tooltip> */}

                          <Tooltip title="PMX取込" placement="top" overlayClassName="tooltip-text">
                            {/* <Menu
                                onClick={pmxMenuChangeEvent}
                                mode="horizontal"
                                items={pmxMenuItems}
                                style={{
                                  marginLeft: '-10px',
                                  height: 0,
                                  color: 'white',
                                  alignItems: 'flex-end',
                                }}
                              /> */}
                            <a onClick={pmxMenuChangeEvent}>
                              <Image
                                preview={false}
                                width={28}
                                src={pmx_import}
                                style={{ marginLeft: '5px', marginTop: '0px' }}
                              ></Image>
                            </a>
                            <input
                              type="file"
                              id="file"
                              ref={inputFile}
                              style={{ display: 'none' }}
                              accept=".PMX"
                              onChange={(e) => openPMXProcessPatternDialog(e)}
                              onClick={(e) => (e.target.value = null)}
                            />
                          </Tooltip>
                          {/* {activePartMenu !== '3' ? ( */}
                          <Tooltip title="DXF取込" placement="top" overlayClassName="tooltip-text">
                            <a onClick={dxfMenuChangeEvent}>
                              <Image
                                preview={false}
                                width={32}
                                src={dxf_import}
                                style={{ marginLeft: '5px', marginTop: '0px' }}
                              ></Image>
                            </a>
                            {/* <input
                                type="file"
                                id="file"
                                ref={inputFile}
                                style={{ display: 'none' }}
                                accept=".PMX"
                                onChange={(e) => openPMXProcessPatternDialog(e)}
                                onClick={(e) => (e.target.value = null)}
                              /> */}
                          </Tooltip>
                          {/* ) : (
                            ''
                          )} */}
                          <Tooltip title="帳票" placement="top" overlayClassName="tooltip-text">
                            <a onClick={reportOutputChangeEvent}>
                              <Image
                                preview={false}
                                width={iconWidth}
                                src={export_report}
                                style={{ marginLeft: '5px', marginTop: '0px' }}
                              ></Image>
                            </a>
                          </Tooltip>

                          <Tooltip title="PCに親部品情報を保存します" placement="top" overlayClassName="tooltip-text">
                            <a onClick={savePCLocal}>
                              <Image
                                preview={false}
                                width={iconWidth}
                                src={download_to_pc}
                                style={{
                                  marginLeft: '5px',
                                  marginTop: '0px',
                                  filter: 'invert(25%) sepia(100%) saturate(1000%) hue-rotate(200deg)',
                                }}
                              ></Image>
                            </a>
                          </Tooltip>
                          <Tooltip
                            title="PCに保存した親部品情報を読み込みます"
                            placement="top"
                            overlayClassName="tooltip-text"
                          >
                            <a onClick={downloadedFileUpload}>
                              <Image
                                preview={false}
                                width={iconWidth}
                                src={upload_from_pc}
                                style={{
                                  marginLeft: '5px',
                                  marginTop: '2px',
                                  filter: 'invert(25%) sepia(100%) saturate(1000%) hue-rotate(200deg)',
                                  cursor: 'pointer',
                                }}
                              />
                            </a>
                          </Tooltip>

                          <input
                            type="file"
                            accept=".iq3"
                            ref={upload3DFileRef}
                            onChange={uploadPCLocal}
                            onClick={(e) => (e.target.value = null)}
                            style={{ display: 'none' }}
                          />

                          {/* <Tooltip title="帳票" placement="top" overlayClassName="tooltip-text">
                      <Menu
                        onClick={reportOutputChangeEvent}
                        mode="horizontal"
                        items={reportOutputMenuitems}
                        style={{
                          marginLeft: '-15px',
                          marginTop: '-24px',
                          height: 0,
                          color: 'white',
                        }}
                      />
                    </Tooltip> */}
                          {/*ファーストリリースで不要*/}
                          {/* <Tooltip title="CSV出力" placement="top" overlayClassName="tooltip-text">
                      <Menu
                        onClick={reportOutputChangeEvent}
                        mode="horizontal"
                        items={listOutputMenuitems}
                        style={{
                          marginLeft: '-19px',
                          marginTop: '-24px',
                          height: 0,
                          color: 'white',
                          textDecoration: 'none',
                        }}
                      />
                    </Tooltip>
                    <Tooltip title="備考価格" placement="top" overlayClassName="tooltip-text">
                      <a onClick={commonTaiochuPopupOpen}>
                        <Image
                          preview={false}
                          width={iconWidth}
                          src={reference_price}
                          style={{ marginLeft: '30px', marginTop: '0px' }}
                        ></Image>
                      </a>
                    </Tooltip> */}
                        </Space>
                      </Col>
                    </Row>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', width: '39%' }}>
                    <Row align="middle">
                      {/* <Col span={8}> */}
                      <Space size="middle">
                        {selectedEstimateData?.estimateProducts?.id === 0 ||
                        selectedEstimateData?.estimateProducts === undefined ? (
                          <>
                            <Tooltip title="保存" placement="top" overlayClassName="tooltip-text">
                              <a onClick={estimateNewDataSaveEvent}>
                                <Image preview={false} width={33} src={save} style={{ marginRight: '5px' }}></Image>
                              </a>
                            </Tooltip>
                          </>
                        ) : (
                          <>
                            <Tooltip title="保存" placement="topLeft" overlayClassName="tooltip-text">
                              <Menu
                                onClick={(e) => estimateDataSaveEvent(e, 'update')}
                                mode="horizontal"
                                items={saveMenuItems}
                                style={{
                                  marginLeft: '-17px',
                                  marginRight: '5px',
                                  height: 0,
                                  color: 'white',
                                  alignItems: 'flex-end',
                                }}
                              />
                            </Tooltip>
                          </>
                        )}
                        {/* </Col> */}
                        {/* <Col span={7}> */}
                        {selectedEstimateData?.estimateProducts?.id !== 0 ? (
                          <Input
                            className="editInfoTle"
                            value={'編集'}
                            type="text"
                            prefix={
                              <Image
                                preview={false}
                                width={13}
                                src={edit_info}
                                style={{
                                  transform: 'rotate(270deg)',
                                  marginRight: '5px',
                                }}
                              />
                            }
                          />
                        ) : (
                          <Input className="editInfoTle" value={'新規'} type="text" />
                        )}
                        {/* 2025-05-14 パラメータの編集を押下した際、「更新」と「破棄」のボタンがあるが、
                        編集をやめて戻りたいときに破棄の表示だと登録されている情報を破棄するように感じてしまうため、
                        破棄の表記ではなく「戻る」や「終了」にするのはどうか */}
                        {/* 破棄 */}
                        <Tooltip title="戻る" placement="top" overlayClassName="tooltip-text">
                          <a onClick={estimateDataDiscardEvent}>
                            <Image preview={false} width={22} src={close}></Image>
                          </a>
                        </Tooltip>
                      </Space>
                    </Row>
                  </div>
                </Row>
              </div>
              {/** 見積データ */}
              {/* <div style={{ height: '90.8vh' }}></div>  2025.09.24 Trieund 編集*/}
              <div style={{ height: '100%' }}>
                <Row>
                  <Col span={5}>
                    {/* 見積基本情報 */}
                    <EstimateBasicInfo
                      estimateBasicInfo={props.selectedEstimateData}
                      ref={estimateBasicInfoRef}
                      getCurrentIQ3={getCurrentIQ3}
                      settingParametersByReCal={props.settingParametersByReCal}
                      activePartMenu={activePartMenu}
                      loading={props?.loading} // Waitingダイアログ
                      basicInfoUpdate={basicInfoUpdate}
                      updateIsRecalMaterial={props.updateIsRecalMaterial}
                      isReCal={props.isReCal}
                      parentActiveTabKey={props?.parentActiveTabKey}
                      parentInfoChangeFlg={parentInfoChangeFlg}
                      updateParentInfoChange={updateParentInfoChange}
                      // 2025-05-15 数量や粗利係数などを直接左側の画面から変更できない。
                      updateParentQuantityChange={updateParentQuantityChange}
                      onChangeEstimateProduct={props.onChangeEstimateProduct}
                      updateEstimateBasicInfoChangedFlg={updateEstimateBasicInfoChangedFlg}
                      estimateBasicInfoChangedFlg={estimateBasicInfoChangedFlg}
                    />
                  </Col>
                  <Col span={19}>
                    {/** 親部品・板金子部品・形鋼子部品 */}
                    <div style={{ height: '90.8vh' }}>
                      <div className="estimate-tab">
                        <Tabs
                          className="estimate-tab"
                          type="card"
                          defaultActiveKey="1"
                          activeKey={activePartMenu}
                          items={tabItems}
                          onChange={partMenuChange}
                        />
                      </div>
                      <div style={{ display: activePartMenu == '1' ? 'block' : 'none', marginTop: 0 }}>
                        <ParentEstimate
                          editMode={editMode}
                          ref={parentEstimateRef}
                          // selectedEstimateData={isPMXComplete ? selectedPMXEstimateData : props.selectedEstimateData}
                          selectedEstimateData={props.selectedEstimateData}
                          // selectedTestEstimateData={isPMXComplete ? selectedPMXEstimateData : props.selectedEstimateData}
                          updateMainEstimateEditMode={updateMainEstimateEditMode}
                          activePartMenu={activePartMenu}
                          updateEstimateInfo={updateEstimateInfo}
                          isReCal={props.isReCal}
                          updateEstimateInfoByReCal={updateEstimateInfoByReCal}
                          newMode={props.newMode}
                          getParentQuantity={getParentQuantity}
                          loading={props?.loading} // Waitingダイアログ
                          clickMenu={clickMenu} // 親部品.板金tab切り替え
                          updateClickMenu={updateClickMenu}
                          isPMXEvent={isPMXEvent}
                          parentActiveTabKey={props?.parentActiveTabKey}
                          updateParentActiveTabKey={props?.updateParentActiveTabKey}
                          isEstimateOpen={props?.isEstimateOpen} // IQX_WEBEST-305 過去データを開いた直後、再計算をしない限りはタブ切替しても計算しないでほしい。
                          updateCreateNewEvent={props?.updateCreateNewEvent}
                          createNewEvent={props?.createNewEvent}
                          updateParentInfoChange={updateParentInfoChange}
                          selectedEstimateDataBeforeParentTab={props?.selectedEstimateDataBeforeParentTab}
                          parentInfoChangeFlg={parentInfoChangeFlg}
                          updateParentQuantityChange={updateParentQuantityChange}
                          // 2025-05-15 数量や粗利係数などを直接左側の画面から変更できない。
                          updateEstimateBasicInfoChangedFlg={updateEstimateBasicInfoChangedFlg}
                          setSelectedEstimateData={props.setSelectedEstimateData}
                          hyoumenProcess={props?.hyoumenProcess}
                        />
                      </div>
                      <div style={{ display: activePartMenu == '2' ? 'block' : 'none', marginTop: 0 }}>
                        <IQ3Estimate
                          type={checkPMXOrNot}
                          editMode={editMode}
                          ref={iQ3EstimateRef}
                          updateEstimateInfo={updateEstimateInfo}
                          // iq3Data={selectediq3Data}
                          // selectedEstimateData={isPMXComplete ? selectedPMXEstimateData : props.selectedEstimateData}
                          selectedEstimateData={props.selectedEstimateData}
                          updateMainEstimateEditMode={updateMainEstimateEditMode}
                          // targetRowKey={props.iq3TargetRowKey == undefined ? 0 : props.iq3TargetRowKey}
                          activePartMenu={activePartMenu}
                          userSettingInfo={props.userSettingInfo}
                          // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
                          companySettingInfo={props?.companySettingInfo}
                          getParentQuantity={getParentQuantity}
                          updatedSelectedEstimateDataTemp={updatedSelectedEstimateDataTemp}
                          loading={props?.loading} // Waitingダイアログ
                          clickMenu={clickMenu}
                          isReCal={props.isReCal}
                          updateIsRecal={props.updateIsRecal}
                          isReCalMaterial={props?.isReCalMaterial}
                          updateIsRecalMaterial={props.updateIsRecalMaterial}
                          isPMXEvent={isPMXEvent}
                          updatePMXEvent={updatePMXEvent}
                          updateCheckPMXOrNot={updateCheckPMXOrNot}
                          iq3ActiveTabKey={props?.iq3ActiveTabKey}
                          updateIq3ActiveTabKey={props?.updateIq3ActiveTabKey}
                          isEstimateOpen={props?.isEstimateOpen} // IQX_WEBEST-305 過去データを開いた直後、再計算をしない限りはタブ切替しても計算しないでほしい。
                          parentQuantityChangeFlg={parentQuantityChangeFlg}
                          updateParentQuantityChange={updateParentQuantityChange}
                          updateAll={updateAll}
                          hubConnectionToken={props?.hubConnectionToken}
                          pmxRead={pmxRead}
                          setPmxRead={setPmxRead} // 2025-09-19 IQX_WEBEST-470 表面処理費が表示されないバグ
                          setFileUploadLoading={props?.setFileUploadLoading} // 2025-09-30 IQX_WEBEST-466 DXF読み込み機能追加
                          settingInfo={settingInfo}
                          hyoumenProcess={props?.hyoumenProcess}
                          loginUserInfo={props?.loginUserInfo}
                        />
                      </div>
                      <div style={{ display: activePartMenu == '3' ? 'block' : 'none', marginTop: 0 }}>
                        <IQ5Estimate
                          type={checkPMXOrNot}
                          editMode={editMode}
                          ref={iQ5EstimateRef}
                          updateEstimateInfo={updateEstimateInfo}
                          // iq3Data={selectediq3Data}
                          // selectedEstimateData={isPMXComplete ? selectedPMXEstimateData : props.selectedEstimateData}
                          selectedEstimateData={props.selectedEstimateData}
                          updateMainEstimateEditMode={updateMainEstimateEditMode}
                          // targetRowKey={props.iq3TargetRowKey == undefined ? 0 : props.iq3TargetRowKey}
                          activePartMenu={activePartMenu}
                          userSettingInfo={props.userSettingInfo}
                          // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
                          companySettingInfo={props.companySettingInfo}
                          getParentQuantity={getParentQuantity}
                          updatedSelectedEstimateDataTemp={updatedSelectedEstimateDataTemp}
                          loading={props?.loading} // Waitingダイアログ
                          clickMenu={clickMenu}
                          isReCal={props.isReCal}
                          updateIsRecal={props.updateIsRecal}
                          isReCalMaterial={props?.isReCalMaterial}
                          updateIsRecalMaterial={props.updateIsRecalMaterial}
                          isPMXEvent={isPMXEvent}
                          updatePMXEvent={updatePMXEvent}
                          updateCheckPMXOrNot={updateCheckPMXOrNot}
                          iq3ActiveTabKey={props?.iq3ActiveTabKey}
                          updateIq3ActiveTabKey={props?.updateIq3ActiveTabKey}
                          isEstimateOpen={props?.isEstimateOpen} // IQX_WEBEST-305 過去データを開いた直後、再計算をしない限りはタブ切替しても計算しないでほしい。
                          parentQuantityChangeFlg={parentQuantityChangeFlg}
                          updateParentQuantityChange={updateParentQuantityChange}
                          updateAll={updateAll}
                          updateSteelList={updateSteelList}
                          hyoumenProcess={props?.hyoumenProcess}
                          loginUserInfo={props?.loginUserInfo}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Form>

            {/* DXF用工程選択画面　*/}
            <Modal
              maskClosable={false}
              title={dxfModalTitle}
              open={isDXFProcessPatternOpen}
              onOk={updateOk}
              centered={true}
              onCancel={dxfCancel}
              width={1490}
              className="updateModalStyle"
              modalRender={(modal) => (
                <Draggable handle=".ant-modal-header">
                  <div>{modal}</div>
                </Draggable>
              )}
              bodyStyle={{ marginTop: '0px' }}
              // style={{ marginTop: '-15px' }}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              footer={[
                <Button
                  key="back"
                  onClick={backDXFProcessPattern}
                  className={isDXFFileUpload ? 'disabledButton' : 'cancelButton'}
                >
                  {'< 戻る(B)'}
                </Button>,
                <Button
                  key="next"
                  onClick={nextDXFProcessPattern}
                  className={isDXFNextIQ3 ? 'disabledButton' : 'cancelButton'}
                >
                  {'次へ(N) >'}
                </Button>,
                <Button key="ok" onClick={completePMX} className={isDXFNextIQ3 ? 'mainButton' : 'disabledButton'}>
                  {'完了(F)'}
                </Button>,
                <Button key="cancel" onClick={dxfCancel} className="cancelButton">
                  {'キャンセル'}
                </Button>,
              ]}
            >
              <Spin spinning={dxfCalculateLoading} tip="" size="large">
                <Steps
                  type="navigation"
                  size="small"
                  className="site-navigation-steps"
                  current={currentDXFStep}
                  items={[
                    {
                      title: 'DXFファイル一覧',
                    },
                    {
                      title: '親部品工程選択',
                    },
                    {
                      title: '板金工程選択',
                    },
                    {
                      title: '',
                    },
                  ]}
                />
                {!isDXFFileUpload && (
                  <Row style={{ marginBottom: '20px' }}>
                    <Col span={14}>
                      <Row style={{ marginTop: 0 }}>
                        <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>
                          【指定した編集中の見積データに対しての動作】
                        </p>
                      </Row>
                      <Row style={{ marginTop: '10px' }}>
                        <Col span={24}>
                          <ul class="pmxType">
                            <li>{pmxProcessType}</li>
                          </ul>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={10}>
                      <Row style={{ height: 42, width: '98%' }}>
                        <Col span={8} className="parent-pdetail-tbl-val-title" style={{ padding: 5 }}>
                          親部品工程パターン
                        </Col>
                        <Col
                          span={16}
                          style={{
                            verticalAlign: 'middle',
                            padding: 5,
                            borderTop: '1px solid rgb(181, 178, 174)',
                            borderRight: '1px solid rgb(181, 178, 174)',
                          }}
                        >
                          <Select
                            style={{
                              width: '90%',
                              marginLeft: 20,
                              pointerEvents: isCreatePMX === CreatePMXData.Update ? 'none' : 'auto',
                            }}
                            id="pattern"
                            name="pattern"
                            // value={parentPatternNo}
                            value={dxfParentPatternNo != 0 ? dxfParentPatternNo : Empty}
                            onChange={(e) => onChangeProcessPatternInfo(0, e)}
                            className={'input-editable'}
                            options={patternList?.map((item) => ({
                              key: item.id,
                              value: item.id,
                              label: item.name === '' ? Empty : item.name,
                            }))}
                          />
                        </Col>
                      </Row>
                      <Row style={{ height: 42, width: '98%', borderTop: '1px solid rgb(181, 178, 174)' }}>
                        <Col span={8} className="parent-pdetail-tbl-val-title" style={{ padding: 5 }}>
                          板金工程パターン
                        </Col>
                        <Col
                          span={16}
                          style={{
                            verticalAlign: 'middle',
                            padding: 5,
                            borderBottom: '1px solid rgb(181, 178, 174)',
                            borderRight: '1px solid rgb(181, 178, 174)',
                          }}
                        >
                          <Select
                            style={{ width: '90%', marginLeft: 20 }}
                            id="childPatternNo"
                            name="childPatternNo"
                            // value={childPatternNo}
                            value={dxfChildPatternNo != 0 ? dxfChildPatternNo : Empty}
                            onChange={(e) => onChangeProcessPatternInfo(1, e)}
                            className={'input-editable'}
                            options={iq3PatternList?.map((item) => ({
                              key: item.id,
                              value: item.id,
                              label: item.name === '' ? Empty : item.name,
                            }))}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                )}

                <div
                  className="kouteical timecharge"
                  style={{ height: '60vh', display: isDXFFileUpload ? '' : 'none' }}
                >
                  {isDXFFileUpload ? (
                    <Spin spinning={isDXFPrepareInfo} tip="" size="large">
                      <div
                        style={{
                          padding: 10,
                          background: '#fff',
                          position: 'sticky',
                          top: 0,
                          zIndex: 10,
                        }}
                      >
                        <Upload beforeUpload={handleBeforeUpload} showUploadList={false} accept=".dxf" multiple>
                          <Button type="primary" icon={<UploadOutlined style={{ fontSize: '14px' }} />}>
                            DXFアップロード
                          </Button>
                        </Upload>
                      </div>

                      <div className="responsive-table" style={{ overflow: 'auto', height: 'calc(60vh - 60px)' }}>
                        <Table
                          scroll={{ x: '10vw', y: 'auto' }}
                          columns={dxfTypecolumns}
                          rowKey={(record) => record?.id}
                          dataSource={dxfUpDataLst}
                          className="upload-file-tb"
                          pagination={false}
                        />
                      </div>
                    </Spin>
                  ) : (
                    ''
                  )}
                </div>

                <div
                  className="overflow-auto kouteical timecharge"
                  style={{
                    height: '60vh',
                    overflow: 'hidden',
                    display: isDXFNext === true && currentDXFStep === 1 ? '' : 'none',
                  }}
                >
                  {isDXFNext === true && currentDXFStep === 1 ? (
                    <Spin spinning={isDXFPrepareInfo} tip="" size="large">
                      <ParentKouteiSentaku
                        type={'pmx'}
                        isNewPMXOrNot={isCreatePMX}
                        editMode={true}
                        patternNo={dxfParentPatternNo}
                        updateSelectedParentPatternNo={updateSelectedDXFParentPatternNo}
                        // selectedDataDetail={selectedEstimateData}
                        selectedDataDetail={selectedPMXEstimateData}
                        pmxMode={true}
                        ref={parentKouteiSentakuRef}
                        updatePatternList={updatePatternList}
                        updateIsPrepareInfoFlg={updateIsPrepareInfoFlg}
                        patternInsertClass={ParentClassNumber} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                        setPatternList={setPatternList} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                      />
                    </Spin>
                  ) : (
                    ''
                  )}
                </div>

                <div
                  className="overflow-auto kouteical timecharge"
                  style={{
                    height: '60vh',
                    overflow: 'hidden',
                    display: isDXFNextIQ3 === true && currentDXFStep === 2 ? '' : 'none',
                  }}
                >
                  {isDXFNextIQ3 === true && currentDXFStep === 2 ? (
                    <Spin spinning={isDXFPrepareInfo} tip="" size="large">
                      <IQ3KouteiSentaku
                        type={'pmx'}
                        patternNo={dxfChildPatternNo}
                        updateSelectedPatternNo={updateSelectedDXFPatternNo}
                        editMode={true}
                        selectedDataDetail={selectedPMXEstimateData}
                        // selectedCardData={selectedCardData}
                        selectedIQ3DataDetail={
                          selectediq3Data != undefined && selectediq3Data?.length > 0 ? selectediq3Data[0] : []
                        }
                        pmxMode={true}
                        iQ3DataLst={selectediq3Data}
                        ref={iQ3KouteiSentakuRef}
                        updatePatternList={updatePatternList}
                        // updatedSelectedData={updatedSelectedData}
                        updateIsPrepareInfoFlg={updateIsPrepareInfoFlg}
                        patternInsertClass={IQ3ClassNumber} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                        setIQ3PatternList={setIQ3PatternList} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                      />
                    </Spin>
                  ) : (
                    ''
                  )}
                </div>
              </Spin>
            </Modal>

            {/* PMX用工程選択画面　*/}
            <Modal
              maskClosable={false}
              title={childModalTitle}
              open={isPMXProcessPatternOpen}
              onOk={updateOk}
              centered={true}
              onCancel={updateCancel}
              width={1490}
              className="updateModalStyle"
              bodyStyle={{ marginTop: '0px' }}
              // style={{ marginTop: '-15px' }}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              footer={[
                <Button
                  key="back"
                  onClick={backProcessPattern}
                  className={
                    isCreatePMX === CreatePMXData.Update || currentStep === 0 ? 'disabledButton' : 'cancelButton'
                  }
                  // style={{ pointerEvents: isCreatePMX === CreatePMXData.Update ? 'none' : 'auto' }}
                >
                  {'< 戻る(B)'}
                </Button>,
                <Button
                  key="next"
                  onClick={nextProcessPattern}
                  className={
                    isCreatePMX === CreatePMXData.Update || currentStep === 2 ? 'disabledButton' : 'cancelButton'
                  }
                >
                  {'次へ(N) >'}
                </Button>,
                <Button key="ok" onClick={completePMX} className={'mainButton'}>
                  {'完了(F)'}
                </Button>,
                <Button key="cancel" onClick={cancelPMXImport} className="cancelButton">
                  {'キャンセル'}
                </Button>,
              ]}
            >
              <Spin spinning={isProcessSelectInfo} tip="" size="large">
                <Steps
                  type="navigation"
                  size="small"
                  className="site-navigation-steps"
                  current={currentStep}
                  items={[
                    {
                      title: '親部品工程選択',
                    },
                    {
                      title: '板金工程選択',
                    },
                    {
                      title: '形鋼工程選択',
                    },
                    {
                      title: '読込',
                    },
                    {
                      title: '',
                    },
                  ]}
                />
                <Row style={{ marginBottom: '20px' }}>
                  <Col span={14}>
                    <Row style={{ marginTop: 0 }}>
                      <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>
                        【指定した編集中の見積データに対しての動作】
                      </p>
                    </Row>
                    <Row style={{ marginTop: '10px' }}>
                      <Col span={24}>
                        <ul class="pmxType">
                          <li>{pmxProcessType}</li>
                        </ul>
                        {/* <Radio.Group value={pmxProcessType}>
                  <Space direction="vertical">
                    <Radio value={0}>編集中の見積を保存して新規見積を作成する</Radio>
                    <Radio value={1}>新規見積を作成する</Radio>
                    <Radio value={2}>編集中の見積に追加する</Radio>
                  </Space>
                </Radio.Group> */}
                      </Col>
                    </Row>
                  </Col>
                  <Col span={10}>
                    <Row style={{ height: 42, width: '98%' }}>
                      <Col span={8} className="parent-pdetail-tbl-val-title" style={{ padding: 5 }}>
                        親部品工程パターン
                      </Col>
                      <Col
                        span={16}
                        style={{
                          verticalAlign: 'middle',
                          padding: 5,
                          borderTop: '1px solid rgb(181, 178, 174)',
                          borderRight: '1px solid rgb(181, 178, 174)',
                        }}
                      >
                        <Select
                          style={{
                            width: '90%',
                            marginLeft: 20,
                            pointerEvents: isCreatePMX === CreatePMXData.Update ? 'none' : 'auto',
                          }}
                          id="pattern"
                          name="pattern"
                          // value={parentPatternNo}
                          value={parentPatternNo != 0 ? parentPatternNo : Empty}
                          onChange={(e) => onChangeProcessPatternInfo(0, e)}
                          className={'input-editable'}
                          options={patternList?.map((item) => ({
                            key: item.id,
                            value: item.id,
                            label: item.name === '' ? Empty : item.name,
                          }))}
                        />
                      </Col>
                    </Row>
                    <Row style={{ height: 42, width: '98%', borderTop: '1px solid rgb(181, 178, 174)' }}>
                      <Col span={8} className="parent-pdetail-tbl-val-title" style={{ padding: 5 }}>
                        板金工程パターン
                      </Col>
                      <Col
                        span={16}
                        style={{
                          verticalAlign: 'middle',
                          padding: 5,
                          borderBottom: '1px solid rgb(181, 178, 174)',
                          borderRight: '1px solid rgb(181, 178, 174)',
                        }}
                      >
                        <Select
                          style={{ width: '90%', marginLeft: 20 }}
                          id="childPatternNo"
                          name="childPatternNo"
                          // value={childPatternNo}
                          value={childPatternNo != 0 ? childPatternNo : Empty}
                          onChange={(e) => onChangeProcessPatternInfo(1, e)}
                          className={'input-editable'}
                          options={iq3PatternList?.map((item) => ({
                            key: item.id,
                            value: item.id,
                            label: item.name === '' ? Empty : item.name,
                          }))}
                        />
                      </Col>
                    </Row>
                    <Row style={{ height: 42, width: '98%', borderTop: '1px solid rgb(181, 178, 174)' }}>
                      <Col span={8} className="parent-pdetail-tbl-val-title" style={{ padding: 5 }}>
                        形鋼工程パターン
                      </Col>
                      <Col
                        span={16}
                        style={{
                          verticalAlign: 'middle',
                          padding: 5,
                          borderBottom: '1px solid rgb(181, 178, 174)',
                          borderRight: '1px solid rgb(181, 178, 174)',
                        }}
                      >
                        <Select
                          style={{ width: '90%', marginLeft: 20 }}
                          id="childIQ5PatternNo"
                          name="childIQ5PatternNo"
                          value={childIQ5PatternNo != 0 ? childIQ5PatternNo : Empty}
                          onChange={(e) => onChangeProcessPatternInfo(2, e)}
                          className={'input-editable'}
                          options={iq5PatternList?.map((item) => ({
                            key: item.id,
                            value: item.id,
                            label: item.name === '' ? Empty : item.name,
                          }))}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <div
                  className="overflow-auto kouteical timecharge"
                  style={{ height: '60vh', overflow: 'hidden', display: isNext == false ? '' : 'none' }}
                >
                  {isNext == false && currentStep === 0 && isProcessSelectInfo === false ? (
                    <Spin spinning={isPrepareInfo} tip="" size="large">
                      <ParentKouteiSentaku
                        type={'pmx'}
                        isNewPMXOrNot={isCreatePMX}
                        editMode={true}
                        patternNo={parentPatternNo}
                        updateSelectedParentPatternNo={updateSelectedParentPatternNo}
                        // selectedDataDetail={selectedEstimateData}
                        selectedDataDetail={selectedPMXEstimateData}
                        pmxMode={true}
                        ref={parentKouteiSentakuRef}
                        updatePatternList={updatePatternList}
                        updateIsPrepareInfoFlg={updateIsPrepareInfoFlg}
                        patternInsertClass={ParentClassNumber} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                        setPatternList={setPatternList} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                      />
                    </Spin>
                  ) : (
                    ''
                  )}
                </div>

                <div
                  className="overflow-auto kouteical timecharge"
                  style={{
                    height: '60vh',
                    overflow: 'hidden',
                    display: isNext == true && currentStep === 1 ? '' : 'none',
                  }}
                >
                  {isNext == true && currentStep === 1 && isProcessSelectInfo === false ? (
                    <Spin spinning={isPrepareInfo} tip="" size="large">
                      <IQ3KouteiSentaku
                        type={'pmx'}
                        patternNo={childPatternNo}
                        updateSelectedPatternNo={updateSelectedPatternNo}
                        editMode={true}
                        selectedDataDetail={selectedPMXEstimateData}
                        selectedCardData={selectedCardData}
                        // selectedEstimateData={selectedPMXEstimateData}
                        selectedIQ3DataDetail={
                          selectediq3Data != undefined && selectediq3Data?.length > 0 ? selectediq3Data[0] : []
                        }
                        pmxMode={true}
                        iQ3DataLst={selectediq3Data}
                        ref={iQ3KouteiSentakuRef}
                        updatePatternList={updatePatternList}
                        // updatedSelectedData={updatedSelectedData}
                        updateIsPrepareInfoFlg={updateIsPrepareInfoFlg}
                        patternInsertClass={IQ3ClassNumber} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                        setIQ3PatternList={setIQ3PatternList} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                      />
                    </Spin>
                  ) : (
                    ''
                  )}
                </div>

                <div
                  className="overflow-auto kouteical timecharge"
                  style={{
                    height: '60vh',
                    overflow: 'hidden',
                    display: isNext == true && currentStep === 2 ? '' : 'none',
                  }}
                >
                  {isNext == true && currentStep === 2 && isProcessSelectInfo === false ? (
                    <Spin spinning={isPrepareInfo} tip="" size="large">
                      <IQ5KouteiSentaku
                        type={'pmx'}
                        patternNo={childIQ5PatternNo}
                        updateSelectedPatternNo={updateSelectedIQ5PatternNo}
                        editMode={true}
                        selectedDataDetail={selectedPMXEstimateData}
                        selectedCardData={selectedCardData}
                        // selectedEstimateData={selectedPMXEstimateData}
                        selectedIQ5DataDetail={
                          selectediq5Data != undefined && selectediq5Data?.length > 0 ? selectediq5Data[0] : []
                        }
                        pmxMode={true}
                        iQ5DataLst={selectediq5Data}
                        ref={iQ5KouteiSentakuRef}
                        updatePatternList={updatePatternList}
                        // updatedSelectedData={updatedSelectedData}
                        updateIsPrepareInfoFlg={updateIsPrepareInfoFlg}
                        patternInsertClass={IQ5ClassNumber} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                        setIQ5PatternList={setIQ5PatternList} // 2025-09-25 IQX_WEBEST-463 パラメータの工程パターンにデータがない時、見積データの工程選択から装置が選べない。
                        setIsHyoumenSelect={setIsHyoumenSelect}
                        isHyoumenSelect={isHyoumenSelect}
                      />
                    </Spin>
                  ) : (
                    ''
                  )}
                </div>
              </Spin>
            </Modal>

            {/* PMX読込クラウド画面　*/}
            {/* <Modal
        maskClosable={false}
        title={childModalTitle}
        open={isPMXCloudFileDialogOpen}
        onOk={updateOk}
        onCancel={updateCancel}
        width={1490}
        className="pmxCloudFileModal"
        // bodyStyle={{ height: 750, marginTop: '0px' }}
        style={{ marginTop: '-15px' }}
        closeIcon={<CloseOutlined style={{ color: 'white' }} />}
        footer={[
          // <Button key="back" onClick={nextIQ3FileLoad} className="mainButton">
          //   {'続けて選択'}
          // </Button>,
          <Button key="next" type="primary" onClick={cloudPMXFileLoadOk} className="mainButton">
            {'OK'}
          </Button>,
          <Button key="cancel" onClick={cloudPMXFileLoadCancel} className="cancelButton">
            {'キャンセル'}
          </Button>,
        ]}
      >
         <Tabs
          className="pmx-cloud-file-tab"
          type="card"
          defaultActiveKey="1"
          activeKey={pmxTabKey}
          items={pmxTabItems}
          onChange={pmxTabChange}
        /> 
        <PMX_CloudFileDialog_Tab_Parent
          selectedParentRows={getSelectedParentRows}
          ref={pmxCloudParentRef}
          cardData={cardInfo}
        />
      </Modal> */}
            {isPMXCloudFileDialogOpen ? (
              <PMX_CloudFileDialog_Tab_Parent
                pmxModal={isPMXCloudFileDialogOpen}
                ref={pmxCloudParentRef}
                cardData={cardInfo}
                cardDataTotalCount={cardInfoCount}
                pmxProcessPattern={openPMXProcessPatternModal}
                loading={props?.loading}
                getNewEstimateInfo={getNewEstimateInfo} // 2025-05-23 ローカルPMXファイル読み込み
              />
            ) : (
              ''
            )}
            {/** 開発中ポップアップ */}
            {openCommonTaiochuPopup ? commonTaiochuModal(openCommonTaiochuPopup, closeCommonTaiochuPopup) : ''}
            {/** 画面切替警告メッセージ */}
            {confirmScreenChangeModalOpen
              ? commonModal(
                  confirmScreenChangeModalOpen,
                  confirmScreenChangeTitle,
                  commonFooter(discardConfirmOk, discardConfirmCancel),
                  null,
                  400,
                  discardConfirmOk,
                  discardConfirmCancel,
                  confirmScreenChangeContent,
                  null,
                  null,
                  false
                )
              : ''}
            {/* 帳票出力 */}
            {isReportOutputOpen
              ? commonModal(
                  isReportOutputOpen,
                  reportModalTitle,
                  null,
                  { height: 120 },
                  600,
                  reportOutputOk,
                  reportOutputCancel,
                  reportParentList,
                  'updateModalStyle',
                  { top: 50 },
                  false
                )
              : ''}
            {/* PC保存確認 */}
            {isEstimateDataSaveConfirm
              ? commonModal(
                  isEstimateDataSaveConfirm,
                  reportModalTitle,
                  null,
                  { height: 120 },
                  550,
                  reportOutputOk,
                  reportOutputCancel,
                  estimateDataSaveContent,
                  'updateModalStyle',
                  { top: 50 },
                  false
                )
              : ''}
            {/** 閲覧モードでもこのデータを保存していない場合は破棄さえてしまうため、メッセージ表示 */}
            {confirmDisplayDataSaveModalOpen
              ? commonModal(
                  confirmDisplayDataSaveModalOpen,
                  confirmScreenChangeTitle,
                  null,
                  null,
                  400,
                  discardConfirmOk,
                  discardConfirmCancel,
                  confirmDisplayDataSaveContent(discardConfirmOk, discardConfirmCancel),
                  null,
                  null,
                  false
                )
              : ''}
            {/* PMX取り込み確認 */}
            {isLoadPMXProcess
              ? commonModal(
                  isLoadPMXProcess,
                  pmxConfirmModalTitle,
                  null,
                  { height: 120 },
                  300,
                  null,
                  pmxLocalProcessCancel,
                  pmxConfirmContent,
                  'updateModalStyle',
                  { left: -300, top: 100 },
                  false
                )
              : ''}
            {/* 親部品リストダイアログ */}
            {parentListDisplay ? (
              <Modal
                maskClosable={false}
                open={parentListDisplay}
                title={parentListModalTitle}
                footer={null}
                bodyStyle={{ height: '71.7vh', marginTop: -5, marginLeft: -23 }}
                width={1670}
                onOk={selectParentInfoOk}
                onCancel={selectParentInfoCancel}
                closeIcon={<CloseOutlined style={{ color: 'white' }} />}
                className={null}
                style={{ top: 110, left: 50 }}
                centered={false}
              >
                <Spin spinning={parentLoading} tip="Loading..." size="large">
                  <div style={{ borderBottom: '1px solid #6c757d', width: '101.2%' }}>
                    <ParentList
                      getSelectedEstimateData={getSelectedEstimateData}
                      editMode={false}
                      parentListClick={false}
                      isFromiQ3={true}
                      isFromParent={true}
                      orderOptions={newParameters?.estimateStatus}
                      companyInfo={newParameters?.company}
                      clientInfo={newParameters?.client}
                      userInfo={newParameters?.currentUserInfo}
                      staffInfo={newParameters?.staff}
                      processInfo={newParameters?.process}
                      parentLoading={updateLoading}
                      onSelectedRowsChange={(rows) => setSelectedRowsFromChild(rows)}
                    />
                  </div>
                  <Row
                    justify="end"
                    style={{
                      marginBottom: 0,
                      marginTop: 7,
                    }}
                  >
                    {/* 2025-09-16 IQX_WEBEST-418 複数子部品の呼び出しは行えないか？ */}
                    {/* <Button className="mainButton" onClick={selectParentInfoOk} style={{ marginRight: 5 }}>
                      追加
                    </Button> */}
                    <Button
                      className="mainButton"
                      onClick={() => selectParentInfoOk(selectedRowsFromChild)}
                      style={{ marginRight: 5 }}
                    >
                      追加
                    </Button>
                    <Button className="cancelButton" onClick={selectParentInfoCancel}>
                      閉じる
                    </Button>
                  </Row>
                </Spin>
              </Modal>
            ) : (
              ''
            )}

            {/* 別名保存_Modal */}
            {isSaveByOtherName
              ? commonModal(
                  isSaveByOtherName,
                  commonModalTitle,
                  commonFooter(saveByOtherNameOk, saveByOtherNameCancel),
                  null,
                  520,
                  saveByOtherNameOk,
                  saveByOtherNameCancel,
                  saveByOtherNameInfoContent,
                  null,
                  null,
                  false
                )
              : ''}

            {/* 上書き保存_Modal */}
            {isSaveByOverwrite
              ? commonModal(
                  isSaveByOverwrite,
                  confirmModalTitle,
                  commonFooter(saveByOverwriteOk, saveByOverwriteCancel),
                  null,
                  400,
                  saveByOverwriteOk,
                  saveByOverwriteCancel,
                  confirmOverwriteSaveContent,
                  null,
                  null,
                  null,
                  false
                )
              : ''}
            {createConfirm
              ? commonModal(
                  createConfirm,
                  confirmModalTitle,
                  commonFooter(createOk, createCancel),
                  null,
                  400,
                  createOk,
                  createCancel,
                  confirmSaveContent,
                  null,
                  null,
                  null,
                  false
                )
              : ''}

            {discardConfirm
              ? commonModal(
                  discardConfirm,
                  confirmModalTitle,
                  commonFooter(discardOk, discardCancel),
                  null,
                  400,
                  discardOk,
                  discardCancel,
                  confirmDiscardContent,
                  null,
                  null,
                  null,
                  false
                )
              : ''}
            {saveDiscardConfirmPopup
              ? commonModal(
                  saveDiscardConfirmPopup,
                  confirmScreenChangeWarning,
                  null,
                  null,
                  500,
                  discardConfirmOk,
                  closeOk,
                  saveDiscardConfirmContent,
                  null,
                  null,
                  false
                )
              : ''}

            {iq3DataConfirm
              ? commonModal(
                  iq3DataConfirm,
                  confirmModalTitle,
                  dataConfirmOK(modalCompletePMXData),
                  null,
                  400,
                  modalCompletePMXData,
                  null,
                  confirmContent,
                  null,
                  null,
                  null,
                  false
                )
              : ''}

            {/* 同一図番_Modal */}
            {isSaveSameDrawingNo
              ? commonModal(
                  isSaveSameDrawingNo,
                  sameDrawingNoModalTitle,
                  commonFooter(saveSameDrawingNoOk, saveSameDrawingNoCancel),
                  null,
                  400,
                  saveSameDrawingNoOk,
                  saveSameDrawingNoCancel,
                  sameDrawingNoContent(
                    getNameByValue(props?.companySettingInfo?.[0]?.environments?.saveSameType, saveSameTypes)
                  ),
                  null,
                  null,
                  false
                )
              : ''}

            {/* 更新確認 */}
            {updateConfirm
              ? commonModal(
                  updateConfirm,
                  confirmModalTitle,
                  commonFooter(confirmOk, confirmCancel),
                  null,
                  400,
                  confirmOk,
                  confirmCancel,
                  confirmUpdateContent,
                  null,
                  null,
                  false
                )
              : ''}

            {/* パラメータ更新_Modal */}
            {isCurtParam
              ? commonModal(
                  isCurtParam,
                  curtParamModalTitle,
                  commonActionFooter(curtParamOk, curtParamCancel, '更新', 'キャンセル'),
                  null,
                  520,
                  curtParamOk,
                  curtParamCancel,
                  curtParamInfoContent,
                  null,
                  null,
                  false
                )
              : ''}

            {/* 一括編集 */}
            {isUpdate
              ? commonModal(
                  isUpdate,
                  editModalTitle,
                  null,
                  null,
                  1790,
                  updateData,
                  discardData,
                  editAllContent,
                  'updateModalStyle',
                  null,
                  true
                )
              : ''}

            {isUpdateSteel
              ? commonModal(
                  isUpdateSteel,
                  steelEditModalTitle,
                  null,
                  null,
                  1790,
                  updateDataIq5,
                  discardData,
                  editSteelAllContent,
                  'updateModalStyle',
                  null,
                  true
                )
              : ''}

            {/* すべてチェックなしのメッセージ表示 */}
            {noCheckMsg
              ? commonModal(
                  noCheckMsg,
                  noCheckMsgModalTitle,
                  dataConfirmOK(curtParmNoCheckOk),
                  null,
                  370,
                  curtParmNoCheckOk,
                  curtParmNoCheckCancel,
                  noCheckMsgModalContent,
                  null,
                  null,
                  null,
                  false
                )
              : ''}
          </div>
        ) : (
          ''
        )}

        {/* 材料明細モデル */}
        {isSteelMaterialListModalVisible ? (
          <Modal
            maskClosable={false}
            open={isSteelMaterialListModalVisible ? true : false}
            title={detail_ProcessSelect_ModalTitle}
            footer={null}
            bodyStyle={{ height: '73vh', marginLeft: -17 }}
            width={1200}
            onOk={steelDetailDialogOk}
            onCancel={steelDetailDialogCancel}
            closeIcon={<CloseOutlined style={{ color: 'white' }} />}
            className={null}
            style={{ top: 85, left: 150 }}
            modalRender={(modal) => (
              <Draggable handle=".ant-modal-header">
                <div>{modal}</div>
              </Draggable>
            )}
          >
            <div className="iq3-tab-div" style={{ height: '70vh', overflow: 'hidden' }}>
              <SteelMaterialList
                fromEstimate={true}
                updateSteelSelect={updateSteelSelect}
                curSteelMaterialId={steelMaterialId}
                loading={props?.loading} // Waitingダイアログ
              />
            </div>
            <Row
              justify="end"
              style={{
                marginBottom: 0,
                marginTop: 5,
              }}
            >
              <Button className="mainButton" onClick={steelDetailDialogOk} style={{ marginRight: 5 }}>
                OK
              </Button>
              <Button className="cancelButton" onClick={steelDetailDialogCancel}>
                キャンセル
              </Button>
            </Row>
          </Modal>
        ) : (
          ''
        )}
      </>
    </Spin>
  );
});

export default MainEstimate;
